// Auto-generated – QS World Rankings 2026 + US News 2026 + Program Rankings
// 958 universities · 25 countries (deduplicated — 49 duplicate-id rows removed June 2026)
//
// rankings keys:
//   gradCS / gradEngineering / gradBusiness / gradLaw / gradMedicine / gradEducation  → US News 2026 grad
//   ugCS / ugEngineering / ugBusiness / ugLaw / ugMedicine / ugEducation              → US News 2026 undergrad
//     (US schools: real US News UG program rank. Non-US schools: mirrors QS subject rank,
//      since QS does not publish separate UG/grad subject rankings. ugLaw/ugMedicine/
//      ugEducation are always null — no UG list exists for these programs anywhere.)
//   qsCS / qsEngineering / qsBusiness / qsNaturalSci / qsSocialSci / qsArtsHum        → QS 2026 subject
//
// availablePrograms: specific programs offered (for shortlist filtering)

export const COUNTRIES = [
  { code: 'USA',        flag: '🇺🇸', label: '🇺🇸 United States' },
  { code: 'UK',         flag: '🇬🇧', label: '🇬🇧 United Kingdom' },
  { code: 'CANADA',     flag: '🇨🇦', label: '🇨🇦 Canada' },
  { code: 'AUSTRALIA',  flag: '🇦🇺', label: '🇦🇺 Australia' },
  { code: 'GERMANY',    flag: '🇩🇪', label: '🇩🇪 Germany' },
  { code: 'FRANCE',     flag: '🇫🇷', label: '🇫🇷 France' },
  { code: 'NETHERLANDS',flag: '🇳🇱', label: '🇳🇱 Netherlands' },
  { code: 'IRELAND',    flag: '🇮🇪', label: '🇮🇪 Ireland' },
  { code: 'SWEDEN',     flag: '🇸🇪', label: '🇸🇪 Sweden' },
  { code: 'SWITZERLAND',flag: '🇨🇭', label: '🇨🇭 Switzerland' },
  { code: 'ITALY',      flag: '🇮🇹', label: '🇮🇹 Italy' },
  { code: 'SPAIN',      flag: '🇪🇸', label: '🇪🇸 Spain' },
  { code: 'NZ',         flag: '🇳🇿', label: '🇳🇿 New Zealand' },
  { code: 'SINGAPORE',  flag: '🇸🇬', label: '🇸🇬 Singapore' },
  { code: 'JAPAN',      flag: '🇯🇵', label: '🇯🇵 Japan' },
  { code: 'SOUTH_KOREA',flag: '🇰🇷', label: '🇰🇷 South Korea' },
  { code: 'MALAYSIA',   flag: '🇲🇾', label: '🇲🇾 Malaysia' },
  { code: 'INDIA',      flag: '🇮🇳', label: '🇮🇳 India' },
  { code: 'UAE',        flag: '🇦🇪', label: '🇦🇪 UAE' },
  { code: 'AUSTRIA',    flag: '🇦🇹', label: '🇦🇹 Austria' },
  { code: 'HONG_KONG',  flag: '🇭🇰', label: '🇭🇰 Hong Kong' },
  { code: 'DENMARK',    flag: '🇩🇰', label: '🇩🇰 Denmark' },
  { code: 'FINLAND',    flag: '🇫🇮', label: '🇫🇮 Finland' },
  { code: 'NORWAY',     flag: '🇳🇴', label: '🇳🇴 Norway' },
  { code: 'BELGIUM',    flag: '🇧🇪', label: '🇧🇪 Belgium' },
];

export const PROGRAM_CATEGORIES = [
  'Engineering', 'Computer Science & IT', 'Business & Management',
  'Natural Sciences', 'Social Sciences', 'Arts & Humanities',
  'Health Sciences', 'Law', 'Education', 'Media & Communications',
  'Architecture & Urban Planning', 'Data Science & AI', 'Finance & Accounting',
  'Hospitality & Tourism', 'Environmental Studies'
];

export const DEGREE_TYPES = [
  'Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research',
  'Diploma / Certificate', 'Executive / Professional'
];

export const INTAKE_MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const SEED_UNIVERSITIES = [
  {
    id: 'usa-mit',
    name: 'Massachusetts Institute of Technology (MIT)',
    country: 'USA',
    city: 'Cambridge, MA',
    qsRank: 1,
    usNewsRank: 2,
    programs: ['Computer Science & IT', 'Engineering', 'Natural Sciences', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 4,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://mit.edu',
    established: 1861,
    campusType: 'Urban',
    about: 'World-leading STEM research university.',
    rankings: { ugCS: 1, ugEngineering: 1, ugBusiness: 1, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 1, gradEngineering: 1, gradBusiness: 4, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 1, qsEngineering: 1, qsBusiness: 8, qsNaturalSci: 1, qsSocialSci: 2, qsArtsHum: null },
    availablePrograms: ['Aeronautics & Astronautics', 'Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Cognitive Science', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Linguistics', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Neuroscience', 'Nuclear Engineering', 'Ocean Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban Studies & Planning'],
  },
  {
    id: 'usa-stanford',
    name: 'Stanford University',
    country: 'USA',
    city: 'Stanford, CA',
    qsRank: 5,
    usNewsRank: 3,
    programs: ['Computer Science & IT', 'Business & Management', 'Engineering', 'Law', 'Medicine & Health', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 57000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 4,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://stanford.edu',
    established: 1885,
    campusType: 'Suburban',
    about: 'Premier research university in Silicon Valley.',
    rankings: { ugCS: 2, ugEngineering: 2, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 1, gradEngineering: 2, gradBusiness: 2, gradLaw: 2, gradMedicine: 12, gradEducation: 3, qsCS: 2, qsEngineering: 2, qsBusiness: 4, qsNaturalSci: 2, qsSocialSci: 4, qsArtsHum: 4 },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth Systems', 'Electrical Engineering', 'Energy Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Management Science & Engineering', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Neuroscience', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Symbolic Systems'],
  },
  {
    id: 'usa-harvard',
    name: 'Harvard University',
    country: 'USA',
    city: 'Cambridge, MA',
    qsRank: 4,
    usNewsRank: 3,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 54000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 4,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://harvard.edu',
    established: 1636,
    campusType: 'Urban',
    about: 'Oldest university in the USA; renowned for law, business, and medicine.',
    rankings: { ugCS: 12, ugEngineering: 21, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 8, gradEngineering: null, gradBusiness: 1, gradLaw: 3, gradMedicine: 1, gradEducation: 2, qsCS: 8, qsEngineering: null, qsBusiness: 1, qsNaturalSci: 4, qsSocialSci: 1, qsArtsHum: 1 },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Design', 'Divinity & Theology', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Finance', 'Financial Engineering', 'Government & Public Policy', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Regional Studies', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-caltech',
    name: 'California Institute of Technology',
    country: 'USA',
    city: 'Pasadena, CA',
    qsRank: 10,
    usNewsRank: 8,
    programs: ['Engineering', 'Natural Sciences', 'Computer Science & IT', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 6,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://caltech.edu',
    established: 1891,
    campusType: 'Suburban',
    about: 'Elite STEM university known for physics and space research.',
    rankings: { ugCS: 9, ugEngineering: 5, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 8, gradEngineering: 4, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: 6, qsBusiness: null, qsNaturalSci: 3, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Astrophysics & Cosmology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computational & Neural Systems', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Geobiology', 'Geophysics', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Neuroscience', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'usa-columbia',
    name: 'Columbia University',
    country: 'USA',
    city: 'New York, NY',
    qsRank: 33,
    usNewsRank: 11,
    programs: ['Business & Management', 'Law', 'Engineering', 'Computer Science & IT', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 7,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://columbia.edu',
    established: 1754,
    campusType: 'Urban',
    about: 'Ivy League university in the heart of New York City.',
    rankings: { ugCS: 16, ugEngineering: 21, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 5, gradLaw: 4, gradMedicine: 3, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: 9, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: 7 },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Environmental Engineering', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'Investment Management', 'Journalism', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Nursing (BSN/MSN)', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Work', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban Planning'],
  },
  {
    id: 'usa-nyu',
    name: 'New York University',
    country: 'USA',
    city: 'New York, NY',
    qsRank: 38,
    usNewsRank: 25,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Finance & Accounting', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 16,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://nyu.edu',
    established: 1831,
    campusType: 'Urban',
    about: 'Global network university with campuses in NYC, Abu Dhabi, and Shanghai.',
    rankings: { ugCS: 30, ugEngineering: 64, ugBusiness: 5, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 13, gradLaw: 6, gradMedicine: 5, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: 10 },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Art History & Curatorship', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Dental Medicine', 'Digital Media & Content', 'Drama & Theatre Arts', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Film & TV Production', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'Investment Management', 'Journalism & Mass Communication', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Relations & Advertising', 'Real Estate', 'Risk Management & Insurance', 'Social Work', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-upenn',
    name: 'University of Pennsylvania',
    country: 'USA',
    city: 'Philadelphia, PA',
    qsRank: 12,
    usNewsRank: 6,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Finance & Accounting', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 8,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://upenn.edu',
    established: 1740,
    campusType: 'Urban',
    about: 'Ivy League home of Wharton School of Business.',
    rankings: { ugCS: 16, ugEngineering: 21, ugBusiness: 1, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 3, gradLaw: 6, gradMedicine: 4, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: 5, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Aerospace Engineering', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'Investment Management', 'LLM (Master of Laws)', 'Landscape Architecture', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Risk Management & Insurance', 'Social Work', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban Planning'],
  },
  {
    id: 'usa-yale',
    name: 'Yale University',
    country: 'USA',
    city: 'New Haven, CT',
    qsRank: 16,
    usNewsRank: 5,
    programs: ['Law', 'Arts & Humanities', 'Medicine & Health', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 6,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://yale.edu',
    established: 1701,
    campusType: 'Urban',
    about: 'Ivy League university renowned for law, drama, and the liberal arts.',
    rankings: { ugCS: 16, ugEngineering: 35, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 9, gradLaw: 1, gradMedicine: 7, gradEducation: 9, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: 8, qsArtsHum: 5 },
    availablePrograms: ['Anthropology', 'Architecture', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Divinity & Theology', 'Drama & Theatre Arts', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Forestry & Environmental Studies', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Nursing (BSN/MSN)', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'usa-princeton',
    name: 'Princeton University',
    country: 'USA',
    city: 'Princeton, NJ',
    qsRank: 18,
    usNewsRank: 1,
    programs: ['Natural Sciences', 'Engineering', 'Social Sciences', 'Finance & Accounting', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 57000,
    tuitionMax: 61000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 5,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://princeton.edu',
    established: 1746,
    campusType: 'Suburban',
    about: 'Ivy League known for economics, physics, and public policy.',
    rankings: { ugCS: 5, ugEngineering: 11, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 8, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: 9, qsSocialSci: 7, qsArtsHum: 6 },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Astrophysics', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Investment Management', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Neuroscience', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public & International Affairs', 'Risk Management & Insurance', 'Sociology'],
  },
  {
    id: 'usa-cornell',
    name: 'Cornell University',
    country: 'USA',
    city: 'Ithaca, NY',
    qsRank: 13,
    usNewsRank: 11,
    programs: ['Engineering', 'Business & Management', 'Agriculture', 'Architecture', 'Hospitality & Tourism', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 68000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 11,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://cornell.edu',
    established: 1865,
    campusType: 'Rural',
    about: 'Ivy League with unique programs in hotel management and agriculture.',
    rankings: { ugCS: 7, ugEngineering: 10, ugBusiness: 8, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 6, gradEngineering: 10, gradBusiness: 11, gradLaw: 18, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Agriculture & Life Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'City & Regional Planning', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Hotel Administration & Hospitality Management', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management', 'Urban & Regional Planning', 'Veterinary Medicine (BVSc/DVM)'],
  },
  {
    id: 'usa-uchicago',
    name: 'University of Chicago',
    country: 'USA',
    city: 'Chicago, IL',
    qsRank: 21,
    usNewsRank: 12,
    programs: ['Finance & Accounting', 'Social Sciences', 'Law', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 7,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://uchicago.edu',
    established: 1890,
    campusType: 'Urban',
    about: 'Home to the Chicago School of Economics with 100+ Nobel laureates.',
    rankings: { ugCS: 25, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 6, gradLaw: 5, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: 10, qsNaturalSci: null, qsSocialSci: 9, qsArtsHum: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cinema & Media Studies', 'Comparative Human Development', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Divinity & Theology', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Policy', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-jhu',
    name: 'Johns Hopkins University',
    country: 'USA',
    city: 'Baltimore, MD',
    qsRank: 26,
    usNewsRank: 8,
    programs: ['Medicine & Health', 'Natural Sciences', 'Engineering', 'Social Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 11,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://jhu.edu',
    established: 1876,
    campusType: 'Urban',
    about: 'World leader in medical research and public health.',
    rankings: { ugCS: 16, ugEngineering: 13, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: 2, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing & Big Data', 'Computer Engineering', 'Criminology & Criminal Justice', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Epidemiology', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'International Studies', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Nursing (BSN/MSN)', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Quantitative Analytics', 'Sociology', 'Space Science & Engineering'],
  },
  {
    id: 'usa-northwestern',
    name: 'Northwestern University',
    country: 'USA',
    city: 'Evanston, IL',
    qsRank: 31,
    usNewsRank: 8,
    programs: ['Business & Management', 'Law', 'Media & Communications', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 8,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://northwestern.edu',
    established: 1851,
    campusType: 'Suburban',
    about: 'Top private research university known for Kellogg and Medill schools.',
    rankings: { ugCS: 30, ugEngineering: 17, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 7, gradLaw: 8, gradMedicine: 9, gradEducation: 10, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cognitive Science', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Journalism', 'Journalism & Mass Communication', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music Performance', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Theatre & Performance Studies', 'Transportation & Logistics'],
  },
  {
    id: 'usa-duke',
    name: 'Duke University',
    country: 'USA',
    city: 'Durham, NC',
    qsRank: 62,
    usNewsRank: 6,
    programs: ['Medicine & Health', 'Law', 'Business & Management', 'Engineering', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 9,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://duke.edu',
    established: 1838,
    campusType: 'Suburban',
    about: 'Research university renowned for medicine and Fuqua School of Business.',
    rankings: { ugCS: 24, ugEngineering: 17, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 11, gradLaw: 8, gradMedicine: 8, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Divinity & Theology', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Forestry & Environmental Studies', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marine Sciences', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Physics', 'Policy Studies', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-dartmouth',
    name: 'Dartmouth College',
    country: 'USA',
    city: 'Hanover, NH',
    qsRank: 180,
    usNewsRank: 16,
    programs: ['Business & Management', 'Arts & Humanities', 'Social Sciences', 'Engineering', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 59000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 9,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://dartmouth.edu',
    established: 1769,
    campusType: 'Rural',
    about: 'Ivy League known for Tuck School of Business and liberal arts.',
    rankings: { ugCS: 39, ugEngineering: 57, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 8, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-brown',
    name: 'Brown University',
    country: 'USA',
    city: 'Providence, RI',
    qsRank: 198,
    usNewsRank: 44,
    programs: ['Arts & Humanities', 'Social Sciences', 'Medicine & Health', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 9,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://brown.edu',
    established: 1764,
    campusType: 'Urban',
    about: 'Ivy League known for its open curriculum and liberal education.',
    rankings: { ugCS: 25, ugEngineering: 42, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human-Computer Interaction', 'Information Technology', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering'],
  },
  {
    id: 'usa-vanderbilt',
    name: 'Vanderbilt University',
    country: 'USA',
    city: 'Nashville, TN',
    qsRank: 198,
    usNewsRank: 20,
    programs: ['Medicine & Health', 'Law', 'Education', 'Business & Management', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 56000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 11,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://vanderbilt.edu',
    established: 1873,
    campusType: 'Urban',
    about: 'Top research university in the South known for medicine and education.',
    rankings: { ugCS: 39, ugEngineering: 32, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: 15, gradMedicine: null, gradEducation: 1, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Dentistry', 'Divinity & Theology', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Musical Arts', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Peabody Education', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-rice',
    name: 'Rice University',
    country: 'USA',
    city: 'Houston, TX',
    qsRank: 113,
    usNewsRank: 13,
    programs: ['Engineering', 'Natural Sciences', 'Computer Science & IT', 'Business & Management', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 56000,
    tuitionMax: 61000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 10,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://rice.edu',
    established: 1912,
    campusType: 'Urban',
    about: 'Small elite research university in Houston with strong STEM programs.',
    rankings: { ugCS: 30, ugEngineering: 21, ugBusiness: 24, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 23, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computational & Applied Mathematics', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-notre-dame',
    name: 'University of Notre Dame',
    country: 'USA',
    city: 'Notre Dame, IN',
    qsRank: 219,
    usNewsRank: 15,
    programs: ['Business & Management', 'Law', 'Engineering', 'Arts & Humanities', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 57000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 13,
    ielts: 6.5,
    toefl: 100,
    greRequired: false,
    website: 'https://nd.edu',
    established: 1842,
    campusType: 'Suburban',
    about: 'Catholic research university renowned for business and law.',
    rankings: { ugCS: 45, ugEngineering: 42, ugBusiness: 12, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 25, gradLaw: 20, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'Investment Management', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Project Management', 'Risk Management & Insurance', 'Sacred Music', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Theology & Religious Studies'],
  },
  {
    id: 'usa-emory',
    name: 'Emory University',
    country: 'USA',
    city: 'Atlanta, GA',
    qsRank: 321,
    usNewsRank: 20,
    programs: ['Medicine & Health', 'Law', 'Business & Management', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 60000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 15,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://emory.edu',
    established: 1836,
    campusType: 'Suburban',
    about: 'Research university in Atlanta known for public health and medicine.',
    rankings: { ugCS: 63, ugEngineering: null, ugBusiness: 12, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 18, gradLaw: 15, gradMedicine: 14, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Global Health', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Rollins Public Health', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Theology'],
  },
  {
    id: 'usa-georgetown',
    name: 'Georgetown University',
    country: 'USA',
    city: 'Washington, DC',
    qsRank: 288,
    usNewsRank: 16,
    programs: ['Law', 'Business & Management', 'Social Sciences', 'Finance & Accounting', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 15,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://georgetown.edu',
    established: 1789,
    campusType: 'Urban',
    about: 'Jesuit research university known for law, international affairs, and business.',
    rankings: { ugCS: 63, ugEngineering: null, ugBusiness: 12, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 23, gradLaw: 11, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Arabic & Islamic Studies', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Foreign Service & Diplomacy', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Linguistics', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Theology'],
  },
  {
    id: 'usa-ucla',
    name: 'University of California, Los Angeles',
    country: 'USA',
    city: 'Los Angeles, CA',
    qsRank: 44,
    usNewsRank: 13,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 43000,
    tuitionMax: 46000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 14,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://ucla.edu',
    established: 1919,
    campusType: 'Urban',
    about: 'Top public research university in Los Angeles.',
    rankings: { ugCS: 15, ugEngineering: 14, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 12, gradEngineering: null, gradBusiness: 15, gradLaw: 13, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Film, Television & Digital Media', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Library & Information Science', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-ucb',
    name: 'University of California, Berkeley',
    country: 'USA',
    city: 'Berkeley, CA',
    qsRank: 28,
    usNewsRank: 18,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 48000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 17,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://berkeley.edu',
    established: 1868,
    campusType: 'Urban',
    about: 'Flagship UC campus; birthplace of Silicon Valley culture.',
    rankings: { ugCS: 2, ugEngineering: 3, ugBusiness: 3, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 4, gradEngineering: 3, gradBusiness: 9, gradLaw: 9, gradMedicine: null, gradEducation: 4, qsCS: 6, qsEngineering: 8, qsBusiness: null, qsNaturalSci: 8, qsSocialSci: 10, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'City & Regional Planning', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Energy & Resources', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Science', 'Information Technology', 'International Business', 'International Law', 'Journalism', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Nuclear Engineering', 'Operations Management', 'Physics', 'Project Management', 'Social Welfare', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-umich',
    name: 'University of Michigan',
    country: 'USA',
    city: 'Ann Arbor, MI',
    qsRank: 23,
    usNewsRank: 18,
    programs: ['Engineering', 'Business & Management', 'Law', 'Medicine & Health', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 53000,
    tuitionMax: 58000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 23,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://umich.edu',
    established: 1817,
    campusType: 'Urban',
    about: 'Leading public research university with top Ross School of Business.',
    rankings: { ugCS: 12, ugEngineering: 5, ugBusiness: 4, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 12, gradEngineering: 8, gradBusiness: 13, gradLaw: 8, gradMedicine: 10, gradEducation: 11, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Science', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Naval Architecture', 'Network Engineering', 'Nuclear Engineering & Radiological Sciences', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Social Work', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-uva',
    name: 'University of Virginia',
    country: 'USA',
    city: 'Charlottesville, VA',
    qsRank: 372,
    usNewsRank: 50,
    programs: ['Business & Management', 'Law', 'Engineering', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 52000,
    tuitionMax: 56000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 25,
    ielts: 7,
    toefl: 95,
    greRequired: false,
    website: 'https://virginia.edu',
    established: 1819,
    campusType: 'Suburban',
    about: 'Public Ivy founded by Thomas Jefferson; renowned for Darden School.',
    rankings: { ugCS: 39, ugEngineering: 35, ugBusiness: 12, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 13, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-unc',
    name: 'University of North Carolina',
    country: 'USA',
    city: 'Chapel Hill, NC',
    qsRank: 392,
    usNewsRank: 24,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 37000,
    tuitionMax: 40000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 25,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://unc.edu',
    established: 1789,
    campusType: 'Suburban',
    about: 'Top public flagship university in the Research Triangle.',
    rankings: { ugCS: 30, ugEngineering: 50, ugBusiness: 8, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 16, gradLaw: null, gradMedicine: null, gradEducation: 8, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-gatech',
    name: 'Georgia Institute of Technology',
    country: 'USA',
    city: 'Atlanta, GA',
    qsRank: 83,
    usNewsRank: 29,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Architecture', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 33000,
    tuitionMax: 36000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 21,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://gatech.edu',
    established: 1885,
    campusType: 'Urban',
    about: 'Top public tech university; one of the best for CS and engineering.',
    rankings: { ugCS: 5, ugEngineering: 3, ugBusiness: 19, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 8, gradEngineering: 4, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'City & Regional Planning', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computational Science', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Polymer Engineering', 'Project Management', 'Quantitative Analytics', 'Robotics & Autonomous Systems', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-carnegie-mellon',
    name: 'Carnegie Mellon University',
    country: 'USA',
    city: 'Pittsburgh, PA',
    qsRank: 52,
    usNewsRank: 20,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Arts & Humanities', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 59000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 17,
    ielts: 7,
    toefl: 100,
    greRequired: true,
    website: 'https://cmu.edu',
    established: 1900,
    campusType: 'Urban',
    about: 'World leader in computer science, AI, and robotics.',
    rankings: { ugCS: 2, ugEngineering: 8, ugBusiness: 6, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 1, gradEngineering: 6, gradBusiness: 17, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 3, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entertainment Technology', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Systems Management', 'Information Technology', 'International Business', 'Language Technologies', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Policy & Management', 'Project Management', 'Quantitative Analytics', 'Robotics & Autonomous Systems', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-usc',
    name: 'University of Southern California',
    country: 'USA',
    city: 'Los Angeles, CA',
    qsRank: 106,
    usNewsRank: 27,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Arts & Humanities', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 64000,
    tuitionMax: 70000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 16,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://usc.edu',
    established: 1880,
    campusType: 'Urban',
    about: 'Major private research university in Los Angeles.',
    rankings: { ugCS: 16, ugEngineering: 28, ugBusiness: 8, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 24, gradLaw: 13, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-utaustin',
    name: 'University of Texas at Austin',
    country: 'USA',
    city: 'Austin, TX',
    qsRank: 197,
    usNewsRank: 29,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Law', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 40000,
    tuitionMax: 43000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 31,
    ielts: 7,
    toefl: 79,
    greRequired: false,
    website: 'https://utexas.edu',
    established: 1883,
    campusType: 'Urban',
    about: 'Flagship Texas public university known for engineering and business.',
    rankings: { ugCS: 9, ugEngineering: 11, ugBusiness: 6, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 10, gradEngineering: 10, gradBusiness: 16, gradLaw: 11, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Advertising & Public Relations', 'Aerospace Engineering', 'Architectural Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'Journalism', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Petroleum Engineering', 'Physics', 'Project Management', 'Social Work', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-purdue',
    name: 'Purdue University',
    country: 'USA',
    city: 'West Lafayette, IN',
    qsRank: 109,
    usNewsRank: 36,
    programs: ['Engineering', 'Agriculture', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 29000,
    tuitionMax: 32000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://purdue.edu',
    established: 1869,
    campusType: 'Suburban',
    about: 'Top engineering and agriculture university in the Midwest.',
    rankings: { ugCS: 16, ugEngineering: 8, ugBusiness: 24, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 12, gradEngineering: 6, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Aviation Technology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Nuclear Engineering', 'Operations Management', 'Physics', 'Polymer Engineering', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)'],
  },
  {
    id: 'usa-uiuc',
    name: 'University of Illinois Urbana-Champaign',
    country: 'USA',
    city: 'Champaign, IL',
    qsRank: 57,
    usNewsRank: 54,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Agriculture', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 34000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 59,
    ielts: 7,
    toefl: 103,
    greRequired: true,
    website: 'https://illinois.edu',
    established: 1867,
    campusType: 'Urban',
    about: 'Big Ten research university with world-class CS and engineering.',
    rankings: { ugCS: 7, ugEngineering: 5, ugBusiness: 12, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 4, gradEngineering: 8, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Atmospheric Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Library & Information Science', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Nuclear Plasma & Radiological Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)'],
  },
  {
    id: 'usa-uwmadison',
    name: 'University of Wisconsin-Madison',
    country: 'USA',
    city: 'Madison, WI',
    qsRank: 184,
    usNewsRank: 50,
    programs: ['Engineering', 'Natural Sciences', 'Business & Management', 'Social Sciences', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 37000,
    tuitionMax: 40000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 49,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://wisc.edu',
    established: 1848,
    campusType: 'Urban',
    about: 'Big Ten flagship known for research and life sciences.',
    rankings: { ugCS: 16, ugEngineering: 14, ugBusiness: 19, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 11, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: 5, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Genetic Counselling', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Journalism', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Pharmacy (PharmD/BPharm)', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)'],
  },
  {
    id: 'usa-ohio-state',
    name: 'Ohio State University',
    country: 'USA',
    city: 'Columbus, OH',
    qsRank: 252,
    usNewsRank: 33,
    programs: ['Business & Management', 'Engineering', 'Medicine & Health', 'Education', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 54,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://osu.edu',
    established: 1870,
    campusType: 'Urban',
    about: 'Large public research university with broad academic programs.',
    rankings: { ugCS: 39, ugEngineering: 28, ugBusiness: 12, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 25, gradLaw: null, gradMedicine: null, gradEducation: 14, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Optometry', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Social Work', 'Software Engineering', 'Sports Science & Kinesiology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics', 'Veterinary Medicine (BVSc/DVM)'],
  },
  {
    id: 'usa-penn-state',
    name: 'Pennsylvania State University',
    country: 'USA',
    city: 'University Park, PA',
    qsRank: 344,
    usNewsRank: 42,
    programs: ['Engineering', 'Business & Management', 'Agriculture', 'Education', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 36000,
    tuitionMax: 40000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 56,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://psu.edu',
    established: 1855,
    campusType: 'Suburban',
    about: 'Major public research university with strong engineering programs.',
    rankings: { ugCS: 39, ugEngineering: 21, ugBusiness: 24, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Hotel & Restaurant Management', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Nuclear Engineering', 'Nursing (BSN/MSN)', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-uw-seattle',
    name: 'University of Washington',
    country: 'USA',
    city: 'Seattle, WA',
    qsRank: 83,
    usNewsRank: 67,
    programs: ['Computer Science & IT', 'Medicine & Health', 'Engineering', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 42000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 7,
    toefl: 92,
    greRequired: false,
    website: 'https://uw.edu',
    established: 1861,
    campusType: 'Urban',
    about: 'Top public research university in the Pacific Northwest.',
    rankings: { ugCS: 9, ugEngineering: 21, ugBusiness: 19, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 6, gradEngineering: null, gradBusiness: null, gradLaw: 17, gradMedicine: 6, gradEducation: 6, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Fisheries & Aquatic Sciences', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Science', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Nursing (BSN/MSN)', 'Pharmacy', 'Pharmacy (PharmD/BPharm)', 'Physics', 'Public Health (MPH)', 'Quantitative Analytics', 'Social Work', 'Software Engineering'],
  },
  {
    id: 'usa-minnesota',
    name: 'University of Minnesota',
    country: 'USA',
    city: 'Minneapolis, MN',
    qsRank: 230,
    usNewsRank: 59,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Natural Sciences', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 44,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://umn.edu',
    established: 1851,
    campusType: 'Urban',
    about: 'Big Ten research university with strong medical and science programs.',
    rankings: { ugCS: 39, ugEngineering: 28, ugBusiness: 19, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 28, gradLaw: 18, gradMedicine: null, gradEducation: 11, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-rutgers',
    name: 'Rutgers University',
    country: 'USA',
    city: 'New Brunswick, NJ',
    qsRank: 651,
    usNewsRank: 59,
    programs: ['Engineering', 'Business & Management', 'Medicine & Health', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 34000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://rutgers.edu',
    established: 1766,
    campusType: 'Suburban',
    about: 'New Jersey\'s flagship state university.',
    rankings: { ugCS: 54, ugEngineering: 50, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-arizona-state',
    name: 'Arizona State University',
    country: 'USA',
    city: 'Tempe, AZ',
    qsRank: 216,
    usNewsRank: 71,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 29000,
    tuitionMax: 32000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://asu.edu',
    established: 1885,
    campusType: 'Urban',
    about: 'Largest US university by enrollment; known for innovation.',
    rankings: { ugCS: 48, ugEngineering: 35, ugBusiness: 24, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-tufts',
    name: 'Tufts University',
    country: 'USA',
    city: 'Medford, MA',
    qsRank: 302,
    usNewsRank: 27,
    programs: ['Engineering', 'Medicine & Health', 'Arts & Humanities', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 15,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://tufts.edu',
    established: 1852,
    campusType: 'Suburban',
    about: 'Research university near Boston known for international relations.',
    rankings: { ugCS: 54, ugEngineering: 50, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'usa-bu',
    name: 'Boston University',
    country: 'USA',
    city: 'Boston, MA',
    qsRank: 119,
    usNewsRank: 46,
    programs: ['Business & Management', 'Medicine & Health', 'Engineering', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 19,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://bu.edu',
    established: 1839,
    campusType: 'Urban',
    about: 'Large private research university in Boston.',
    rankings: { ugCS: 48, ugEngineering: 48, ugBusiness: 37, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-bc',
    name: 'Boston College',
    country: 'USA',
    city: 'Chestnut Hill, MA',
    qsRank: 401,
    usNewsRank: 36,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 19,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://bc.edu',
    established: 1863,
    campusType: 'Suburban',
    about: 'Jesuit research university near Boston with top Carroll School.',
    rankings: { ugCS: 98, ugEngineering: null, ugBusiness: 32, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-brandeis',
    name: 'Brandeis University',
    country: 'USA',
    city: 'Waltham, MA',
    qsRank: 351,
    usNewsRank: 54,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Business & Management', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 34,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://brandeis.edu',
    established: 1948,
    campusType: 'Suburban',
    about: 'Research university near Boston with strong sciences and social sciences.',
    rankings: { ugCS: 107, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-rochester',
    name: 'University of Rochester',
    country: 'USA',
    city: 'Rochester, NY',
    qsRank: 201,
    usNewsRank: 54,
    programs: ['Medicine & Health', 'Engineering', 'Natural Sciences', 'Business & Management', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 29,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://rochester.edu',
    established: 1850,
    campusType: 'Suburban',
    about: 'Research university known for Eastman School of Music and optics.',
    rankings: { ugCS: 78, ugEngineering: null, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-wake-forest',
    name: 'Wake Forest University',
    country: 'USA',
    city: 'Winston-Salem, NC',
    qsRank: 501,
    usNewsRank: 31,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 57000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 21,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://wfu.edu',
    established: 1834,
    campusType: 'Suburban',
    about: 'Private research university known for business and medicine.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-wustl',
    name: 'Washington University in St. Louis',
    country: 'USA',
    city: 'St. Louis, MO',
    qsRank: 165,
    usNewsRank: 20,
    programs: ['Medicine & Health', 'Business & Management', 'Law', 'Engineering', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 15,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://wustl.edu',
    established: 1853,
    campusType: 'Suburban',
    about: 'Top research university known for Olin Business and medical school.',
    rankings: { ugCS: 45, ugEngineering: 42, ugBusiness: 12, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 24, gradLaw: null, gradMedicine: 14, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art & Design', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Occupational Therapy', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Social Work', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-case-western',
    name: 'Case Western Reserve University',
    country: 'USA',
    city: 'Cleveland, OH',
    qsRank: 601,
    usNewsRank: 38,
    programs: ['Engineering', 'Medicine & Health', 'Business & Management', 'Natural Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 61000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://case.edu',
    established: 1826,
    campusType: 'Urban',
    about: 'Research university in Cleveland known for engineering and medicine.',
    rankings: { ugCS: 78, ugEngineering: 42, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-tulane',
    name: 'Tulane University',
    country: 'USA',
    city: 'New Orleans, LA',
    qsRank: 601,
    usNewsRank: 38,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 13,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://tulane.edu',
    established: 1834,
    campusType: 'Urban',
    about: 'Private research university in New Orleans with strong business school.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-pitt',
    name: 'University of Pittsburgh',
    country: 'USA',
    city: 'Pittsburgh, PA',
    qsRank: 401,
    usNewsRank: 52,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Natural Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 29000,
    tuitionMax: 32000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://pitt.edu',
    established: 1787,
    campusType: 'Urban',
    about: 'Public research university known for medicine and pharmacy.',
    rankings: { ugCS: 63, ugEngineering: 57, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: 11, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-lehigh',
    name: 'Lehigh University',
    country: 'USA',
    city: 'Bethlehem, PA',
    qsRank: 601,
    usNewsRank: 38,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 57000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 24,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://lehigh.edu',
    established: 1865,
    campusType: 'Suburban',
    about: 'Private research university known for engineering and business.',
    rankings: { ugCS: 107, ugEngineering: 57, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-drexel',
    name: 'Drexel University',
    country: 'USA',
    city: 'Philadelphia, PA',
    qsRank: 751,
    usNewsRank: 71,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Medicine & Health', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 54000,
    tuitionMax: 60000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 76,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://drexel.edu',
    established: 1891,
    campusType: 'Urban',
    about: 'Known for co-op programs integrating work experience with education.',
    rankings: { ugCS: 78, ugEngineering: 64, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-fordham',
    name: 'Fordham University',
    country: 'USA',
    city: 'New York, NY',
    qsRank: 801,
    usNewsRank: 62,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Social Sciences', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 61000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://fordham.edu',
    established: 1841,
    campusType: 'Urban',
    about: 'Jesuit university in New York with Gabelli School of Business.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-smu',
    name: 'Southern Methodist University',
    country: 'USA',
    city: 'Dallas, TX',
    qsRank: 751,
    usNewsRank: 46,
    programs: ['Business & Management', 'Law', 'Engineering', 'Arts & Humanities', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://smu.edu',
    established: 1911,
    campusType: 'Urban',
    about: 'Private university in Dallas known for Cox School of Business.',
    rankings: { ugCS: 177, ugEngineering: null, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-miami',
    name: 'University of Miami',
    country: 'USA',
    city: 'Coral Gables, FL',
    qsRank: 401,
    usNewsRank: 50,
    programs: ['Business & Management', 'Medicine & Health', 'Engineering', 'Arts & Humanities', 'Marine Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 54000,
    tuitionMax: 61000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 33,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://miami.edu',
    established: 1925,
    campusType: 'Suburban',
    about: 'Private research university in South Florida.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Coastal & Ocean Management', 'Computer Engineering', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marine Biology', 'Marine Engineering', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Oceanography', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-american',
    name: 'American University',
    country: 'USA',
    city: 'Washington, DC',
    qsRank: 751,
    usNewsRank: 87,
    programs: ['International Relations', 'Law', 'Business & Management', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 50000,
    tuitionMax: 56000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 37,
    ielts: 6.5,
    toefl: 84,
    greRequired: false,
    website: 'https://american.edu',
    established: 1893,
    campusType: 'Urban',
    about: 'Known for international studies and public policy near DC.',
    rankings: { ugCS: 229, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Foreign Policy & Security Studies', 'Global Affairs', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-george-washington',
    name: 'George Washington University',
    country: 'USA',
    city: 'Washington, DC',
    qsRank: 601,
    usNewsRank: 54,
    programs: ['Law', 'International Relations', 'Business & Management', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://gwu.edu',
    established: 1821,
    campusType: 'Urban',
    about: 'Private research university in downtown Washington DC.',
    rankings: { ugCS: 63, ugEngineering: 77, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Foreign Policy & Security Studies', 'Global Affairs', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-clemson',
    name: 'Clemson University',
    country: 'USA',
    city: 'Clemson, SC',
    qsRank: 601,
    usNewsRank: 62,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 36000,
    tuitionMax: 40000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 51,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://clemson.edu',
    established: 1889,
    campusType: 'Rural',
    about: 'Public research university in South Carolina known for engineering.',
    rankings: { ugCS: 78, ugEngineering: 50, ugBusiness: 64, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-ucsd',
    name: 'UC San Diego',
    country: 'USA',
    city: 'La Jolla, CA',
    qsRank: 65,
    usNewsRank: 25,
    programs: ['Medicine & Health', 'Computer Science & IT', 'Engineering', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 47000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 34,
    ielts: 7,
    toefl: 95,
    greRequired: false,
    website: 'https://ucsd.edu',
    established: 1960,
    campusType: 'Suburban',
    about: 'Top UC campus known for oceanography and biomedical research.',
    rankings: { ugCS: 12, ugEngineering: 17, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: 12, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Pharmacy', 'Physics', 'Public Health (MPH)', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'usa-ucdavis',
    name: 'UC Davis',
    country: 'USA',
    city: 'Davis, CA',
    qsRank: 183,
    usNewsRank: 33,
    programs: ['Agriculture', 'Veterinary Medicine', 'Engineering', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 47000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 39,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://ucdavis.edu',
    established: 1905,
    campusType: 'Suburban',
    about: 'UC campus renowned for agriculture, veterinary medicine, and wine.',
    rankings: { ugCS: 35, ugEngineering: 32, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Animal Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Horticulture', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health', 'Viticulture & Enology'],
  },
  {
    id: 'usa-ucsb',
    name: 'UC Santa Barbara',
    country: 'USA',
    city: 'Santa Barbara, CA',
    qsRank: 154,
    usNewsRank: 44,
    programs: ['Natural Sciences', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 47000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 32,
    ielts: 7,
    toefl: 80,
    greRequired: false,
    website: 'https://ucsb.edu',
    established: 1944,
    campusType: 'Suburban',
    about: 'Research-intensive UC campus with beautiful coastal setting.',
    rankings: { ugCS: 35, ugEngineering: 42, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology', 'Software Engineering'],
  },
  {
    id: 'usa-ucirvine',
    name: 'UC Irvine',
    country: 'USA',
    city: 'Irvine, CA',
    qsRank: 241,
    usNewsRank: 33,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Medicine & Health', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 47000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://uci.edu',
    established: 1965,
    campusType: 'Suburban',
    about: 'Top UC campus in Orange County with strong CS programs.',
    rankings: { ugCS: 25, ugEngineering: 35, ugBusiness: 32, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-stonybrook',
    name: 'Stony Brook University',
    country: 'USA',
    city: 'Stony Brook, NY',
    qsRank: 351,
    usNewsRank: 59,
    programs: ['Medicine & Health', 'Natural Sciences', 'Engineering', 'Computer Science & IT', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 49,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://stonybrook.edu',
    established: 1957,
    campusType: 'Suburban',
    about: 'SUNY flagship research university with strong STEM programs.',
    rankings: { ugCS: 54, ugEngineering: 64, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-colorado',
    name: 'University of Colorado Boulder',
    country: 'USA',
    city: 'Boulder, CO',
    qsRank: 362,
    usNewsRank: 62,
    programs: ['Engineering', 'Natural Sciences', 'Business & Management', 'Computer Science & IT', 'Environmental Studies'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 42000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://colorado.edu',
    established: 1876,
    campusType: 'Urban',
    about: 'Flagship Colorado university known for aerospace and environmental sciences.',
    rankings: { ugCS: 30, ugEngineering: 28, ugBusiness: 32, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Conservation Biology', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Renewable Energy & Clean Technology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Sustainability & Climate Studies'],
  },
  {
    id: 'usa-indiana',
    name: 'Indiana University',
    country: 'USA',
    city: 'Bloomington, IN',
    qsRank: 601,
    usNewsRank: 50,
    programs: ['Business & Management', 'Law', 'Education', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 36000,
    tuitionMax: 40000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://indiana.edu',
    established: 1820,
    campusType: 'Suburban',
    about: 'Big Ten university known for Kelley School of Business.',
    rankings: { ugCS: 54, ugEngineering: null, ugBusiness: 8, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: 20, gradLaw: null, gradMedicine: null, gradEducation: 11, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-florida',
    name: 'University of Florida',
    country: 'USA',
    city: 'Gainesville, FL',
    qsRank: 213,
    usNewsRank: 31,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Medicine & Health', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 37,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://ufl.edu',
    established: 1853,
    campusType: 'Suburban',
    about: 'Top public university in Florida known for engineering and agriculture.',
    rankings: { ugCS: 48, ugEngineering: 32, ugBusiness: 24, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-fsu',
    name: 'Florida State University',
    country: 'USA',
    city: 'Tallahassee, FL',
    qsRank: 601,
    usNewsRank: 54,
    programs: ['Business & Management', 'Engineering', 'Social Sciences', 'Arts & Humanities', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 36,
    ielts: 6,
    toefl: 80,
    greRequired: false,
    website: 'https://fsu.edu',
    established: 1851,
    campusType: 'Suburban',
    about: 'Florida\'s top public research university with strong business programs.',
    rankings: { ugCS: 117, ugEngineering: null, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-iowa',
    name: 'University of Iowa',
    country: 'USA',
    city: 'Iowa City, IA',
    qsRank: 601,
    usNewsRank: 67,
    programs: ['Medicine & Health', 'Law', 'Business & Management', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 32000,
    tuitionMax: 35000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uiowa.edu',
    established: 1847,
    campusType: 'Suburban',
    about: 'Big Ten research university known for creative writing and medicine.',
    rankings: { ugCS: 71, ugEngineering: 72, ugBusiness: 32, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-virginia-tech',
    name: 'Virginia Tech',
    country: 'USA',
    city: 'Blacksburg, VA',
    qsRank: 413,
    usNewsRank: 92,
    programs: ['Engineering', 'Computer Science & IT', 'Agriculture', 'Architecture', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 31000,
    tuitionMax: 34000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://vt.edu',
    established: 1872,
    campusType: 'Rural',
    about: 'Major public research university known for engineering and CS.',
    rankings: { ugCS: 25, ugEngineering: 14, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-maryland',
    name: 'University of Maryland',
    country: 'USA',
    city: 'College Park, MD',
    qsRank: 153,
    usNewsRank: 79,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 37000,
    tuitionMax: 41000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 52,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://umd.edu',
    established: 1856,
    campusType: 'Suburban',
    about: 'Flagship Maryland public university near DC with strong STEM.',
    rankings: { ugCS: 16, ugEngineering: 21, ugBusiness: 24, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-ucsc',
    name: 'UC Santa Cruz',
    country: 'USA',
    city: 'Santa Cruz, CA',
    qsRank: 501,
    usNewsRank: 87,
    programs: ['Computer Science & IT', 'Natural Sciences', 'Engineering', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 47000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://ucsc.edu',
    established: 1965,
    campusType: 'Suburban',
    about: 'UC campus known for computer science and environmental research.',
    rankings: { ugCS: 48, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology', 'Software Engineering'],
  },
  {
    id: 'usa-temple',
    name: 'Temple University',
    country: 'USA',
    city: 'Philadelphia, PA',
    qsRank: 801,
    usNewsRank: 87,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://temple.edu',
    established: 1884,
    campusType: 'Urban',
    about: 'Public research university in Philadelphia with diverse programs.',
    rankings: { ugCS: 117, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-auburn',
    name: 'Auburn University',
    country: 'USA',
    city: 'Auburn, AL',
    qsRank: 801,
    usNewsRank: 71,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Architecture', 'Veterinary Medicine'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 32000,
    tuitionMax: 35000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://auburn.edu',
    established: 1856,
    campusType: 'Suburban',
    about: 'Public research university known for engineering and architecture.',
    rankings: { ugCS: 78, ugEngineering: 57, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Animal Sciences', 'Architecture', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Operations Management', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health'],
  },
  {
    id: 'usa-byu',
    name: 'Brigham Young University',
    country: 'USA',
    city: 'Provo, UT',
    qsRank: 1001,
    usNewsRank: 97,
    programs: ['Business & Management', 'Engineering', 'Education', 'Law', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 6500,
    tuitionMax: 7000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6.5,
    toefl: 85,
    greRequired: false,
    website: 'https://byu.edu',
    established: 1875,
    campusType: 'Suburban',
    about: 'Private LDS university known for its highly affordable education.',
    rankings: { ugCS: 107, ugEngineering: null, ugBusiness: 37, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-fordham-law',
    name: 'Fordham University School of Law',
    country: 'USA',
    city: 'New York, NY',
    qsRank: null,
    usNewsRank: 62,
    programs: ['Law', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 56000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 47,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://law.fordham.edu',
    established: 1905,
    campusType: 'Urban',
    about: 'Top NYC law school with strong corporate and international law programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Finance', 'Financial Engineering', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Political Science & Government', 'Psychology', 'Risk Management & Insurance', 'Sociology'],
  },
  {
    id: 'usa-northeastern',
    name: 'Northeastern University',
    country: 'USA',
    city: 'Boston, MA',
    qsRank: 349,
    usNewsRank: 38,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Health Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 57000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 18,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://northeastern.edu',
    established: 1898,
    campusType: 'Urban',
    about: 'Known for cooperative education and strong industry connections.',
    rankings: { ugCS: 35, ugEngineering: 35, ugBusiness: 64, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Health Informatics', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Project Management', 'Public Health (MPH)', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-babson',
    name: 'Babson College',
    country: 'USA',
    city: 'Wellesley, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Entrepreneurship', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 60000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 24,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://babson.edu',
    established: 1919,
    campusType: 'Suburban',
    about: '#1 for entrepreneurship; focused entirely on business education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: 37, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-bentley',
    name: 'Bentley University',
    country: 'USA',
    city: 'Waltham, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Data Science & AI', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 53000,
    tuitionMax: 58000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 41,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://bentley.edu',
    established: 1917,
    campusType: 'Suburban',
    about: 'Business-focused university known for integrating tech and commerce.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Risk Management & Insurance', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-suffolk',
    name: 'Suffolk University',
    country: 'USA',
    city: 'Boston, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Law', 'Business & Management', 'Finance & Accounting', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 45000,
    tuitionMax: 51000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://suffolk.edu',
    established: 1906,
    campusType: 'Urban',
    about: 'Urban university in Boston with strong law and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'Investment Management', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Project Management', 'Risk Management & Insurance', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-ucr',
    name: 'UC Riverside',
    country: 'USA',
    city: 'Riverside, CA',
    qsRank: 501,
    usNewsRank: 84,
    programs: ['Engineering', 'Natural Sciences', 'Business & Management', 'Agriculture', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 43000,
    tuitionMax: 46000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 70,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://ucr.edu',
    established: 1954,
    campusType: 'Suburban',
    about: 'UC campus in the Inland Empire with growing research programs.',
    rankings: { ugCS: 54, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-ucm',
    name: 'UC Merced',
    country: 'USA',
    city: 'Merced, CA',
    qsRank: 751,
    usNewsRank: 201,
    programs: ['Engineering', 'Natural Sciences', 'Social Sciences', 'Computer Science & IT', 'Environmental Studies'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 43000,
    tuitionMax: 46000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 71,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ucmerced.edu',
    established: 2005,
    campusType: 'Suburban',
    about: 'Newest UC campus with strong sustainability research programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Conservation Biology', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Relations & Diplomacy', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Political Science & Government', 'Psychology', 'Renewable Energy & Clean Technology', 'Sociology', 'Software Engineering', 'Sustainability & Climate Studies'],
  },
  {
    id: 'usa-houston',
    name: 'University of Houston',
    country: 'USA',
    city: 'Houston, TX',
    qsRank: 651,
    usNewsRank: 131,
    programs: ['Engineering', 'Business & Management', 'Law', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 31000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uh.edu',
    established: 1927,
    campusType: 'Urban',
    about: 'Public research university in Houston, Texas.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-umass',
    name: 'University of Massachusetts Amherst',
    country: 'USA',
    city: 'Amherst, MA',
    qsRank: 423,
    usNewsRank: 71,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://umass.edu',
    established: 1863,
    campusType: 'Suburban',
    about: 'Flagship UMass campus with strong engineering and CS programs.',
    rankings: { ugCS: 35, ugEngineering: 57, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-ucf',
    name: 'University of Central Florida',
    country: 'USA',
    city: 'Orlando, FL',
    qsRank: 751,
    usNewsRank: 201,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Hospitality & Tourism', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 21000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 50,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ucf.edu',
    established: 1963,
    campusType: 'Suburban',
    about: 'Second largest US university with strong hospitality and engineering.',
    rankings: { ugCS: 78, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics', 'Tourism Management'],
  },
  {
    id: 'usa-uncc',
    name: 'University of North Carolina Charlotte',
    country: 'USA',
    city: 'Charlotte, NC',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Education', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://charlotte.edu',
    established: 1946,
    campusType: 'Urban',
    about: 'Public research university in Charlotte, NC.',
    rankings: { ugCS: 107, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-ncsu',
    name: 'NC State University',
    country: 'USA',
    city: 'Raleigh, NC',
    qsRank: 601,
    usNewsRank: 71,
    programs: ['Engineering', 'Agriculture', 'Computer Science & IT', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 29000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 48,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://ncsu.edu',
    established: 1887,
    campusType: 'Urban',
    about: 'Public research university in Raleigh\'s Research Triangle.',
    rankings: { ugCS: 48, ugEngineering: 35, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-kansas',
    name: 'University of Kansas',
    country: 'USA',
    city: 'Lawrence, KS',
    qsRank: null,
    usNewsRank: 87,
    programs: ['Business & Management', 'Engineering', 'Law', 'Medicine & Health', 'Pharmacy'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 31000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 93,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ku.edu',
    established: 1865,
    campusType: 'Suburban',
    about: 'Public research university in Lawrence, Kansas.',
    rankings: { ugCS: 107, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Clinical Pharmacy', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy', 'Pharmacy (PharmD/BPharm)', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-oklahoma',
    name: 'University of Oklahoma',
    country: 'USA',
    city: 'Norman, OK',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Engineering', 'Business & Management', 'Law', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 27000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ou.edu',
    established: 1890,
    campusType: 'Suburban',
    about: 'Public research flagship of Oklahoma.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-sdsu',
    name: 'San Diego State University',
    country: 'USA',
    city: 'San Diego, CA',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 21000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sdsu.edu',
    established: 1897,
    campusType: 'Suburban',
    about: 'Large public university in San Diego with strong business programs.',
    rankings: { ugCS: 98, ugEngineering: null, ugBusiness: 64, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-uconn',
    name: 'University of Connecticut',
    country: 'USA',
    city: 'Storrs, CT',
    qsRank: 651,
    usNewsRank: 62,
    programs: ['Business & Management', 'Engineering', 'Law', 'Medicine & Health', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 42000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://uconn.edu',
    established: 1881,
    campusType: 'Suburban',
    about: 'Connecticut\'s flagship public university.',
    rankings: { ugCS: 71, ugEngineering: 64, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-hawaii',
    name: 'University of Hawaii at Manoa',
    country: 'USA',
    city: 'Honolulu, HI',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Natural Sciences', 'Business & Management', 'Engineering', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 32000,
    tuitionMax: 35000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hawaii.edu',
    established: 1907,
    campusType: 'Suburban',
    about: 'Pacific research university with strong oceanography programs.',
    rankings: { ugCS: 177, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-kentucky',
    name: 'University of Kentucky',
    country: 'USA',
    city: 'Lexington, KY',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Agriculture', 'Medicine & Health', 'Business & Management', 'Engineering', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 94,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uky.edu',
    established: 1865,
    campusType: 'Urban',
    about: 'Public research university known for agriculture and medicine.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-oxford',
    name: 'University of Oxford',
    country: 'UK',
    city: 'Oxford',
    qsRank: 3,
    usNewsRank: 5,
    programs: ['Natural Sciences', 'Medicine & Health', 'Law', 'Social Sciences', 'Arts & Humanities', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 38000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 17,
    ielts: 7,
    toefl: 110,
    greRequired: false,
    website: 'https://ox.ac.uk',
    established: 1096,
    campusType: 'Urban',
    about: 'World\'s oldest English-speaking university and global academic leader.',
    rankings: { ugCS: 4, ugEngineering: 4, ugBusiness: 7, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 4, qsEngineering: 4, qsBusiness: 7, qsNaturalSci: 6, qsSocialSci: 3, qsArtsHum: 2 },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Classics', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Geography', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Neuroscience', 'Nursing', 'Operations Management', 'Oriental Studies', 'PPE (Philosophy, Politics & Economics)', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-cambridge',
    name: 'University of Cambridge',
    country: 'UK',
    city: 'Cambridge',
    qsRank: 5,
    usNewsRank: 7,
    programs: ['Natural Sciences', 'Engineering', 'Law', 'Medicine & Health', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 38000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 21,
    ielts: 7.5,
    toefl: 110,
    greRequired: false,
    website: 'https://cam.ac.uk',
    established: 1209,
    campusType: 'Urban',
    about: 'Leading global research university known for science and mathematics.',
    rankings: { ugCS: 7, ugEngineering: 3, ugBusiness: 6, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 7, qsEngineering: 3, qsBusiness: 6, qsNaturalSci: 5, qsSocialSci: 5, qsArtsHum: 3 },
    availablePrograms: ['Aerospace Engineering', 'Anglo-Saxon Norse & Celtic', 'Architecture', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Law', 'LLM (Master of Laws)', 'Land Economy', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Natural Sciences', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Public Health (MPH)', 'Veterinary Medicine (BVSc/DVM)'],
  },
  {
    id: 'uk-imperial',
    name: 'Imperial College London',
    country: 'UK',
    city: 'London',
    qsRank: 2,
    usNewsRank: 14,
    programs: ['Engineering', 'Computer Science & IT', 'Medicine & Health', 'Natural Sciences', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 32000,
    tuitionMax: 37000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 15,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://imperial.ac.uk',
    established: 1907,
    campusType: 'Urban',
    about: 'World-class STEM university in London.',
    rankings: { ugCS: 10, ugEngineering: 9, ugBusiness: 10, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 10, qsEngineering: 9, qsBusiness: 10, qsNaturalSci: 9, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Design Engineering', 'Dyson School of Design Engineering', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-ucl',
    name: 'University College London',
    country: 'UK',
    city: 'London',
    qsRank: 9,
    usNewsRank: 30,
    programs: ['Engineering', 'Computer Science & IT', 'Medicine & Health', 'Architecture', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 63,
    ielts: 7,
    toefl: 96,
    greRequired: false,
    website: 'https://ucl.ac.uk',
    established: 1826,
    campusType: 'Urban',
    about: 'Leading multidisciplinary research university in London.',
    rankings: { ugCS: 20, ugEngineering: 16, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 20, qsEngineering: 16, qsBusiness: null, qsNaturalSci: 14, qsSocialSci: 12, qsArtsHum: 9 },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Archaeology', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Bartlett School', 'Biomedical Engineering', 'Biomedical Sciences', 'Brain Sciences', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Relations & Diplomacy', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Urban & Regional Planning', 'Urban Planning'],
  },
  {
    id: 'uk-edinburgh',
    name: 'University of Edinburgh',
    country: 'UK',
    city: 'Edinburgh',
    qsRank: 22,
    usNewsRank: 30,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 32000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 42,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://ed.ac.uk',
    established: 1583,
    campusType: 'Urban',
    about: 'Scotland\'s premier research university; founded in the 16th century.',
    rankings: { ugCS: 25, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 25, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: 8 },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Celtic & Scottish Studies', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Divinity', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Geosciences', 'Human Resource Management', 'Industrial & Systems Engineering', 'Informatics', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-kcl',
    name: 'King\'s College London',
    country: 'UK',
    city: 'London',
    qsRank: 40,
    usNewsRank: 45,
    programs: ['Medicine & Health', 'Law', 'Business & Management', 'Social Sciences', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 33000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 37,
    ielts: 7,
    toefl: 92,
    greRequired: false,
    website: 'https://kcl.ac.uk',
    established: 1829,
    campusType: 'Urban',
    about: 'Russell Group university in central London with strength in law and medicine.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-manchester',
    name: 'University of Manchester',
    country: 'UK',
    city: 'Manchester',
    qsRank: 34,
    usNewsRank: 51,
    programs: ['Engineering', 'Natural Sciences', 'Business & Management', 'Social Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 29000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 56,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://manchester.ac.uk',
    established: 1824,
    campusType: 'Urban',
    about: 'Russell Group with strong business, engineering, and life sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-lse',
    name: 'London School of Economics',
    country: 'UK',
    city: 'London',
    qsRank: 50,
    usNewsRank: 35,
    programs: ['Social Sciences', 'Finance & Accounting', 'Business & Management', 'Law', 'Economics'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 28000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 16,
    ielts: 7.5,
    toefl: 107,
    greRequired: false,
    website: 'https://lse.ac.uk',
    established: 1895,
    campusType: 'Urban',
    about: 'World-leading social science university; consistently top for economics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: 6, qsArtsHum: null },
    availablePrograms: ['Accounting & Auditing', 'Accounting & Finance', 'Actuarial Science', 'Anthropology', 'Applied Economics', 'Behavioral Economics', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Development Economics', 'Development Studies', 'Econometrics', 'Economics', 'Entrepreneurship & Innovation', 'European Studies', 'Finance', 'Financial Engineering', 'Geography', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Policy', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-bristol',
    name: 'University of Bristol',
    country: 'UK',
    city: 'Bristol',
    qsRank: 54,
    usNewsRank: 43,
    programs: ['Engineering', 'Natural Sciences', 'Medicine & Health', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 23000,
    tuitionMax: 27000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 61,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://bristol.ac.uk',
    established: 1909,
    campusType: 'Urban',
    about: 'Russell Group research university known for engineering and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'uk-warwick',
    name: 'University of Warwick',
    country: 'UK',
    city: 'Coventry',
    qsRank: 69,
    usNewsRank: 56,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 29000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 85,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://warwick.ac.uk',
    established: 1965,
    campusType: 'Suburban',
    about: 'Russell Group known for Warwick Business School and economics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-glasgow',
    name: 'University of Glasgow',
    country: 'UK',
    city: 'Glasgow',
    qsRank: 78,
    usNewsRank: 78,
    programs: ['Medicine & Health', 'Engineering', 'Social Sciences', 'Arts & Humanities', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://gla.ac.uk',
    established: 1451,
    campusType: 'Urban',
    about: 'One of Scotland\'s ancient universities; strong in medicine and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-durham',
    name: 'University of Durham',
    country: 'UK',
    city: 'Durham',
    qsRank: 91,
    usNewsRank: 152,
    programs: ['Social Sciences', 'Natural Sciences', 'Arts & Humanities', 'Business & Management', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://dur.ac.uk',
    established: 1832,
    campusType: 'Urban',
    about: 'Russell Group university near Newcastle known for business and humanities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-southampton',
    name: 'University of Southampton',
    country: 'UK',
    city: 'Southampton',
    qsRank: 93,
    usNewsRank: 152,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Medicine & Health', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 70,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://soton.ac.uk',
    established: 1862,
    campusType: 'Suburban',
    about: 'Russell Group known for electronics, engineering, and oceanography.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-leeds',
    name: 'University of Leeds',
    country: 'UK',
    city: 'Leeds',
    qsRank: 97,
    usNewsRank: 152,
    programs: ['Business & Management', 'Engineering', 'Medicine & Health', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 23000,
    tuitionMax: 27000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://leeds.ac.uk',
    established: 1904,
    campusType: 'Urban',
    about: 'Russell Group university in the north of England; strong business school.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-birmingham',
    name: 'University of Birmingham',
    country: 'UK',
    city: 'Birmingham',
    qsRank: 84,
    usNewsRank: 152,
    programs: ['Engineering', 'Medicine & Health', 'Business & Management', 'Natural Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://birmingham.ac.uk',
    established: 1900,
    campusType: 'Suburban',
    about: 'Russell Group research university with strong engineering and medicine.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-sheffield',
    name: 'University of Sheffield',
    country: 'UK',
    city: 'Sheffield',
    qsRank: 105,
    usNewsRank: 152,
    programs: ['Engineering', 'Medicine & Health', 'Natural Sciences', 'Business & Management', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://sheffield.ac.uk',
    established: 1905,
    campusType: 'Urban',
    about: 'Russell Group known for engineering and materials science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-nottingham',
    name: 'University of Nottingham',
    country: 'UK',
    city: 'Nottingham',
    qsRank: 110,
    usNewsRank: 152,
    programs: ['Engineering', 'Medicine & Health', 'Business & Management', 'Agriculture', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 23000,
    tuitionMax: 27000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://nottingham.ac.uk',
    established: 1881,
    campusType: 'Suburban',
    about: 'Russell Group with campuses in the UK, China, and Malaysia.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-qmul',
    name: 'Queen Mary University of London',
    country: 'UK',
    city: 'London',
    qsRank: 125,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Law', 'Engineering', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://qmul.ac.uk',
    established: 1887,
    campusType: 'Urban',
    about: 'Russell Group university in East London; strong in medicine and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-exeter',
    name: 'University of Exeter',
    country: 'UK',
    city: 'Exeter',
    qsRank: 151,
    usNewsRank: 152,
    programs: ['Business & Management', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 75,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://exeter.ac.uk',
    established: 1955,
    campusType: 'Suburban',
    about: 'Russell Group university in South West England known for business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-bath',
    name: 'University of Bath',
    country: 'UK',
    city: 'Bath',
    qsRank: 179,
    usNewsRank: 152,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 23000,
    tuitionMax: 28000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://bath.ac.uk',
    established: 1966,
    campusType: 'Suburban',
    about: 'Strong for engineering and management; excellent employability.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-leicester',
    name: 'University of Leicester',
    country: 'UK',
    city: 'Leicester',
    qsRank: 392,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Business & Management', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 19000,
    tuitionMax: 23000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://le.ac.uk',
    established: 1921,
    campusType: 'Suburban',
    about: 'Research university known for criminology and space research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-reading',
    name: 'University of Reading',
    country: 'UK',
    city: 'Reading',
    qsRank: 246,
    usNewsRank: null,
    programs: ['Business & Management', 'Agriculture', 'Natural Sciences', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 19000,
    tuitionMax: 23000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 85,
    greRequired: false,
    website: 'https://reading.ac.uk',
    established: 1892,
    campusType: 'Suburban',
    about: 'Known for meteorology, agriculture, and finance programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-cardiff',
    name: 'Cardiff University',
    country: 'UK',
    city: 'Cardiff',
    qsRank: 198,
    usNewsRank: 152,
    programs: ['Engineering', 'Medicine & Health', 'Social Sciences', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 21000,
    tuitionMax: 25000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://cardiff.ac.uk',
    established: 1883,
    campusType: 'Urban',
    about: 'Wales\' leading research university; Russell Group member.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-york',
    name: 'University of York',
    country: 'UK',
    city: 'York',
    qsRank: 197,
    usNewsRank: 152,
    programs: ['Social Sciences', 'Natural Sciences', 'Arts & Humanities', 'Engineering', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://york.ac.uk',
    established: 1963,
    campusType: 'Suburban',
    about: 'Russell Group research university known for social sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology', 'Software Engineering'],
  },
  {
    id: 'uk-queens-belfast',
    name: 'Queen\'s University Belfast',
    country: 'UK',
    city: 'Belfast',
    qsRank: 218,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Law', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://qub.ac.uk',
    established: 1845,
    campusType: 'Urban',
    about: 'Northern Ireland\'s leading research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-st-andrews',
    name: 'University of St Andrews',
    country: 'UK',
    city: 'St Andrews',
    qsRank: 104,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Business & Management', 'Medicine & Health', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 30000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://st-andrews.ac.uk',
    established: 1413,
    campusType: 'Urban',
    about: 'Scotland\'s oldest university; prestigious for arts and sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-liverpool',
    name: 'University of Liverpool',
    country: 'UK',
    city: 'Liverpool',
    qsRank: 201,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Natural Sciences', 'Veterinary Medicine'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 75,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://liverpool.ac.uk',
    established: 1881,
    campusType: 'Urban',
    about: 'Russell Group research university known for medicine and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Animal Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health'],
  },
  {
    id: 'uk-newcastle',
    name: 'Newcastle University',
    country: 'UK',
    city: 'Newcastle',
    qsRank: 206,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Agriculture', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 21000,
    tuitionMax: 25000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 76,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://ncl.ac.uk',
    established: 1834,
    campusType: 'Urban',
    about: 'Russell Group university with strength in engineering and medicine.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-aberdeen',
    name: 'University of Aberdeen',
    country: 'UK',
    city: 'Aberdeen',
    qsRank: 252,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Engineering', 'Business & Management', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 85,
    greRequired: false,
    website: 'https://abdn.ac.uk',
    established: 1495,
    campusType: 'Urban',
    about: 'Scotland\'s ancient university with strong energy sector connections.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-strathclyde',
    name: 'University of Strathclyde',
    country: 'UK',
    city: 'Glasgow',
    qsRank: 302,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://strath.ac.uk',
    established: 1796,
    campusType: 'Urban',
    about: 'Entrepreneurial Scottish university; strong in engineering and management.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-brunel',
    name: 'Brunel University London',
    country: 'UK',
    city: 'Uxbridge',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 85,
    greRequired: false,
    website: 'https://brunel.ac.uk',
    established: 1966,
    campusType: 'Suburban',
    about: 'London university known for engineering and technology programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-city',
    name: 'City, University of London',
    country: 'UK',
    city: 'London',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Engineering', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://city.ac.uk',
    established: 1894,
    campusType: 'Urban',
    about: 'London university known for Cass Business School and journalism.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-sussex',
    name: 'University of Sussex',
    country: 'UK',
    city: 'Brighton',
    qsRank: 451,
    usNewsRank: null,
    programs: ['Social Sciences', 'Natural Sciences', 'Arts & Humanities', 'Engineering', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6.5,
    toefl: 85,
    greRequired: false,
    website: 'https://sussex.ac.uk',
    established: 1961,
    campusType: 'Suburban',
    about: 'Research university near Brighton known for social sciences and AI.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'uk-loughborough',
    name: 'Loughborough University',
    country: 'UK',
    city: 'Loughborough',
    qsRank: 251,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Sports Science', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 19000,
    tuitionMax: 23000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://lboro.ac.uk',
    established: 1909,
    campusType: 'Suburban',
    about: 'Consistently top ranked for student experience and sports.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Exercise Physiology & Rehabilitation', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Sports Management', 'Sports Science & Kinesiology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-lancaster',
    name: 'University of Lancaster',
    country: 'UK',
    city: 'Lancaster',
    qsRank: 302,
    usNewsRank: null,
    programs: ['Business & Management', 'Social Sciences', 'Natural Sciences', 'Engineering', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 71,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://lancaster.ac.uk',
    established: 1964,
    campusType: 'Suburban',
    about: 'Red brick university known for management and politics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-surrey',
    name: 'University of Surrey',
    country: 'UK',
    city: 'Guildford',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Hospitality & Tourism'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://surrey.ac.uk',
    established: 1891,
    campusType: 'Suburban',
    about: 'Known for hospitality management and strong industry placements.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Event & Convention Management', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'uk-essex',
    name: 'University of Essex',
    country: 'UK',
    city: 'Colchester',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Social Sciences', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 6,
    toefl: 80,
    greRequired: false,
    website: 'https://essex.ac.uk',
    established: 1964,
    campusType: 'Suburban',
    about: 'Internationally known for politics and social science research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-hull',
    name: 'University of Hull',
    country: 'UK',
    city: 'Hull',
    qsRank: 751,
    usNewsRank: null,
    programs: ['Business & Management', 'Social Sciences', 'Natural Sciences', 'Law', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hull.ac.uk',
    established: 1927,
    campusType: 'Urban',
    about: 'Northern English research university with strong law faculty.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-oxford-brookes',
    name: 'Oxford Brookes University',
    country: 'UK',
    city: 'Oxford',
    qsRank: 1001,
    usNewsRank: null,
    programs: ['Business & Management', 'Architecture', 'Engineering', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://brookes.ac.uk',
    established: 1865,
    campusType: 'Urban',
    about: 'Modern university in Oxford with strong architecture and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Architecture', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'Interior Design', 'International Business', 'International Relations & Diplomacy', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-coventry',
    name: 'Coventry University',
    country: 'UK',
    city: 'Coventry',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 75,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://coventry.ac.uk',
    established: 1843,
    campusType: 'Urban',
    about: 'Modern university known for strong industry links and global campuses.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'International Relations & Diplomacy', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-heriot-watt',
    name: 'Heriot-Watt University',
    country: 'UK',
    city: 'Edinburgh',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Architecture', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://hw.ac.uk',
    established: 1821,
    campusType: 'Suburban',
    about: 'Scottish university known for engineering and Dubai campus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-aston',
    name: 'Aston University',
    country: 'UK',
    city: 'Birmingham',
    qsRank: 551,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 21000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 85,
    greRequired: false,
    website: 'https://aston.ac.uk',
    established: 1895,
    campusType: 'Urban',
    about: 'Birmingham university known for business and optometry.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-uel',
    name: 'University of East London',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uel.ac.uk',
    established: 1898,
    campusType: 'Urban',
    about: 'East London university with diverse student body and strong employability.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-westminster',
    name: 'University of Westminster',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Media & Communications', 'Architecture', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://westminster.ac.uk',
    established: 1838,
    campusType: 'Urban',
    about: 'London university known for media, architecture, and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'Interior Design', 'International Business', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'Landscape Architecture', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-middlesex',
    name: 'Middlesex University',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://mdx.ac.uk',
    established: 1878,
    campusType: 'Urban',
    about: 'London university with campuses in Dubai and Mauritius.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-greenwich',
    name: 'University of Greenwich',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Architecture', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://gre.ac.uk',
    established: 1890,
    campusType: 'Urban',
    about: 'London university on the Thames with strong architecture programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-kingston',
    name: 'Kingston University',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Engineering', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://kingston.ac.uk',
    established: 1899,
    campusType: 'Suburban',
    about: 'South London university known for fashion, art, and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-anglia-ruskin',
    name: 'Anglia Ruskin University',
    country: 'UK',
    city: 'Cambridge',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Medicine & Health', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://aru.ac.uk',
    established: 1858,
    campusType: 'Urban',
    about: 'Modern university in Cambridge and Chelmsford.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-teesside',
    name: 'Teesside University',
    country: 'UK',
    city: 'Middlesbrough',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Medicine & Health', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://tees.ac.uk',
    established: 1930,
    campusType: 'Urban',
    about: 'Northern English university known for digital and creative industries.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-portsmouth',
    name: 'University of Portsmouth',
    country: 'UK',
    city: 'Portsmouth',
    qsRank: 651,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 85,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://port.ac.uk',
    established: 1869,
    campusType: 'Urban',
    about: 'South coast university with strong employability record.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-plymouth',
    name: 'University of Plymouth',
    country: 'UK',
    city: 'Plymouth',
    qsRank: 801,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Business & Management', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://plymouth.ac.uk',
    established: 1862,
    campusType: 'Urban',
    about: 'South West England university known for marine sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-northumbria',
    name: 'Northumbria University',
    country: 'UK',
    city: 'Newcastle',
    qsRank: 801,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://northumbria.ac.uk',
    established: 1969,
    campusType: 'Urban',
    about: 'Modern Newcastle university with strong design and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-huddersfield',
    name: 'University of Huddersfield',
    country: 'UK',
    city: 'Huddersfield',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://hud.ac.uk',
    established: 1841,
    campusType: 'Urban',
    about: 'Yorkshire university known for music technology and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-de-montfort',
    name: 'De Montfort University',
    country: 'UK',
    city: 'Leicester',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://dmu.ac.uk',
    established: 1870,
    campusType: 'Urban',
    about: 'Leicester university known for fashion, law, and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-derby',
    name: 'University of Derby',
    country: 'UK',
    city: 'Derby',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://derby.ac.uk',
    established: 1851,
    campusType: 'Urban',
    about: 'Midlands university with flexible learning and strong vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-salford',
    name: 'University of Salford',
    country: 'UK',
    city: 'Salford',
    qsRank: 801,
    usNewsRank: null,
    programs: ['Engineering', 'Media & Communications', 'Business & Management', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://salford.ac.uk',
    established: 1896,
    campusType: 'Urban',
    about: 'Manchester-area university known for media and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Journalism & Mass Communication', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-uwl',
    name: 'University of West London',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Media & Communications', 'Law', 'Nursing'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uwl.ac.uk',
    established: 1860,
    campusType: 'Urban',
    about: 'West London university known for music, aviation, and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Community Health Nursing', 'Corporate & Commercial Law', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'Journalism & Mass Communication', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Nurse Practitioner', 'Nursing (BSN/MSN)', 'Operations Management', 'Philosophy', 'Project Management', 'Public Relations & Advertising', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-sunderland',
    name: 'University of Sunderland',
    country: 'UK',
    city: 'Sunderland',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Media & Communications', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 90,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://sunderland.ac.uk',
    established: 1901,
    campusType: 'Urban',
    about: 'Northeast England university with affordable tuition.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-wolverhampton',
    name: 'University of Wolverhampton',
    country: 'UK',
    city: 'Wolverhampton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://wlv.ac.uk',
    established: 1992,
    campusType: 'Urban',
    about: 'West Midlands university with wide range of vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-bcu',
    name: 'Birmingham City University',
    country: 'UK',
    city: 'Birmingham',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Engineering', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://bcu.ac.uk',
    established: 1992,
    campusType: 'Urban',
    about: 'Birmingham\'s modern university with strong arts and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'au-melb',
    name: 'University of Melbourne',
    country: 'AUSTRALIA',
    city: 'Melbourne',
    qsRank: 13,
    usNewsRank: 33,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Law', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 40000,
    tuitionMax: 48000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 35,
    ielts: 7,
    toefl: 94,
    greRequired: false,
    website: 'https://unimelb.edu.au',
    established: 1853,
    campusType: 'Suburban',
    about: 'Australia\'s top-ranked research university and a global leader.',
    rankings: { ugCS: 18, ugEngineering: 19, ugBusiness: 18, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 18, qsEngineering: 19, qsBusiness: 18, qsNaturalSci: 15, qsSocialSci: 13, qsArtsHum: 14 },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Social Work', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)'],
  },
  {
    id: 'au-sydney',
    name: 'University of Sydney',
    country: 'AUSTRALIA',
    city: 'Sydney',
    qsRank: 18,
    usNewsRank: 49,
    programs: ['Medicine & Health', 'Business & Management', 'Law', 'Engineering', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 40000,
    tuitionMax: 48000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 94,
    greRequired: false,
    website: 'https://sydney.edu.au',
    established: 1850,
    campusType: 'Urban',
    about: 'Australia\'s first university; renowned for medicine, law, and business.',
    rankings: { ugCS: 23, ugEngineering: 24, ugBusiness: 22, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 23, qsEngineering: 24, qsBusiness: 22, qsNaturalSci: 20, qsSocialSci: 17, qsArtsHum: 17 },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Pharmacy (PharmD/BPharm)', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Science'],
  },
  {
    id: 'au-unsw',
    name: 'University of New South Wales',
    country: 'AUSTRALIA',
    city: 'Sydney',
    qsRank: 19,
    usNewsRank: 49,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Medicine & Health', 'Law', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 42000,
    tuitionMax: 50000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 32,
    ielts: 7,
    toefl: 94,
    greRequired: false,
    website: 'https://unsw.edu.au',
    established: 1949,
    campusType: 'Urban',
    about: 'Leading engineering and business university in Sydney.',
    rankings: { ugCS: 27, ugEngineering: 27, ugBusiness: 27, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 27, qsEngineering: 27, qsBusiness: 27, qsNaturalSci: 23, qsSocialSci: 20, qsArtsHum: 20 },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Optometry', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Quantitative Analytics', 'Social Work', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-anu',
    name: 'Australian National University',
    country: 'AUSTRALIA',
    city: 'Canberra',
    qsRank: 30,
    usNewsRank: 52,
    programs: ['Natural Sciences', 'Social Sciences', 'Business & Management', 'Engineering', 'Arts & Humanities', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 41000,
    tuitionMax: 49000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 35,
    ielts: 7,
    toefl: 94,
    greRequired: false,
    website: 'https://anu.edu.au',
    established: 1946,
    campusType: 'Suburban',
    about: 'Australia\'s national research university in the capital.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: 25, qsSocialSci: 18, qsArtsHum: 19 },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Archaeology', 'Art & Design', 'Art History & Curatorship', 'Asia-Pacific Studies', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Diplomatic Studies', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Security Studies', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-qut',
    name: 'Queensland University of Technology',
    country: 'AUSTRALIA',
    city: 'Brisbane',
    qsRank: 407,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Education', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 32000,
    tuitionMax: 38000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://qut.edu.au',
    established: 1989,
    campusType: 'Urban',
    about: 'Brisbane\'s technology-focused university with strong industry links.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-uq',
    name: 'University of Queensland',
    country: 'AUSTRALIA',
    city: 'Brisbane',
    qsRank: 40,
    usNewsRank: 52,
    programs: ['Natural Sciences', 'Medicine & Health', 'Business & Management', 'Engineering', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 41000,
    tuitionMax: 49000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 32,
    ielts: 7,
    toefl: 94,
    greRequired: false,
    website: 'https://uq.edu.au',
    established: 1909,
    campusType: 'Suburban',
    about: 'Top Queensland research university with strong sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-monash',
    name: 'Monash University',
    country: 'AUSTRALIA',
    city: 'Melbourne',
    qsRank: 37,
    usNewsRank: 80,
    programs: ['Engineering', 'Business & Management', 'Medicine & Health', 'Law', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 40000,
    tuitionMax: 47000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 44,
    ielts: 7,
    toefl: 94,
    greRequired: false,
    website: 'https://monash.edu',
    established: 1958,
    campusType: 'Suburban',
    about: 'Major Victorian research university with campuses globally.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-uts',
    name: 'University of Technology Sydney',
    country: 'AUSTRALIA',
    city: 'Sydney',
    qsRank: 137,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 36000,
    tuitionMax: 44000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 53,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uts.edu.au',
    established: 1988,
    campusType: 'Urban',
    about: 'Industry-focused tech university in central Sydney.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-adelaide',
    name: 'University of Adelaide',
    country: 'AUSTRALIA',
    city: 'Adelaide',
    qsRank: 109,
    usNewsRank: 152,
    programs: ['Engineering', 'Medicine & Health', 'Natural Sciences', 'Business & Management', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 37000,
    tuitionMax: 44000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 67,
    ielts: 6.5,
    toefl: 94,
    greRequired: false,
    website: 'https://adelaide.edu.au',
    established: 1874,
    campusType: 'Urban',
    about: 'Sandstone research university in South Australia.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-curtin',
    name: 'Curtin University',
    country: 'AUSTRALIA',
    city: 'Perth',
    qsRank: 198,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 36000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://curtin.edu.au',
    established: 1966,
    campusType: 'Suburban',
    about: 'Western Australia\'s largest university with strong engineering focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'au-wa',
    name: 'University of Western Australia',
    country: 'AUSTRALIA',
    city: 'Perth',
    qsRank: 82,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Engineering', 'Business & Management', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 45000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 80,
    ielts: 6.5,
    toefl: 94,
    greRequired: false,
    website: 'https://uwa.edu.au',
    established: 1911,
    campusType: 'Suburban',
    about: 'Sandstone research university in Perth, WA.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-rmit',
    name: 'RMIT University',
    country: 'AUSTRALIA',
    city: 'Melbourne',
    qsRank: 227,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 31000,
    tuitionMax: 38000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://rmit.edu.au',
    established: 1887,
    campusType: 'Urban',
    about: 'Melbourne\'s applied and industry-focused research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'au-macquarie',
    name: 'Macquarie University',
    country: 'AUSTRALIA',
    city: 'Sydney',
    qsRank: 141,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Computer Science & IT', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 36000,
    tuitionMax: 43000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://mq.edu.au',
    established: 1964,
    campusType: 'Suburban',
    about: 'Sydney research university known for finance and cognitive science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-deakin',
    name: 'Deakin University',
    country: 'AUSTRALIA',
    city: 'Geelong',
    qsRank: 251,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 36000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://deakin.edu.au',
    established: 1974,
    campusType: 'Suburban',
    about: 'Victorian university known for online learning and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-griffith',
    name: 'Griffith University',
    country: 'AUSTRALIA',
    city: 'Brisbane',
    qsRank: 324,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Engineering', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 71,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://griffith.edu.au',
    established: 1971,
    campusType: 'Suburban',
    about: 'Brisbane multi-campus university with strong criminology and arts.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-latrobe',
    name: 'La Trobe University',
    country: 'AUSTRALIA',
    city: 'Melbourne',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Business & Management', 'Social Sciences', 'Engineering', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://latrobe.edu.au',
    established: 1964,
    campusType: 'Suburban',
    about: 'Melbourne university with campuses across regional Victoria.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-flinders',
    name: 'Flinders University',
    country: 'AUSTRALIA',
    city: 'Adelaide',
    qsRank: 451,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Business & Management', 'Engineering', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 33000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://flinders.edu.au',
    established: 1966,
    campusType: 'Suburban',
    about: 'South Australian university known for medicine and innovation.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-newcastle',
    name: 'University of Newcastle',
    country: 'AUSTRALIA',
    city: 'Newcastle, NSW',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Medicine & Health', 'Business & Management', 'Natural Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 33000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://newcastle.edu.au',
    established: 1965,
    campusType: 'Urban',
    about: 'NSW regional research university with strong engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-tasmania',
    name: 'University of Tasmania',
    country: 'AUSTRALIA',
    city: 'Hobart',
    qsRank: 554,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Medicine & Health', 'Business & Management', 'Engineering', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 33000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 77,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://utas.edu.au',
    established: 1890,
    campusType: 'Suburban',
    about: 'Australia\'s fourth-oldest university with strong maritime research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-wollongong',
    name: 'University of Wollongong',
    country: 'AUSTRALIA',
    city: 'Wollongong',
    qsRank: 193,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 36000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 57,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uow.edu.au',
    established: 1951,
    campusType: 'Urban',
    about: 'NSW university known for engineering and innovative research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-scu',
    name: 'Southern Cross University',
    country: 'AUSTRALIA',
    city: 'Lismore, NSW',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Medicine & Health', 'Education', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 28000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://scu.edu.au',
    established: 1994,
    campusType: 'Suburban',
    about: 'Regional NSW university known for environmental science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Curriculum & Instruction', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-jcu',
    name: 'James Cook University',
    country: 'AUSTRALIA',
    city: 'Townsville, QLD',
    qsRank: 435,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Medicine & Health', 'Business & Management', 'Engineering', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 77,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://jcu.edu.au',
    established: 1970,
    campusType: 'Suburban',
    about: 'Tropical Australian university known for marine and environmental sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-cqu',
    name: 'CQUniversity',
    country: 'AUSTRALIA',
    city: 'Rockhampton, QLD',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 23000,
    tuitionMax: 27000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://cqu.edu.au',
    established: 1992,
    campusType: 'Suburban',
    about: 'Central Queensland university with broad vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-torrens',
    name: 'Torrens University',
    country: 'AUSTRALIA',
    city: 'Adelaide',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Hospitality & Tourism', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 31000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 90,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://torrens.edu.au',
    established: 2013,
    campusType: 'Urban',
    about: 'Private Australian university with focus on entrepreneurship.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food & Beverage Management', 'History', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'au-bond',
    name: 'Bond University',
    country: 'AUSTRALIA',
    city: 'Gold Coast, QLD',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 42000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 30,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://bond.edu.au',
    established: 1989,
    campusType: 'Suburban',
    about: 'Australia\'s first private not-for-profit university on the Gold Coast.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-toronto',
    name: 'University of Toronto',
    country: 'CANADA',
    city: 'Toronto, ON',
    qsRank: 25,
    usNewsRank: 18,
    programs: ['Computer Science & IT', 'Engineering', 'Medicine & Health', 'Business & Management', 'Natural Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 42000,
    tuitionMax: 55000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://utoronto.ca',
    established: 1827,
    campusType: 'Urban',
    about: 'Canada\'s top research university; globally recognised for STEM.',
    rankings: { ugCS: 20, ugEngineering: 22, ugBusiness: 25, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 20, qsEngineering: 22, qsBusiness: 25, qsNaturalSci: 17, qsSocialSci: 14, qsArtsHum: 13 },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Forestry', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Science', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Pharmacy (PharmD/BPharm)', 'Physics', 'Project Management', 'Public Health (MPH)', 'Social Work', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-mcgill',
    name: 'McGill University',
    country: 'CANADA',
    city: 'Montreal, QC',
    qsRank: 29,
    usNewsRank: 27,
    programs: ['Medicine & Health', 'Engineering', 'Law', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 44000,
    tuitionMax: 52000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 46,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://mcgill.ca',
    established: 1821,
    campusType: 'Urban',
    about: 'Prestigious Montreal university known as the \'Harvard of Canada\'.',
    rankings: { ugCS: 35, ugEngineering: 38, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 35, qsEngineering: 38, qsBusiness: null, qsNaturalSci: 28, qsSocialSci: 24, qsArtsHum: 22 },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Pharmacy (PharmD/BPharm)', 'Physics', 'Project Management', 'Public Health (MPH)', 'Religious Studies', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-ubc',
    name: 'University of British Columbia',
    country: 'CANADA',
    city: 'Vancouver, BC',
    qsRank: 38,
    usNewsRank: 35,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 40000,
    tuitionMax: 50000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 52,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://ubc.ca',
    established: 1908,
    campusType: 'Suburban',
    about: 'Top Pacific Rim research university with beautiful campus.',
    rankings: { ugCS: 25, ugEngineering: 28, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 25, qsEngineering: 28, qsBusiness: null, qsNaturalSci: 22, qsSocialSci: 19, qsArtsHum: 18 },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Food & Nutritional Sciences', 'Forestry', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Pharmacy (PharmD/BPharm)', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-alberta',
    name: 'University of Alberta',
    country: 'CANADA',
    city: 'Edmonton, AB',
    qsRank: 111,
    usNewsRank: 78,
    programs: ['Engineering', 'Natural Sciences', 'Business & Management', 'Medicine & Health', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://ualberta.ca',
    established: 1908,
    campusType: 'Suburban',
    about: 'Top Alberta research university with strong energy sector links.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-waterloo',
    name: 'University of Waterloo',
    country: 'CANADA',
    city: 'Waterloo, ON',
    qsRank: 112,
    usNewsRank: 175,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Mathematics'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 37000,
    tuitionMax: 46000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 56,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://uwaterloo.ca',
    established: 1957,
    campusType: 'Suburban',
    about: 'Canada\'s top engineering and CS university; renowned co-op program.',
    rankings: { ugCS: 30, ugEngineering: 35, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 30, qsEngineering: 35, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Actuarial Science', 'Aerospace Engineering', 'Applied Mathematics', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mathematics', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Operations Research', 'Physics', 'Project Management', 'Software Engineering', 'Statistics & Data Analysis', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-western',
    name: 'Western University',
    country: 'CANADA',
    city: 'London, ON',
    qsRank: 203,
    usNewsRank: 175,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 33000,
    tuitionMax: 41000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 58,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://uwo.ca',
    established: 1878,
    campusType: 'Suburban',
    about: 'Ontario research university known for Ivey Business School.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-queens',
    name: 'Queen\'s University',
    country: 'CANADA',
    city: 'Kingston, ON',
    qsRank: 246,
    usNewsRank: 175,
    programs: ['Business & Management', 'Engineering', 'Medicine & Health', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 44000,
    tuitionMax: 53000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 42,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://queensu.ca',
    established: 1841,
    campusType: 'Urban',
    about: 'Prestigious Ontario university known for Smith School of Business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-mcmaster',
    name: 'McMaster University',
    country: 'CANADA',
    city: 'Hamilton, ON',
    qsRank: 152,
    usNewsRank: 78,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 30000,
    tuitionMax: 38000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 69,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://mcmaster.ca',
    established: 1887,
    campusType: 'Suburban',
    about: 'Ontario research university known for DeGroote Business School.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-dalhousie',
    name: 'Dalhousie University',
    country: 'CANADA',
    city: 'Halifax, NS',
    qsRank: 272,
    usNewsRank: 175,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Law', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 23000,
    tuitionMax: 29000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 67,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://dal.ca',
    established: 1818,
    campusType: 'Urban',
    about: 'Atlantic Canada\'s leading research university in Halifax.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-simon-fraser',
    name: 'Simon Fraser University',
    country: 'CANADA',
    city: 'Burnaby, BC',
    qsRank: 318,
    usNewsRank: 201,
    programs: ['Computer Science & IT', 'Business & Management', 'Engineering', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 27000,
    tuitionMax: 33000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 65,
    ielts: 7,
    toefl: 79,
    greRequired: false,
    website: 'https://sfu.ca',
    established: 1965,
    campusType: 'Suburban',
    about: 'BC research university known for technology and entrepreneurship.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-calgary',
    name: 'University of Calgary',
    country: 'CANADA',
    city: 'Calgary, AB',
    qsRank: 246,
    usNewsRank: 175,
    programs: ['Engineering', 'Business & Management', 'Law', 'Medicine & Health', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 22000,
    tuitionMax: 28000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 69,
    ielts: 7,
    toefl: 86,
    greRequired: false,
    website: 'https://ucalgary.ca',
    established: 1966,
    campusType: 'Suburban',
    about: 'Alberta research university with strong energy and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-ottawa',
    name: 'University of Ottawa',
    country: 'CANADA',
    city: 'Ottawa, ON',
    qsRank: 277,
    usNewsRank: 175,
    programs: ['Law', 'Social Sciences', 'Business & Management', 'Medicine & Health', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 27000,
    tuitionMax: 33000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 59,
    ielts: 7,
    toefl: 86,
    greRequired: false,
    website: 'https://uottawa.ca',
    established: 1848,
    campusType: 'Urban',
    about: 'Canada\'s bilingual university in the national capital.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-laval',
    name: 'Université Laval',
    country: 'CANADA',
    city: 'Quebec City, QC',
    qsRank: 501,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Engineering', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 20000,
    tuitionMax: 26000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 69,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ulaval.ca',
    established: 1663,
    campusType: 'Suburban',
    about: 'Canada\'s oldest French-language university in Quebec City.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-concordia',
    name: 'Concordia University',
    country: 'CANADA',
    city: 'Montreal, QC',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 22000,
    tuitionMax: 28000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 67,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://concordia.ca',
    established: 1974,
    campusType: 'Urban',
    about: 'Montreal university known for business and creative arts.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-manitoba',
    name: 'University of Manitoba',
    country: 'CANADA',
    city: 'Winnipeg, MB',
    qsRank: 651,
    usNewsRank: null,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Medicine & Health', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 67,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://umanitoba.ca',
    established: 1877,
    campusType: 'Suburban',
    about: 'Prairie research university with strong agriculture and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-victoria',
    name: 'University of Victoria',
    country: 'CANADA',
    city: 'Victoria, BC',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Business & Management', 'Engineering', 'Natural Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 21000,
    tuitionMax: 27000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 71,
    ielts: 7,
    toefl: 79,
    greRequired: false,
    website: 'https://uvic.ca',
    established: 1963,
    campusType: 'Suburban',
    about: 'BC research university known for tech and environment programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-guelph',
    name: 'University of Guelph',
    country: 'CANADA',
    city: 'Guelph, ON',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Agriculture', 'Veterinary Medicine', 'Business & Management', 'Engineering', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 22000,
    tuitionMax: 28000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 73,
    ielts: 7,
    toefl: 89,
    greRequired: false,
    website: 'https://uoguelph.ca',
    established: 1964,
    campusType: 'Suburban',
    about: 'Ontario university known for veterinary medicine and agriculture.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Animal Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health'],
  },
  {
    id: 'ca-ryerson',
    name: 'Toronto Metropolitan University',
    country: 'CANADA',
    city: 'Toronto, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 25000,
    tuitionMax: 32000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 60,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://torontomu.ca',
    established: 1948,
    campusType: 'Urban',
    about: 'Urban Toronto university focused on professional and applied programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-york',
    name: 'York University',
    country: 'CANADA',
    city: 'Toronto, ON',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 23000,
    tuitionMax: 29000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 69,
    ielts: 7,
    toefl: 79,
    greRequired: false,
    website: 'https://yorku.ca',
    established: 1959,
    campusType: 'Suburban',
    about: 'Toronto\'s second largest university with strong business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-nb',
    name: 'University of New Brunswick',
    country: 'CANADA',
    city: 'Fredericton, NB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Education', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 73,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unb.ca',
    established: 1785,
    campusType: 'Suburban',
    about: 'Canada\'s first English-language university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-carleton',
    name: 'Carleton University',
    country: 'CANADA',
    city: 'Ottawa, ON',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 24000,
    tuitionMax: 29000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 67,
    ielts: 7,
    toefl: 86,
    greRequired: false,
    website: 'https://carleton.ca',
    established: 1942,
    campusType: 'Suburban',
    about: 'Ottawa university known for journalism and aerospace engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-windsor',
    name: 'University of Windsor',
    country: 'CANADA',
    city: 'Windsor, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Law', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 20000,
    tuitionMax: 26000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 68,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uwindsor.ca',
    established: 1857,
    campusType: 'Urban',
    about: 'Ontario university near Detroit with strong engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-brock',
    name: 'Brock University',
    country: 'CANADA',
    city: 'St. Catharines, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 17000,
    tuitionMax: 21000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://brocku.ca',
    established: 1964,
    campusType: 'Suburban',
    about: 'Niagara region university with wine education and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-trent',
    name: 'Trent University',
    country: 'CANADA',
    city: 'Peterborough, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Education', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 17000,
    tuitionMax: 21000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://trentu.ca',
    established: 1963,
    campusType: 'Suburban',
    about: 'Small liberal arts university with strong environmental sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-nipissing',
    name: 'Nipissing University',
    country: 'CANADA',
    city: 'North Bay, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Education', 'Business & Management', 'Social Sciences', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://nipissingu.ca',
    established: 1992,
    campusType: 'Suburban',
    about: 'Smaller Ontario university known for education programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-algoma',
    name: 'Algoma University',
    country: 'CANADA',
    city: 'Sault Ste. Marie, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Social Sciences', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 85,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://algomau.ca',
    established: 1965,
    campusType: 'Urban',
    about: 'Northern Ontario university with Indigenous education focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-bcit',
    name: 'British Columbia Institute of Technology',
    country: 'CANADA',
    city: 'Burnaby, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Architecture', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 22000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://bcit.ca',
    established: 1964,
    campusType: 'Suburban',
    about: 'BC\'s largest applied tech institute; focused on industry-ready graduates.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ca-seneca',
    name: 'Seneca Polytechnic',
    country: 'CANADA',
    city: 'Toronto, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Arts & Humanities', 'Hospitality & Tourism'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://senecapolytechnic.ca',
    established: 1967,
    campusType: 'Suburban',
    about: 'Large Toronto college with strong applied and vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food & Beverage Management', 'History', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'ca-humber',
    name: 'Humber College',
    country: 'CANADA',
    city: 'Toronto, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://humber.ca',
    established: 1967,
    campusType: 'Urban',
    about: 'Toronto college known for creative arts, business, and technology.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-georgebrown',
    name: 'George Brown College',
    country: 'CANADA',
    city: 'Toronto, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Culinary Arts', 'Engineering', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://georgebrown.ca',
    established: 1967,
    campusType: 'Urban',
    about: 'Toronto college in the heart of the city known for culinary and tech.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Culinary Arts & Gastronomy', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food Science & Technology', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Restaurant & Food Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-sheridan',
    name: 'Sheridan College',
    country: 'CANADA',
    city: 'Brampton, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Computer Science & IT', 'Business & Management', 'Engineering', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 17000,
    tuitionMax: 21000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sheridancollege.ca',
    established: 1967,
    campusType: 'Suburban',
    about: 'Top Ontario animation and design college.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-langara',
    name: 'Langara College',
    country: 'CANADA',
    city: 'Vancouver, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://langara.ca',
    established: 1970,
    campusType: 'Urban',
    about: 'Vancouver college known as a pathway to UBC and SFU.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-douglas',
    name: 'Douglas College',
    country: 'CANADA',
    city: 'New Westminster, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 77,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://douglascollege.ca',
    established: 1970,
    campusType: 'Urban',
    about: 'BC Lower Mainland college with strong pathway programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-tcd',
    name: 'Trinity College Dublin',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: 81,
    usNewsRank: 152,
    programs: ['Computer Science & IT', 'Business & Management', 'Law', 'Natural Sciences', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 28000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 50,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://tcd.ie',
    established: 1592,
    campusType: 'Urban',
    about: 'Ireland\'s oldest and most prestigious university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-ucd',
    name: 'University College Dublin',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: 181,
    usNewsRank: 152,
    programs: ['Business & Management', 'Engineering', 'Agriculture', 'Law', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 26000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 59,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://ucd.ie',
    established: 1854,
    campusType: 'Suburban',
    about: 'Ireland\'s largest research university with global alumni network.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-ucc',
    name: 'University College Cork',
    country: 'IRELAND',
    city: 'Cork',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Law', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 22000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 64,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://ucc.ie',
    established: 1845,
    campusType: 'Suburban',
    about: 'Leading Irish research university in the south of Ireland.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-nuig',
    name: 'University of Galway',
    country: 'IRELAND',
    city: 'Galway',
    qsRank: 301,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Engineering', 'Business & Management', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 22000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 65,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://universityofgalway.ie',
    established: 1845,
    campusType: 'Suburban',
    about: 'West of Ireland research university; bilingual English/Irish.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-dcu',
    name: 'Dublin City University',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: 431,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Media & Communications', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://dcu.ie',
    established: 1975,
    campusType: 'Suburban',
    about: 'Dublin university known for communications, technology, and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ie-ul',
    name: 'University of Limerick',
    country: 'IRELAND',
    city: 'Limerick',
    qsRank: 501,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 22000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 70,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://ul.ie',
    established: 1972,
    campusType: 'Suburban',
    about: 'Limerick university with top co-op programs and technology focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ie-maynooth',
    name: 'Maynooth University',
    country: 'IRELAND',
    city: 'Maynooth, Co. Kildare',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Social Sciences', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 69,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://maynoothuniversity.ie',
    established: 1795,
    campusType: 'Suburban',
    about: 'Ireland\'s fastest growing research university near Dublin.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-dit',
    name: 'Technological University Dublin',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://tudublin.ie',
    established: 2019,
    campusType: 'Urban',
    about: 'Dublin\'s largest applied technology university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ie-gmit',
    name: 'Atlantic Technological University',
    country: 'IRELAND',
    city: 'Galway',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 76,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://atu.ie',
    established: 2022,
    campusType: 'Suburban',
    about: 'Atlantic technological university serving the west of Ireland.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-iadt',
    name: 'IADT Dun Laoghaire',
    country: 'IRELAND',
    city: 'Dun Laoghaire, Co. Dublin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Media & Communications', 'Computer Science & IT', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://iadt.ie',
    established: 1997,
    campusType: 'Suburban',
    about: 'Creative media and design college near Dublin.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-rcsi',
    name: 'Royal College of Surgeons in Ireland',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Pharmacy'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 45000,
    tuitionMax: 55000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 25,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://rcsi.com',
    established: 1784,
    campusType: 'Urban',
    about: 'Elite medical school in Dublin attracting global students.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Clinical Pharmacy', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmaceutical Sciences', 'Pharmacy', 'Pharmacy (PharmD/BPharm)', 'Physics', 'Public Health (MPH)'],
  },
  {
    id: 'ie-ncad',
    name: 'National College of Art and Design',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Architecture', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 9000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 80,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ncad.ie',
    established: 1746,
    campusType: 'Urban',
    about: 'Ireland\'s national arts and design institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Architecture', 'Art History & Curatorship', 'Broadcasting & Media Production', 'Digital Media & Content', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Interior Design', 'Journalism & Mass Communication', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'Music & Performing Arts', 'Philosophy', 'Public Relations & Advertising', 'Urban & Regional Planning'],
  },
  {
    id: 'ie-smurfit',
    name: 'UCD Michael Smurfit Business School',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 35000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://smurfitschool.ie',
    established: 1964,
    campusType: 'Suburban',
    about: 'Ireland\'s top business school; consistently ranked globally.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-setu',
    name: 'South East Technological University',
    country: 'IRELAND',
    city: 'Waterford',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://setu.ie',
    established: 2022,
    campusType: 'Urban',
    about: 'New technological university for the south east of Ireland.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-mtu',
    name: 'Munster Technological University',
    country: 'IRELAND',
    city: 'Cork',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mtu.ie',
    established: 2021,
    campusType: 'Urban',
    about: 'Multi-campus tech university in Cork and Kerry.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'de-tum',
    name: 'Technical University of Munich',
    country: 'GERMANY',
    city: 'Munich',
    qsRank: 37,
    usNewsRank: 52,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://tum.de',
    established: 1868,
    campusType: 'Urban',
    about: 'Germany\'s top technical university; consistently ranked globally.',
    rankings: { ugCS: 15, ugEngineering: 15, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 15, qsEngineering: 15, qsBusiness: null, qsNaturalSci: 22, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Brewing & Food Technology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Geodesy & Geoinformation', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Sports Science & Health', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-lmu',
    name: 'Ludwig Maximilian University Munich',
    country: 'GERMANY',
    city: 'Munich',
    qsRank: 54,
    usNewsRank: 56,
    programs: ['Medicine & Health', 'Natural Sciences', 'Business & Management', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 45,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://lmu.de',
    established: 1472,
    campusType: 'Urban',
    about: 'Bavaria\'s largest university; excellent across all disciplines.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-heidelberg',
    name: 'Heidelberg University',
    country: 'GERMANY',
    city: 'Heidelberg',
    qsRank: 87,
    usNewsRank: 78,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 40,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-heidelberg.de',
    established: 1386,
    campusType: 'Urban',
    about: 'Germany\'s oldest university; renowned for natural sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'de-berlin-fu',
    name: 'Freie Universität Berlin',
    country: 'GERMANY',
    city: 'Berlin',
    qsRank: 98,
    usNewsRank: 78,
    programs: ['Social Sciences', 'Arts & Humanities', 'Natural Sciences', 'Medicine & Health', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 42,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://fu-berlin.de',
    established: 1948,
    campusType: 'Suburban',
    about: 'Major Berlin research university with strong humanities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'de-humboldt',
    name: 'Humboldt University of Berlin',
    country: 'GERMANY',
    city: 'Berlin',
    qsRank: 128,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Law', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://hu-berlin.de',
    established: 1810,
    campusType: 'Urban',
    about: 'Historic Berlin university; 41 Nobel laureate alumni.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'de-tu-berlin',
    name: 'Technical University of Berlin',
    country: 'GERMANY',
    city: 'Berlin',
    qsRank: 154,
    usNewsRank: 152,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 48,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://tu.berlin',
    established: 1879,
    campusType: 'Urban',
    about: 'Major Berlin tech university with strong engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'de-rwth',
    name: 'RWTH Aachen University',
    country: 'GERMANY',
    city: 'Aachen',
    qsRank: 106,
    usNewsRank: 152,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 52,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://rwth-aachen.de',
    established: 1870,
    campusType: 'Urban',
    about: 'Germany\'s largest technical university; top for engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-karlsruhe',
    name: 'Karlsruhe Institute of Technology',
    country: 'GERMANY',
    city: 'Karlsruhe',
    qsRank: 116,
    usNewsRank: 152,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 58,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://kit.edu',
    established: 1825,
    campusType: 'Suburban',
    about: 'German national research centre; top for engineering and CS.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-stuttgart',
    name: 'University of Stuttgart',
    country: 'GERMANY',
    city: 'Stuttgart',
    qsRank: 383,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 58,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-stuttgart.de',
    established: 1829,
    campusType: 'Urban',
    about: 'Baden-Württemberg university with strong automotive engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'de-mannheim',
    name: 'University of Mannheim',
    country: 'GERMANY',
    city: 'Mannheim',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Business & Management', 'Social Sciences', 'Finance & Accounting', 'Law', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 45,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-mannheim.de',
    established: 1907,
    campusType: 'Urban',
    about: 'Germany\'s top business university; consistent European rankings.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-frankfurt',
    name: 'Goethe University Frankfurt',
    country: 'GERMANY',
    city: 'Frankfurt',
    qsRank: 301,
    usNewsRank: null,
    programs: ['Finance & Accounting', 'Business & Management', 'Medicine & Health', 'Natural Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-frankfurt.de',
    established: 1914,
    campusType: 'Urban',
    about: 'Frankfurt university near Europe\'s financial centre.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Risk Management & Insurance', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-cologne',
    name: 'University of Cologne',
    country: 'GERMANY',
    city: 'Cologne',
    qsRank: 350,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-koeln.de',
    established: 1388,
    campusType: 'Urban',
    about: 'One of Germany\'s largest universities by student population.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-bonn',
    name: 'University of Bonn',
    country: 'GERMANY',
    city: 'Bonn',
    qsRank: 259,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Law', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 45,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-bonn.de',
    established: 1818,
    campusType: 'Urban',
    about: 'Former German capital\'s prestigious research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'de-hamburg',
    name: 'University of Hamburg',
    country: 'GERMANY',
    city: 'Hamburg',
    qsRank: 254,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Business & Management', 'Law', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 44,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-hamburg.de',
    established: 1919,
    campusType: 'Urban',
    about: 'North Germany\'s largest university in the port city.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-freiburg',
    name: 'University of Freiburg',
    country: 'GERMANY',
    city: 'Freiburg im Breisgau',
    qsRank: 186,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Medicine & Health', 'Engineering', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-freiburg.de',
    established: 1457,
    campusType: 'Urban',
    about: 'Picturesque Black Forest university with strong research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Public Health (MPH)'],
  },
  {
    id: 'de-tu-dresden',
    name: 'Technical University Dresden',
    country: 'GERMANY',
    city: 'Dresden',
    qsRank: 319,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 58,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://tu-dresden.de',
    established: 1828,
    campusType: 'Urban',
    about: 'Saxon technical university with strong engineering and medicine.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Pharmacy', 'Physics', 'Public Health (MPH)', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'de-darmstadt',
    name: 'Technical University Darmstadt',
    country: 'GERMANY',
    city: 'Darmstadt',
    qsRank: 414,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 55,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://tu-darmstadt.de',
    established: 1877,
    campusType: 'Suburban',
    about: 'Major German tech university known for electrical engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-erlangen',
    name: 'Friedrich-Alexander University Erlangen-Nuremberg',
    country: 'GERMANY',
    city: 'Erlangen',
    qsRank: 247,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Medicine & Health', 'Business & Management', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 48,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://fau.de',
    established: 1742,
    campusType: 'Urban',
    about: 'Bavaria\'s second largest university with strong tech focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-munich-hsg',
    name: 'Munich Business School',
    country: 'GERMANY',
    city: 'Munich',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 50,
    ielts: 6.5,
    toefl: 85,
    greRequired: false,
    website: 'https://munich-business-school.de',
    established: 1991,
    campusType: 'Urban',
    about: 'Private business school in Munich with international programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-eu-bus',
    name: 'EU Business School Germany',
    country: 'GERMANY',
    city: 'Munich',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 25000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://euruni.edu',
    established: 1973,
    campusType: 'Urban',
    about: 'International business school with campuses across Europe.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-hfu',
    name: 'Hochschule Furtwangen University',
    country: 'GERMANY',
    city: 'Furtwangen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 67,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://hs-furtwangen.de',
    established: 1850,
    campusType: 'Rural',
    about: 'Applied science university known for tech innovation.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-reutlingen',
    name: 'Reutlingen University',
    country: 'GERMANY',
    city: 'Reutlingen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 62,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://reutlingen-university.de',
    established: 1855,
    campusType: 'Suburban',
    about: 'Baden-Württemberg university of applied sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-nordakademie',
    name: 'Nordakademie University',
    country: 'GERMANY',
    city: 'Elmshorn',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 61,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://nordakademie.de',
    established: 1992,
    campusType: 'Suburban',
    about: 'Private German business and tech school near Hamburg.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-iu',
    name: 'IU International University',
    country: 'GERMANY',
    city: 'Berlin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Psychology', 'Engineering', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 77,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://iu.de',
    established: 1998,
    campusType: 'Urban',
    about: 'Germany\'s largest private university with strong online programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Clinical Psychology', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Counselling Psychology', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Organizational Psychology', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-esb',
    name: 'ESB Business School Reutlingen',
    country: 'GERMANY',
    city: 'Reutlingen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 60,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://esb-business-school.de',
    established: 1971,
    campusType: 'Suburban',
    about: 'Top German international business school with exchange programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-psl',
    name: 'PSL Research University Paris',
    country: 'FRANCE',
    city: 'Paris',
    qsRank: 24,
    usNewsRank: 47,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 20,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://psl.eu',
    established: 2010,
    campusType: 'Urban',
    about: 'Elite Paris federation: ENS, Dauphine, Mines, Observatoire.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-saclay',
    name: 'Université Paris-Saclay',
    country: 'FRANCE',
    city: 'Paris',
    qsRank: 15,
    usNewsRank: 30,
    programs: ['Engineering', 'Natural Sciences', 'Computer Science & IT', 'Data Science & AI', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 8000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 22,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://universite-paris-saclay.fr',
    established: 2014,
    campusType: 'Suburban',
    about: 'France\'s largest research cluster; top for STEM globally.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Pharmacy', 'Physics', 'Public Health (MPH)', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'fr-sorbonne',
    name: 'Sorbonne University',
    country: 'FRANCE',
    city: 'Paris',
    qsRank: 73,
    usNewsRank: 56,
    programs: ['Natural Sciences', 'Medicine & Health', 'Arts & Humanities', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 8000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://sorbonne-universite.fr',
    established: 1150,
    campusType: 'Urban',
    about: 'Medieval university revived; Paris\'s top broad research institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'fr-ecole-poly',
    name: 'École Polytechnique',
    country: 'FRANCE',
    city: 'Palaiseau',
    qsRank: 52,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Computer Science & IT', 'Data Science & AI', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 20000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 15,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://polytechnique.edu',
    established: 1794,
    campusType: 'Suburban',
    about: 'France\'s foremost grande école for engineering and science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-hec',
    name: 'HEC Paris',
    country: 'FRANCE',
    city: 'Jouy-en-Josas',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 47000,
    tuitionMax: 55000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 25,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://hec.edu',
    established: 1881,
    campusType: 'Suburban',
    about: 'Europe\'s #1 business school; elite MBA and grande école programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-insead',
    name: 'INSEAD',
    country: 'FRANCE',
    city: 'Fontainebleau',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 85000,
    tuitionMax: 90000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 20,
    ielts: 7.5,
    toefl: 110,
    greRequired: false,
    website: 'https://insead.edu',
    established: 1957,
    campusType: 'Suburban',
    about: 'World\'s #1 MBA; campuses in France, Singapore, and Abu Dhabi.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-sciences-po',
    name: 'Sciences Po Paris',
    country: 'FRANCE',
    city: 'Paris',
    qsRank: 220,
    usNewsRank: null,
    programs: ['Social Sciences', 'Law', 'Business & Management', 'Arts & Humanities', 'International Relations'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 27,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://sciencespo.fr',
    established: 1872,
    campusType: 'Urban',
    about: 'France\'s elite social sciences and political science institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Foreign Policy & Security Studies', 'Global Affairs', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-centrale',
    name: 'CentraleSupélec',
    country: 'FRANCE',
    city: 'Paris',
    qsRank: 198,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 22,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://centralesupelec.fr',
    established: 1829,
    campusType: 'Suburban',
    about: 'Top French grande école for engineering and applied sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-em-lyon',
    name: 'EM Lyon Business School',
    country: 'FRANCE',
    city: 'Lyon',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 42,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://em-lyon.com',
    established: 1872,
    campusType: 'Urban',
    about: 'One of France\'s top grande écoles for business in Lyon.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-essec',
    name: 'ESSEC Business School',
    country: 'FRANCE',
    city: 'Cergy-Pontoise',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Hospitality & Tourism', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 38000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://essec.edu',
    established: 1907,
    campusType: 'Suburban',
    about: 'Top French business school; strong hospitality and luxury management.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Finance', 'Financial Engineering', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'fr-edhec',
    name: 'EDHEC Business School',
    country: 'FRANCE',
    city: 'Lille / Nice',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Law', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 27000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://edhec.edu',
    established: 1906,
    campusType: 'Urban',
    about: 'Top French school with #1 MSc Finance in Europe.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-skema',
    name: 'SKEMA Business School',
    country: 'FRANCE',
    city: 'Sophia Antipolis',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 60,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://skema.edu',
    established: 2009,
    campusType: 'Suburban',
    about: 'Global business school with campuses in France, USA, China.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing & Big Data', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-grenoble-em',
    name: 'Grenoble École de Management',
    country: 'FRANCE',
    city: 'Grenoble',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Technology Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 55,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://grenoble-em.com',
    established: 1984,
    campusType: 'Urban',
    about: 'French business school in the Alps; focus on tech and innovation.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Digital Transformation', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'IT Management & Strategy', 'Innovation Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Technology Management'],
  },
  {
    id: 'fr-kedge',
    name: 'KEDGE Business School',
    country: 'FRANCE',
    city: 'Bordeaux / Marseille',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Hospitality & Tourism', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 20000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 55,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://kedge.edu',
    established: 2013,
    campusType: 'Urban',
    about: 'French business school with wine and luxury management specialties.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Finance', 'Financial Engineering', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'fr-icn',
    name: 'ICN Business School',
    country: 'FRANCE',
    city: 'Nancy',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://icn-artem.com',
    established: 1905,
    campusType: 'Urban',
    about: 'Lorraine business school with interdisciplinary ARTEM alliance.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-audencia',
    name: 'Audencia Business School',
    country: 'FRANCE',
    city: 'Nantes',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences', 'Sustainability'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 60,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://audencia.com',
    established: 1900,
    campusType: 'Urban',
    about: 'Nantes business school known for sustainability and CSR.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Environmental Management', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Renewable Energy & Clean Technology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Sustainability & Climate Studies'],
  },
  {
    id: 'fr-isc-paris',
    name: 'ISC Paris Business School',
    country: 'FRANCE',
    city: 'Paris',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://iscparis.com',
    established: 1963,
    campusType: 'Urban',
    about: 'Parisian private business school with international focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-toulouse-bs',
    name: 'Toulouse Business School',
    country: 'FRANCE',
    city: 'Toulouse',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Aerospace Management', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 58,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://tbs-education.com',
    established: 1903,
    campusType: 'Urban',
    about: 'French business school with unique aerospace management programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Aerospace Management', 'Airport & Airline Operations', 'Aviation Management', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-montpellier-bs',
    name: 'Montpellier Business School',
    country: 'FRANCE',
    city: 'Montpellier',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://montpellier-bs.com',
    established: 1897,
    campusType: 'Urban',
    about: 'Southern French business school with strong sustainability focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-rouen',
    name: 'Rouen Business School (NEOMA)',
    country: 'FRANCE',
    city: 'Rouen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 58,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://neoma-bs.com',
    established: 2013,
    campusType: 'Urban',
    about: 'Normandy business school formed by merger of Rouen and Reims schools.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-delft',
    name: 'Delft University of Technology',
    country: 'NETHERLANDS',
    city: 'Delft',
    qsRank: 47,
    usNewsRank: 78,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 30,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://tudelft.nl',
    established: 1842,
    campusType: 'Suburban',
    about: 'Netherlands\' top technical university; globally ranked engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'nl-leiden',
    name: 'Leiden University',
    country: 'NETHERLANDS',
    city: 'Leiden',
    qsRank: 91,
    usNewsRank: 152,
    programs: ['Law', 'Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://leiden.edu',
    established: 1575,
    campusType: 'Urban',
    about: 'Netherlands\' oldest university; renowned for law and life sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'nl-amsterdam',
    name: 'University of Amsterdam',
    country: 'NETHERLANDS',
    city: 'Amsterdam',
    qsRank: 53,
    usNewsRank: 101,
    programs: ['Business & Management', 'Social Sciences', 'Natural Sciences', 'Law', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://uva.nl',
    established: 1632,
    campusType: 'Urban',
    about: 'Research-intensive university in the heart of Amsterdam.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-eindhoven',
    name: 'Eindhoven University of Technology',
    country: 'NETHERLANDS',
    city: 'Eindhoven',
    qsRank: 117,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Data Science & AI', 'Natural Sciences', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://tue.nl',
    established: 1956,
    campusType: 'Suburban',
    about: 'Netherlands\' tech hub university; collaborates with ASML, Philips, NXP.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'nl-groningen',
    name: 'University of Groningen',
    country: 'NETHERLANDS',
    city: 'Groningen',
    qsRank: 152,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Business & Management', 'Social Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://rug.nl',
    established: 1614,
    campusType: 'Urban',
    about: 'Northern Dutch university; ancient and highly international.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-erasmus',
    name: 'Erasmus University Rotterdam',
    country: 'NETHERLANDS',
    city: 'Rotterdam',
    qsRank: 198,
    usNewsRank: 201,
    programs: ['Business & Management', 'Finance & Accounting', 'Medicine & Health', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 50,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://eur.nl',
    established: 1913,
    campusType: 'Urban',
    about: 'Rotterdam university famous for Erasmus School of Economics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-utrechtu',
    name: 'Utrecht University',
    country: 'NETHERLANDS',
    city: 'Utrecht',
    qsRank: 87,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Social Sciences', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://uu.nl',
    established: 1636,
    campusType: 'Urban',
    about: 'Major Dutch research university; strong life sciences and sustainability.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'nl-maastricht',
    name: 'Maastricht University',
    country: 'NETHERLANDS',
    city: 'Maastricht',
    qsRank: 212,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Social Sciences', 'Psychology'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 51,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://maastrichtuniversity.nl',
    established: 1976,
    campusType: 'Urban',
    about: 'Problem-based learning pioneer; highly international Dutch university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Clinical Psychology', 'Corporate & Commercial Law', 'Counselling Psychology', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Organizational Psychology', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-vrije',
    name: 'Vrije Universiteit Amsterdam',
    country: 'NETHERLANDS',
    city: 'Amsterdam',
    qsRank: 218,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Social Sciences', 'Business & Management', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://vu.nl',
    established: 1880,
    campusType: 'Suburban',
    about: 'Amsterdam\'s second university; strong for health and social sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-wageningen',
    name: 'Wageningen University',
    country: 'NETHERLANDS',
    city: 'Wageningen',
    qsRank: 166,
    usNewsRank: null,
    programs: ['Agriculture', 'Natural Sciences', 'Environmental Studies', 'Data Science & AI', 'Veterinary Medicine'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 54,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://wur.nl',
    established: 1918,
    campusType: 'Suburban',
    about: 'World\'s top university for agriculture and environmental sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Animal Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Analytics', 'Chemistry', 'Cloud Computing & Big Data', 'Conservation Biology', 'Data Science', 'Earth & Planetary Sciences', 'Environmental Engineering', 'Environmental Science', 'Microbiology', 'Physics', 'Quantitative Analytics', 'Renewable Energy & Clean Technology', 'Sustainability & Climate Studies', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health'],
  },
  {
    id: 'nl-twente',
    name: 'University of Twente',
    country: 'NETHERLANDS',
    city: 'Enschede',
    qsRank: 198,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 55,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://utwente.nl',
    established: 1961,
    campusType: 'Suburban',
    about: 'Entrepreneurial Dutch tech university; \'the entrepreneurial university\'.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'nl-tilburg',
    name: 'Tilburg University',
    country: 'NETHERLANDS',
    city: 'Tilburg',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Social Sciences', 'Finance & Accounting', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 55,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://tilburguniversity.edu',
    established: 1927,
    campusType: 'Suburban',
    about: 'Dutch university known for Tilburg School of Business and Economics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing & Big Data', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Quantitative Analytics', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-radboud',
    name: 'Radboud University',
    country: 'NETHERLANDS',
    city: 'Nijmegen',
    qsRank: 198,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 55,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://ru.nl',
    established: 1923,
    campusType: 'Suburban',
    about: 'Nijmegen research university with strong health sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'nl-hanze',
    name: 'Hanze University of Applied Sciences',
    country: 'NETHERLANDS',
    city: 'Groningen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Medicine & Health', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hanze.nl',
    established: 1798,
    campusType: 'Urban',
    about: 'Large applied sciences university in northern Netherlands.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-zuyd',
    name: 'Zuyd University of Applied Sciences',
    country: 'NETHERLANDS',
    city: 'Maastricht',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://zuyd.nl',
    established: 2000,
    campusType: 'Urban',
    about: 'Applied sciences university in Dutch-Belgian-German border region.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-saxion',
    name: 'Saxion University of Applied Sciences',
    country: 'NETHERLANDS',
    city: 'Deventer',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://saxion.edu',
    established: 1875,
    campusType: 'Suburban',
    about: 'Applied sciences university in eastern Netherlands.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'nl-inholland',
    name: 'Inholland University',
    country: 'NETHERLANDS',
    city: 'Amsterdam',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://inholland.nl',
    established: 2003,
    campusType: 'Urban',
    about: 'Amsterdam-area university of applied sciences with wide programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-wittenborg',
    name: 'Wittenborg University',
    country: 'NETHERLANDS',
    city: 'Apeldoorn',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Hospitality & Tourism', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 9000,
    tuitionMax: 13000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 77,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://wittenborg.eu',
    established: 1987,
    campusType: 'Urban',
    about: 'International business university in the Netherlands.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Finance', 'Financial Engineering', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'nl-nibesvv',
    name: 'NIBE School of Finance',
    country: 'NETHERLANDS',
    city: 'Amsterdam',
    qsRank: null,
    usNewsRank: null,
    programs: ['Finance & Accounting', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 11000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://nibe.info',
    established: 1948,
    campusType: 'Urban',
    about: 'Amsterdam financial sector professional education provider.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-rotterdam-bs',
    name: 'Rotterdam Business School',
    country: 'NETHERLANDS',
    city: 'Rotterdam',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 14000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://rotterdambs.com',
    established: 1988,
    campusType: 'Urban',
    about: 'International business school within Rotterdam University.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing & Big Data', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-kth',
    name: 'KTH Royal Institute of Technology',
    country: 'SWEDEN',
    city: 'Stockholm',
    qsRank: 65,
    usNewsRank: 152,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 20000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://kth.se',
    established: 1827,
    campusType: 'Urban',
    about: 'Sweden\'s leading technical university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'se-lund',
    name: 'Lund University',
    country: 'SWEDEN',
    city: 'Lund',
    qsRank: 78,
    usNewsRank: 152,
    programs: ['Engineering', 'Medicine & Health', 'Natural Sciences', 'Business & Management', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://lu.se',
    established: 1666,
    campusType: 'Urban',
    about: 'Sweden\'s most prestigious university; strong research output.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-chalmers',
    name: 'Chalmers University of Technology',
    country: 'SWEDEN',
    city: 'Gothenburg',
    qsRank: 120,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Architecture', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://chalmers.se',
    established: 1829,
    campusType: 'Urban',
    about: 'Top Swedish tech university; known for Volvo and Ericsson collaborations.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'se-stockholm',
    name: 'Stockholm University',
    country: 'SWEDEN',
    city: 'Stockholm',
    qsRank: 198,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Law', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://su.se',
    established: 1878,
    campusType: 'Urban',
    about: 'Major Swedish research university in the capital.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-gothenburg',
    name: 'University of Gothenburg',
    country: 'SWEDEN',
    city: 'Gothenburg',
    qsRank: 246,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://gu.se',
    established: 1891,
    campusType: 'Urban',
    about: 'Sweden\'s second largest university; strong in social sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-uu',
    name: 'Uppsala University',
    country: 'SWEDEN',
    city: 'Uppsala',
    qsRank: 97,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Law', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://uu.se',
    established: 1477,
    campusType: 'Urban',
    about: 'Scandinavia\'s oldest university; world-class research output.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Industrial & Systems Engineering', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'se-liu',
    name: 'Linköping University',
    country: 'SWEDEN',
    city: 'Linköping',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Medicine & Health', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 53,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://liu.se',
    established: 1975,
    campusType: 'Suburban',
    about: 'Young Swedish university known for IT and engineering excellence.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-umu',
    name: 'Umeå University',
    country: 'SWEDEN',
    city: 'Umeå',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 58,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://umu.se',
    established: 1965,
    campusType: 'Urban',
    about: 'Northern Swedish research university; strong in medicine.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'se-slu',
    name: 'Swedish University of Agricultural Sciences',
    country: 'SWEDEN',
    city: 'Uppsala',
    qsRank: null,
    usNewsRank: null,
    programs: ['Agriculture', 'Environmental Studies', 'Veterinary Medicine', 'Natural Sciences', 'Forestry'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 58,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://slu.se',
    established: 1977,
    campusType: 'Suburban',
    about: 'Sweden\'s leading agricultural and environmental university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Animal Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Chemistry', 'Conservation Biology', 'Earth & Planetary Sciences', 'Environmental Engineering', 'Environmental Science', 'Forestry & Forest Management', 'Microbiology', 'Natural Resources Management', 'Physics', 'Renewable Energy & Clean Technology', 'Sustainability & Climate Studies', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health', 'Wildlife & Conservation Biology'],
  },
  {
    id: 'se-mah',
    name: 'Malmö University',
    country: 'SWEDEN',
    city: 'Malmö',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities', 'Health Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mau.se',
    established: 1998,
    campusType: 'Urban',
    about: 'Modern urban university near Copenhagen with diverse programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-hkr',
    name: 'Kristianstad University',
    country: 'SWEDEN',
    city: 'Kristianstad',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 14000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hkr.se',
    established: 1977,
    campusType: 'Suburban',
    about: 'Swedish university in Skåne with business and health programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'se-mdh',
    name: 'Mälardalen University',
    country: 'SWEDEN',
    city: 'Västerås',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Education', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mdu.se',
    established: 1977,
    campusType: 'Urban',
    about: 'Central Swedish university known for robotics and automation.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'se-hb',
    name: 'University of Borås',
    country: 'SWEDEN',
    city: 'Borås',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 14000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hb.se',
    established: 1977,
    campusType: 'Urban',
    about: 'Swedish textile and fashion university with applied sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'se-hv',
    name: 'University West',
    country: 'SWEDEN',
    city: 'Trollhättan',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 14000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hv.se',
    established: 1990,
    campusType: 'Suburban',
    about: 'Work-integrated learning university in western Sweden.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-jth',
    name: 'Jönköping University',
    country: 'SWEDEN',
    city: 'Jönköping',
    qsRank: 501,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 60,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ju.se',
    established: 1994,
    campusType: 'Suburban',
    about: 'International university college in southern Sweden.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ch-eth',
    name: 'ETH Zurich',
    country: 'SWITZERLAND',
    city: 'Zurich',
    qsRank: 7,
    usNewsRank: 15,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Architecture', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 27,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://ethz.ch',
    established: 1855,
    campusType: 'Urban',
    about: 'Europe\'s top-ranked university for STEM; 21 Nobel laureates.',
    rankings: { ugCS: 5, ugEngineering: 5, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 5, qsEngineering: 5, qsBusiness: null, qsNaturalSci: 7, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Agricultural Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Atmospheric Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Earth Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Geomatics', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'ch-epfl',
    name: 'EPFL',
    country: 'SWITZERLAND',
    city: 'Lausanne',
    qsRank: 20,
    usNewsRank: 52,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Architecture', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://epfl.ch',
    established: 1969,
    campusType: 'Suburban',
    about: 'Switzerland\'s French-language engineering powerhouse.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Communication Systems', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Life Sciences Engineering', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Microengineering', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'ch-zurich',
    name: 'University of Zurich',
    country: 'SWITZERLAND',
    city: 'Zurich',
    qsRank: 94,
    usNewsRank: 56,
    programs: ['Medicine & Health', 'Natural Sciences', 'Law', 'Business & Management', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://uzh.ch',
    established: 1833,
    campusType: 'Urban',
    about: 'Switzerland\'s largest university; strong in medicine and sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-bern',
    name: 'University of Bern',
    country: 'SWITZERLAND',
    city: 'Bern',
    qsRank: 144,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Law', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 42,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://unibe.ch',
    established: 1834,
    campusType: 'Urban',
    about: 'Swiss capital\'s research university with strong life sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'ch-basel',
    name: 'University of Basel',
    country: 'SWITZERLAND',
    city: 'Basel',
    qsRank: 165,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Business & Management', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 42,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://unibas.ch',
    established: 1460,
    campusType: 'Urban',
    about: 'Switzerland\'s oldest university; close to French and German borders.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-geneva',
    name: 'University of Geneva',
    country: 'SWITZERLAND',
    city: 'Geneva',
    qsRank: 127,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Law', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://unige.ch',
    established: 1559,
    campusType: 'Urban',
    about: 'Geneva\'s university near UN headquarters; strong in international law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-st-gallen',
    name: 'University of St. Gallen (HSG)',
    country: 'SWITZERLAND',
    city: 'St. Gallen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Law', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 32000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 35,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://unisg.ch',
    established: 1898,
    campusType: 'Urban',
    about: 'Europe\'s top business school; consistently ranked #1 for Masters in Management.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-imd',
    name: 'IMD Business School',
    country: 'SWITZERLAND',
    city: 'Lausanne',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 90000,
    tuitionMax: 95000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 15,
    ielts: 7.5,
    toefl: 110,
    greRequired: false,
    website: 'https://imd.org',
    established: 1990,
    campusType: 'Suburban',
    about: 'World-top executive education and MBA school on Lake Geneva.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-fhnw',
    name: 'University of Applied Sciences Northwestern Switzerland',
    country: 'SWITZERLAND',
    city: 'Basel',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 62,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://fhnw.ch',
    established: 2006,
    campusType: 'Urban',
    about: 'Large Swiss university of applied sciences across multiple campuses.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ch-zhaw',
    name: 'ZHAW Zurich University of Applied Sciences',
    country: 'SWITZERLAND',
    city: 'Winterthur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 62,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://zhaw.ch',
    established: 2007,
    campusType: 'Suburban',
    about: 'Zurich-area applied sciences university with strong industry ties.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-hes-so',
    name: 'HES-SO University of Applied Sciences',
    country: 'SWITZERLAND',
    city: 'Lausanne',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 65,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://hes-so.ch',
    established: 1997,
    campusType: 'Suburban',
    about: 'Switzerland\'s largest university of applied sciences network.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-ehl',
    name: 'EHL Hospitality Business School',
    country: 'SWITZERLAND',
    city: 'Lausanne',
    qsRank: null,
    usNewsRank: null,
    programs: ['Hospitality & Tourism', 'Business & Management', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 45000,
    tuitionMax: 55000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://ehl.edu',
    established: 1893,
    campusType: 'Suburban',
    about: 'World\'s #1 hospitality management school in Lausanne.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Finance', 'Financial Engineering', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'ch-glion',
    name: 'Glion Institute of Higher Education',
    country: 'SWITZERLAND',
    city: 'Montreux',
    qsRank: null,
    usNewsRank: null,
    programs: ['Hospitality & Tourism', 'Business & Management', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 40000,
    tuitionMax: 50000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 50,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://glion.edu',
    established: 1962,
    campusType: 'Suburban',
    about: 'Premium Swiss hospitality and business education on Lake Geneva.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Finance', 'Financial Engineering', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'ch-les-roches',
    name: 'Les Roches Global Hospitality Education',
    country: 'SWITZERLAND',
    city: 'Bluche',
    qsRank: null,
    usNewsRank: null,
    programs: ['Hospitality & Tourism', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 48000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 52,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://lesroches.edu',
    established: 1954,
    campusType: 'Rural',
    about: 'Elite Swiss hospitality school in the Alps.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'International Business', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'ch-slu',
    name: 'SHMS Swiss Hotel Management School',
    country: 'SWITZERLAND',
    city: 'Leysin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Hospitality & Tourism', 'Business & Management', 'Culinary Arts'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 44000,
    currency: 'CHF',
    intakes: ['September', 'February'],
    acceptanceRate: 55,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://shms.com',
    established: 1991,
    campusType: 'Rural',
    about: 'Swiss hospitality management school with stunning Alpine campus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Business Administration (BBA/BCom)', 'Culinary Arts & Gastronomy', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Food & Beverage Management', 'Food Science & Technology', 'Hospitality & Hotel Management', 'Human Resource Management', 'International Business', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Restaurant & Food Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'sg-nus',
    name: 'National University of Singapore',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: 8,
    usNewsRank: 26,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Medicine & Health', 'Law', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 45000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 20,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://nus.edu.sg',
    established: 1905,
    campusType: 'Urban',
    about: 'Asia\'s top university; consistently in global top 10.',
    rankings: { ugCS: 9, ugEngineering: 7, ugBusiness: 20, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 9, qsEngineering: 7, qsBusiness: 20, qsNaturalSci: 20, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dental Medicine', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Nursing (BSN/MSN)', 'Operations Management', 'Pharmacy', 'Pharmacy (PharmD/BPharm)', 'Project Management', 'Public Health (MPH)', 'Quantitative Analytics', 'Real Estate', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-ntu',
    name: 'Nanyang Technological University',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: 15,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 33000,
    tuitionMax: 42000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 22,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://ntu.edu.sg',
    established: 1991,
    campusType: 'Suburban',
    about: 'Asia\'s top tech university; known for research and innovation.',
    rankings: { ugCS: 15, ugEngineering: 10, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: 15, qsEngineering: 10, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Art, Design & Media', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Communication Studies', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-smu',
    name: 'Singapore Management University',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: 501,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Finance & Accounting', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://smu.edu.sg',
    established: 2000,
    campusType: 'Urban',
    about: 'Singapore\'s premier business and law university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-sutd',
    name: 'Singapore University of Technology and Design',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Data Science & AI', 'Design'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 32000,
    tuitionMax: 40000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 28,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://sutd.edu.sg',
    established: 2012,
    campusType: 'Suburban',
    about: 'Unique design-focused tech university in Singapore.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Environmental Engineering', 'Fashion Design & Management', 'Graphic Design & Visual Communication', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Industrial Design', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Quantitative Analytics', 'Software Engineering', 'UX/UI Design', 'Urban & Regional Planning'],
  },
  {
    id: 'sg-sit',
    name: 'Singapore Institute of Technology',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 30000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://singaporetech.edu.sg',
    established: 2009,
    campusType: 'Suburban',
    about: 'Applied technology university; strong industry collaboration.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-sim',
    name: 'Singapore Institute of Management',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 57,
    ielts: 6,
    toefl: 80,
    greRequired: false,
    website: 'https://sim.edu.sg',
    established: 1964,
    campusType: 'Urban',
    about: 'Singapore\'s largest private education institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-james-cook',
    name: 'James Cook University Singapore',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Medicine & Health', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 27000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 52,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://jcu.edu.sg',
    established: 2003,
    campusType: 'Urban',
    about: 'Australian university\'s Singapore campus; strong tropical research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'sg-psb',
    name: 'PSB Academy',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 67,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://psb-academy.edu.sg',
    established: 1964,
    campusType: 'Urban',
    about: 'Singapore private education with UK university partnerships.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-kaplan',
    name: 'Kaplan Singapore',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://kaplan.com.sg',
    established: 1994,
    campusType: 'Urban',
    about: 'Singapore campus offering programmes from UK and Australian universities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Investment Management', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Risk Management & Insurance', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-suss',
    name: 'Singapore University of Social Sciences',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Social Sciences', 'Business & Management', 'Education', 'Law', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 28000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 40,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://suss.edu.sg',
    established: 2005,
    campusType: 'Urban',
    about: 'Applied learning university focused on social innovation.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ae-nyu-abu',
    name: 'NYU Abu Dhabi',
    country: 'UAE',
    city: 'Abu Dhabi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Liberal Arts', 'Computer Science & IT', 'Natural Sciences', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 0,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 6.5,
    toefl: 100,
    greRequired: false,
    website: 'https://nyuad.nyu.edu',
    established: 2010,
    campusType: 'Urban',
    about: 'Fully-funded liberal arts university in Abu Dhabi.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Economics', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interdisciplinary Studies', 'International Relations & Diplomacy', 'Liberal Arts', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology', 'Software Engineering'],
  },
  {
    id: 'ae-khalifa',
    name: 'Khalifa University',
    country: 'UAE',
    city: 'Abu Dhabi',
    qsRank: 181,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Medicine & Health', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 0,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://ku.ac.ae',
    established: 2007,
    campusType: 'Suburban',
    about: 'Abu Dhabi\'s leading STEM research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Pharmacy', 'Physics', 'Public Health (MPH)', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'ae-american-sharjah',
    name: 'American University of Sharjah',
    country: 'UAE',
    city: 'Sharjah',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Architecture', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 6,
    toefl: 80,
    greRequired: false,
    website: 'https://aus.edu',
    established: 1997,
    campusType: 'Suburban',
    about: 'UAE\'s top private research university in Sharjah.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ae-american-dubai',
    name: 'American University in Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://aud.edu',
    established: 1995,
    campusType: 'Urban',
    about: 'US-style university in the heart of Dubai.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ae-uaeu',
    name: 'United Arab Emirates University',
    country: 'UAE',
    city: 'Al Ain',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Medicine & Health', 'Business & Management', 'Natural Sciences', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 0,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 53,
    ielts: 6,
    toefl: 80,
    greRequired: false,
    website: 'https://uaeu.ac.ae',
    established: 1976,
    campusType: 'Suburban',
    about: 'UAE\'s first national university; strong in engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-bits-dubai',
    name: 'BITS Pilani Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 55,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://bpdc.bitspilani.ac.in',
    established: 2000,
    campusType: 'Urban',
    about: 'Dubai campus of India\'s top private tech university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-manipal-dubai',
    name: 'Manipal Academy of Higher Education Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 63,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://manipaldubai.com',
    established: 2000,
    campusType: 'Urban',
    about: 'Dubai campus of India\'s Manipal University.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-heriot-dubai',
    name: 'Heriot-Watt University Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 60,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hw.ac.uk/dubai',
    established: 2005,
    campusType: 'Suburban',
    about: 'Scottish university\'s Dubai campus in Academic City.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ae-coventry-dubai',
    name: 'Coventry University Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://coventry.ac.uk/dubai',
    established: 2018,
    campusType: 'Urban',
    about: 'UK university\'s Dubai campus in Al Twar.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ae-middlesex-dubai',
    name: 'Middlesex University Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 71,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mdx.ac.ae',
    established: 2005,
    campusType: 'Urban',
    about: 'UK university\'s Dubai campus; affordable global degree.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-paris-sorbonne',
    name: 'Paris-Sorbonne University Abu Dhabi',
    country: 'UAE',
    city: 'Abu Dhabi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Social Sciences', 'Business & Management', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 62,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://psad.ae',
    established: 2006,
    campusType: 'Urban',
    about: 'French Sorbonne University\'s Abu Dhabi campus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-rochester-ras',
    name: 'Rochester Institute of Technology Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 62,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://rit.edu/dubai',
    established: 2008,
    campusType: 'Suburban',
    about: 'US university\'s Dubai campus with strong tech programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-wollongong-dubai',
    name: 'University of Wollongong Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Education', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uowdubai.ac.ae',
    established: 1993,
    campusType: 'Urban',
    about: 'Oldest Australian university campus in UAE.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ae-sp-jain',
    name: 'S P Jain School of Global Management',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 35000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://spjain.org',
    established: 2004,
    campusType: 'Urban',
    about: 'Tri-city global business school: Dubai, Mumbai, Sydney, Singapore.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing & Big Data', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-canadian-dubai',
    name: 'Canadian University Dubai',
    country: 'UAE',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Architecture', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://cud.ac.ae',
    established: 2006,
    campusType: 'Urban',
    about: 'Canadian-accredited university in central Dubai.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-iit-bombay',
    name: 'IIT Bombay',
    country: 'INDIA',
    city: 'Mumbai',
    qsRank: 118,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 11,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitb.ac.in',
    established: 1958,
    campusType: 'Urban',
    about: 'Maharashtra\'s premier IIT; top for CS, engineering and design.',
    rankings: { ugCS: null, ugEngineering: 45, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: 45, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Design', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Energy Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Naval Architecture', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'in-iit-delhi',
    name: 'IIT Delhi',
    country: 'INDIA',
    city: 'New Delhi',
    qsRank: 150,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 16,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitd.ac.in',
    established: 1961,
    campusType: 'Urban',
    about: 'Delhi\'s flagship IIT; renowned for research and placements.',
    rankings: { ugCS: null, ugEngineering: 45, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: 45, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Atmospheric Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Cognitive Science', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Design', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Polymer Science', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iit-madras',
    name: 'IIT Madras',
    country: 'INDIA',
    city: 'Chennai',
    qsRank: 227,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 17,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitm.ac.in',
    established: 1959,
    campusType: 'Suburban',
    about: 'Tamil Nadu\'s premier IIT; ranked India\'s #1 engineering institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Engineering Design', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Naval Architecture & Ocean Engineering', 'Network Engineering', 'Ocean Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'in-iit-kanpur',
    name: 'IIT Kanpur',
    country: 'INDIA',
    city: 'Kanpur',
    qsRank: 278,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 18,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitk.ac.in',
    established: 1959,
    campusType: 'Urban',
    about: 'Known for pioneering CS education in India.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Cognitive Science', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Earth Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iit-kharagpur',
    name: 'IIT Kharagpur',
    country: 'INDIA',
    city: 'Kharagpur',
    qsRank: 222,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 20,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitkgp.ac.in',
    established: 1951,
    campusType: 'Suburban',
    about: 'India\'s first IIT; largest campus with diverse programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agricultural & Food Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Geology & Geophysics', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-iit-roorkee',
    name: 'IIT Roorkee',
    country: 'INDIA',
    city: 'Roorkee',
    qsRank: 350,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Architecture', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 25,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitr.ac.in',
    established: 1847,
    campusType: 'Suburban',
    about: 'Asia\'s oldest tech institution; strong in civil and earthquake engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-iit-hyderabad',
    name: 'IIT Hyderabad',
    country: 'INDIA',
    city: 'Hyderabad',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI', 'Design'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 30,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iith.ac.in',
    established: 2008,
    campusType: 'Suburban',
    about: 'New IIT in Hyderabad; growing research profile.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Fashion Design & Management', 'Graphic Design & Visual Communication', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Industrial Design', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'UX/UI Design'],
  },
  {
    id: 'in-iit-guwahati',
    name: 'IIT Guwahati',
    country: 'INDIA',
    city: 'Guwahati',
    qsRank: 364,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Design'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 35,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitg.ac.in',
    established: 1994,
    campusType: 'Suburban',
    about: 'NE India\'s premier IIT on the banks of the Brahmaputra.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Fashion Design & Management', 'Graphic Design & Visual Communication', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Industrial Design', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'UX/UI Design'],
  },
  {
    id: 'in-iisc',
    name: 'Indian Institute of Science',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: 211,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Computer Science & IT', 'Data Science & AI', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2500,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 12,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iisc.ac.in',
    established: 1909,
    campusType: 'Urban',
    about: 'India\'s top research institution for science and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computational & Data Sciences', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Engineering', 'Materials Science & Engineering', 'Mathematical Sciences', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Neuroscience', 'Nursing', 'Pharmacy', 'Physics', 'Public Health (MPH)', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'in-iim-ahmedabad',
    name: 'IIM Ahmedabad',
    country: 'INDIA',
    city: 'Ahmedabad',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 40000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 5,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iima.ac.in',
    established: 1961,
    campusType: 'Suburban',
    about: 'India\'s #1 business school; global MBA powerhouse.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Agribusiness Management', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Systems Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-bangalore',
    name: 'IIM Bangalore',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 38000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 7,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iimb.ac.in',
    established: 1973,
    campusType: 'Suburban',
    about: 'South India\'s premier management institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing & Big Data', 'Criminology & Criminal Justice', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Quantitative Analytics', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-calcutta',
    name: 'IIM Calcutta',
    country: 'INDIA',
    city: 'Kolkata',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 38000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 8,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iimcal.ac.in',
    established: 1961,
    campusType: 'Urban',
    about: 'India\'s first IIM; consistently in global B-school rankings.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-bits-pilani',
    name: 'BITS Pilani',
    country: 'INDIA',
    city: 'Pilani',
    qsRank: 501,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Pharmacy'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 6000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 30,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://bits-pilani.ac.in',
    established: 1964,
    campusType: 'Rural',
    about: 'India\'s top private tech university; strong placement record.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Clinical Pharmacy', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy (PharmD/BPharm)', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-manipal',
    name: 'Manipal Academy of Higher Education',
    country: 'INDIA',
    city: 'Manipal',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Engineering', 'Computer Science & IT', 'Business & Management', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 6000,
    tuitionMax: 10000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 55,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://manipal.edu',
    established: 1953,
    campusType: 'Suburban',
    about: 'Deemed university in Karnataka with global campuses.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-vit',
    name: 'VIT University',
    country: 'INDIA',
    city: 'Vellore',
    qsRank: 751,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 62,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://vit.ac.in',
    established: 1984,
    campusType: 'Suburban',
    about: 'Large private university in Tamil Nadu; highly ranked for placements.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-srm',
    name: 'SRM Institute of Science and Technology',
    country: 'INDIA',
    city: 'Chennai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Medicine & Health', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 65,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://srmist.edu.in',
    established: 1985,
    campusType: 'Suburban',
    about: 'Top private Tamil Nadu university with diverse engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-amity',
    name: 'Amity University',
    country: 'INDIA',
    city: 'Noida, UP',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Law', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 9000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 68,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://amity.edu',
    established: 2005,
    campusType: 'Suburban',
    about: 'Large private university with campuses across India and abroad.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-symbiosis',
    name: 'Symbiosis International University',
    country: 'INDIA',
    city: 'Pune',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Computer Science & IT', 'Social Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 6000,
    tuitionMax: 10000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://siu.edu.in',
    established: 2002,
    campusType: 'Suburban',
    about: 'Pune-based international university with strong B-school.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-du',
    name: 'University of Delhi',
    country: 'INDIA',
    city: 'New Delhi',
    qsRank: 407,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Commerce', 'Natural Sciences', 'Social Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1000,
    tuitionMax: 2000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 50,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://du.ac.in',
    established: 1922,
    campusType: 'Urban',
    about: 'India\'s largest university; prestigious colleges in the capital.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Commerce', 'Chemistry', 'Commerce', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'International Trade & Commerce', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Microbiology', 'Music & Performing Arts', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology'],
  },
  {
    id: 'in-jnu',
    name: 'Jawaharlal Nehru University',
    country: 'INDIA',
    city: 'New Delhi',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Social Sciences', 'Arts & Humanities', 'Natural Sciences', 'Law', 'International Relations'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1000,
    tuitionMax: 1500,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 18,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://jnu.ac.in',
    established: 1969,
    campusType: 'Suburban',
    about: 'India\'s top research university for humanities and social sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Foreign Policy & Security Studies', 'Global Affairs', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Microbiology', 'Music & Performing Arts', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology'],
  },
  {
    id: 'in-hyderabad',
    name: 'University of Hyderabad',
    country: 'INDIA',
    city: 'Hyderabad',
    qsRank: 501,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Computer Science & IT', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1000,
    tuitionMax: 2000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 22,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://uohyd.ac.in',
    established: 1974,
    campusType: 'Suburban',
    about: 'Central university with strong humanities and science research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology', 'Software Engineering'],
  },
  {
    id: 'in-xlri',
    name: 'XLRI - Xavier School of Management',
    country: 'INDIA',
    city: 'Jamshedpur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Human Resources', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 32000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 12,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://xlri.ac.in',
    established: 1949,
    campusType: 'Urban',
    about: 'India\'s oldest business school; known for HR and business management.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Organizational Behavior', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Talent Management'],
  },
  {
    id: 'in-sp-jain-mumbai',
    name: 'S P Jain Institute of Management',
    country: 'INDIA',
    city: 'Mumbai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 30000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 15,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://spjimr.org',
    established: 1981,
    campusType: 'Urban',
    about: 'Mumbai\'s premier business school with strong corporate partnerships.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing & Big Data', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iift',
    name: 'Indian Institute of Foreign Trade',
    country: 'INDIA',
    city: 'New Delhi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'International Trade', 'Economics'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 25000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 10,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iift.ac.in',
    established: 1963,
    campusType: 'Urban',
    about: 'India\'s top institution for international business and trade.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Applied Economics', 'Behavioral Economics', 'Business Administration (BBA/BCom)', 'Development Economics', 'Econometrics', 'Economics', 'Entrepreneurship & Innovation', 'Export & Import Management', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Trade & Commerce', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Trade Policy & Economics'],
  },
  {
    id: 'in-nmims',
    name: 'SVKM\'s NMIMS University',
    country: 'INDIA',
    city: 'Mumbai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Pharmacy', 'Architecture', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 18000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 58,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://nmims.edu',
    established: 1981,
    campusType: 'Urban',
    about: 'Mumbai\'s Narsee Monjee; strong in management and pharmacy.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Clinical Pharmacy', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy (PharmD/BPharm)', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-christo',
    name: 'Christ University',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 60,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://christuniversity.in',
    established: 1969,
    campusType: 'Urban',
    about: 'Bengaluru private university known for management and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-pes',
    name: 'PES University',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 65,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://pes.edu',
    established: 1972,
    campusType: 'Urban',
    about: 'Bengaluru tech university with strong industry connections.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-lpu',
    name: 'Lovely Professional University',
    country: 'INDIA',
    city: 'Jalandhar, Punjab',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://lpu.in',
    established: 2005,
    campusType: 'Suburban',
    about: 'Large private university in Punjab with global student body.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-chitkara',
    name: 'Chitkara University',
    country: 'INDIA',
    city: 'Chandigarh',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Architecture', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 6000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 68,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://chitkara.edu.in',
    established: 2010,
    campusType: 'Suburban',
    about: 'Punjab private university with strong innovation and startup focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-thapar',
    name: 'Thapar Institute of Engineering',
    country: 'INDIA',
    city: 'Patiala',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 6000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 62,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://thapar.edu',
    established: 1956,
    campusType: 'Suburban',
    about: 'Deemed university in Punjab; known for engineering excellence.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-auckland',
    name: 'University of Auckland',
    country: 'NZ',
    city: 'Auckland',
    qsRank: 68,
    usNewsRank: 152,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Medicine & Health', 'Natural Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 30000,
    tuitionMax: 38000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://auckland.ac.nz',
    established: 1883,
    campusType: 'Urban',
    about: 'New Zealand\'s top-ranked university and leading research institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-otago',
    name: 'University of Otago',
    country: 'NZ',
    city: 'Dunedin',
    qsRank: 184,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Business & Management', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 49,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://otago.ac.nz',
    established: 1869,
    campusType: 'Urban',
    about: 'NZ\'s oldest university; renowned for medicine and health sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-victoria',
    name: 'Victoria University of Wellington',
    country: 'NZ',
    city: 'Wellington',
    qsRank: 272,
    usNewsRank: null,
    programs: ['Law', 'Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 54,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://wgtn.ac.nz',
    established: 1895,
    campusType: 'Urban',
    about: 'NZ capital\'s research university; strong in law and public policy.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-massey',
    name: 'Massey University',
    country: 'NZ',
    city: 'Palmerston North',
    qsRank: 451,
    usNewsRank: null,
    programs: ['Agriculture', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 27000,
    tuitionMax: 33000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 90,
    greRequired: false,
    website: 'https://massey.ac.nz',
    established: 1927,
    campusType: 'Suburban',
    about: 'NZ\'s distance learning leader; strong in agriculture and design.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-canterbury',
    name: 'University of Canterbury',
    country: 'NZ',
    city: 'Christchurch',
    qsRank: 325,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 60,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://canterbury.ac.nz',
    established: 1873,
    campusType: 'Suburban',
    about: 'Canterbury\'s flagship research university with strong engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-aut',
    name: 'Auckland University of Technology',
    country: 'NZ',
    city: 'Auckland',
    qsRank: 451,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 56,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://aut.ac.nz',
    established: 1895,
    campusType: 'Urban',
    about: 'Applied-learning NZ university in Auckland; industry-focused.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-waikato',
    name: 'University of Waikato',
    country: 'NZ',
    city: 'Hamilton',
    qsRank: 501,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 25000,
    tuitionMax: 31000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://waikato.ac.nz',
    established: 1964,
    campusType: 'Suburban',
    about: 'Waikato research university with strong business and science programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-lincoln',
    name: 'Lincoln University',
    country: 'NZ',
    city: 'Christchurch',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Agriculture', 'Environmental Studies', 'Business & Management', 'Natural Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 26000,
    tuitionMax: 32000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 62,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://lincoln.ac.nz',
    established: 1878,
    campusType: 'Rural',
    about: 'NZ specialist university for land-based industries.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Conservation Biology', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Project Management', 'Renewable Energy & Clean Technology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Sustainability & Climate Studies'],
  },
  {
    id: 'nz-unitec',
    name: 'Unitec Institute of Technology',
    country: 'NZ',
    city: 'Auckland',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 22000,
    tuitionMax: 27000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 73,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unitec.ac.nz',
    established: 1976,
    campusType: 'Suburban',
    about: 'Auckland technology institution with vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'nz-nmit',
    name: 'Nelson Marlborough Institute',
    country: 'NZ',
    city: 'Nelson',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Computer Science & IT', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 83,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://nmit.ac.nz',
    established: 1905,
    campusType: 'Suburban',
    about: 'Top of the South polytechnic in Nelson, NZ.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-weltech',
    name: 'Wellington Institute of Technology',
    country: 'NZ',
    city: 'Wellington',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 20000,
    tuitionMax: 25000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://weltec.ac.nz',
    established: 1960,
    campusType: 'Urban',
    about: 'Wellington polytechnic focused on applied vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-wintec',
    name: 'Waikato Institute of Technology',
    country: 'NZ',
    city: 'Hamilton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research', 'Diploma / Certificate'],
    tuitionMin: 19000,
    tuitionMax: 24000,
    currency: 'NZD',
    intakes: ['February', 'July'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://wintec.ac.nz',
    established: 1924,
    campusType: 'Urban',
    about: 'Waikato region polytechnic with industry-focused programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-michigan-state',
    name: 'Michigan State University',
    country: 'USA',
    city: 'East Lansing, MI',
    qsRank: 251,
    usNewsRank: 50,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 26000,
    tuitionMax: 29000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 76,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://msu.edu',
    established: 1855,
    campusType: 'Suburban',
    about: 'Big Ten university known for agriculture, business, and Broad College.',
    rankings: { ugCS: 54, ugEngineering: 48, ugBusiness: 24, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-ucf2',
    name: 'University of Central Florida',
    country: 'USA',
    city: 'Orlando, FL',
    qsRank: 751,
    usNewsRank: 201,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Hospitality & Tourism', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 50,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ucf.edu',
    established: 1963,
    campusType: 'Suburban',
    about: 'Large Florida university with strong hospitality and simulation programs.',
    rankings: { ugCS: 78, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics', 'Tourism Management'],
  },
  {
    id: 'usa-uclaextension',
    name: 'George Mason University',
    country: 'USA',
    city: 'Fairfax, VA',
    qsRank: 601,
    usNewsRank: 131,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Social Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 32000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://gmu.edu',
    established: 1972,
    campusType: 'Suburban',
    about: 'Northern Virginia public university near DC with strong CS programs.',
    rankings: { ugCS: 78, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-american-u',
    name: 'American University Washington DC',
    country: 'USA',
    city: 'Washington, DC',
    qsRank: 751,
    usNewsRank: 87,
    programs: ['International Relations', 'Law', 'Business & Management', 'Social Sciences', 'Media & Communications'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 51000,
    tuitionMax: 57000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 37,
    ielts: 6.5,
    toefl: 84,
    greRequired: false,
    website: 'https://american.edu',
    established: 1893,
    campusType: 'Urban',
    about: 'DC university known for international affairs and public policy.',
    rankings: { ugCS: 229, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Foreign Policy & Security Studies', 'Global Affairs', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-william-mary',
    name: 'College of William & Mary',
    country: 'USA',
    city: 'Williamsburg, VA',
    qsRank: null,
    usNewsRank: 79,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 50000,
    tuitionMax: 55000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 37,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://wm.edu',
    established: 1693,
    campusType: 'Suburban',
    about: 'Second-oldest American university; public Ivy in Virginia.',
    rankings: { ugCS: 54, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-ga-state',
    name: 'Georgia State University',
    country: 'USA',
    city: 'Atlanta, GA',
    qsRank: 601,
    usNewsRank: 131,
    programs: ['Business & Management', 'Law', 'Computer Science & IT', 'Social Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://gsu.edu',
    established: 1913,
    campusType: 'Urban',
    about: 'Urban Atlanta university with strong business and law schools.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-lsu',
    name: 'Louisiana State University',
    country: 'USA',
    city: 'Baton Rouge, LA',
    qsRank: 601,
    usNewsRank: 131,
    programs: ['Engineering', 'Business & Management', 'Agriculture', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 31000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 76,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://lsu.edu',
    established: 1853,
    campusType: 'Suburban',
    about: 'Louisiana\'s flagship university known for petroleum engineering.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-ole-miss',
    name: 'University of Mississippi',
    country: 'USA',
    city: 'Oxford, MS',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Social Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 23000,
    tuitionMax: 26000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 98,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://olemiss.edu',
    established: 1844,
    campusType: 'Suburban',
    about: 'Mississippi\'s flagship university; known for law and liberal arts.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-arkansas',
    name: 'University of Arkansas',
    country: 'USA',
    city: 'Fayetteville, AR',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Business & Management', 'Engineering', 'Agriculture', 'Law', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 27000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uark.edu',
    established: 1871,
    campusType: 'Suburban',
    about: 'Arkansas flagship with top retail and supply chain programs.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-ucf3',
    name: 'University of Memphis',
    country: 'USA',
    city: 'Memphis, TN',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Engineering', 'Education', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://memphis.edu',
    established: 1912,
    campusType: 'Urban',
    about: 'Tennessee urban research university with strong music programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-west-virginia',
    name: 'West Virginia University',
    country: 'USA',
    city: 'Morgantown, WV',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Engineering', 'Business & Management', 'Medicine & Health', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 31000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://wvu.edu',
    established: 1867,
    campusType: 'Suburban',
    about: 'WV flagship known for energy and aerospace engineering.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-nevada',
    name: 'University of Nevada Las Vegas',
    country: 'USA',
    city: 'Las Vegas, NV',
    qsRank: null,
    usNewsRank: null,
    programs: ['Hospitality & Tourism', 'Business & Management', 'Engineering', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://unlv.edu',
    established: 1957,
    campusType: 'Urban',
    about: 'Top university for hospitality management in Las Vegas.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food & Beverage Management', 'History', 'Hospitality & Hotel Management', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'usa-missouri',
    name: 'University of Missouri',
    country: 'USA',
    city: 'Columbia, MO',
    qsRank: 601,
    usNewsRank: 67,
    programs: ['Business & Management', 'Journalism & Media', 'Engineering', 'Medicine & Health', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 31000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://missouri.edu',
    established: 1839,
    campusType: 'Suburban',
    about: 'Missouri\'s flagship; known for journalism and agriculture.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biomedical Engineering', 'Biomedical Sciences', 'Broadcast Journalism', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Digital Journalism', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Journalism', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Media Studies', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-tennessee',
    name: 'University of Tennessee',
    country: 'USA',
    city: 'Knoxville, TN',
    qsRank: 601,
    usNewsRank: 131,
    programs: ['Engineering', 'Business & Management', 'Agriculture', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://utk.edu',
    established: 1794,
    campusType: 'Suburban',
    about: 'SEC university known for engineering and business.',
    rankings: { ugCS: 71, ugEngineering: 64, ugBusiness: 37, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-alabama',
    name: 'University of Alabama',
    country: 'USA',
    city: 'Tuscaloosa, AL',
    qsRank: 601,
    usNewsRank: 131,
    programs: ['Business & Management', 'Engineering', 'Law', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ua.edu',
    established: 1831,
    campusType: 'Suburban',
    about: 'Alabama flagship with strong business and engineering programs.',
    rankings: { ugCS: 117, ugEngineering: null, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-auburn2',
    name: 'Auburn University',
    country: 'USA',
    city: 'Auburn, AL',
    qsRank: 601,
    usNewsRank: 71,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Architecture', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 31000,
    tuitionMax: 34000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://auburn.edu',
    established: 1856,
    campusType: 'Suburban',
    about: 'SEC university known for architecture and aerospace engineering.',
    rankings: { ugCS: 78, ugEngineering: 57, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-mississippi-state',
    name: 'Mississippi State University',
    country: 'USA',
    city: 'Starkville, MS',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 27000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://msstate.edu',
    established: 1878,
    campusType: 'Rural',
    about: 'Mississippi\'s land-grant university with top engineering programs.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-south-carolina',
    name: 'University of South Carolina',
    country: 'USA',
    city: 'Columbia, SC',
    qsRank: 601,
    usNewsRank: 79,
    programs: ['Business & Management', 'Engineering', 'Law', 'Social Sciences', 'Hospitality & Tourism'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 32000,
    tuitionMax: 35000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 66,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://sc.edu',
    established: 1801,
    campusType: 'Urban',
    about: 'South Carolina flagship with top-ranked Darla Moore Business School.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'usa-clemson2',
    name: 'Clemson University',
    country: 'USA',
    city: 'Clemson, SC',
    qsRank: 601,
    usNewsRank: 62,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 36000,
    tuitionMax: 40000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 51,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://clemson.edu',
    established: 1889,
    campusType: 'Rural',
    about: 'South Carolina public research university known for engineering.',
    rankings: { ugCS: 78, ugEngineering: 50, ugBusiness: 64, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-kentucky2',
    name: 'University of Kentucky',
    country: 'USA',
    city: 'Lexington, KY',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Agriculture', 'Medicine & Health', 'Business & Management', 'Engineering', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 94,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uky.edu',
    established: 1865,
    campusType: 'Urban',
    about: 'Kentucky flagship known for agriculture and pharmaceutical research.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-ohio-u',
    name: 'Ohio University',
    country: 'USA',
    city: 'Athens, OH',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Engineering', 'Media & Communications', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 21000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ohio.edu',
    established: 1804,
    campusType: 'Suburban',
    about: 'Ohio\'s oldest university with strong journalism programs.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Digital Media & Content', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-toledo',
    name: 'University of Toledo',
    country: 'USA',
    city: 'Toledo, OH',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Medicine & Health', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 96,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://utoledo.edu',
    established: 1872,
    campusType: 'Suburban',
    about: 'Northwest Ohio public research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-bowling-green',
    name: 'Bowling Green State University',
    country: 'USA',
    city: 'Bowling Green, OH',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://bgsu.edu',
    established: 1910,
    campusType: 'Suburban',
    about: 'Ohio state university with strong education and arts programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-ball-state',
    name: 'Ball State University',
    country: 'USA',
    city: 'Muncie, IN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Education', 'Business & Management', 'Architecture', 'Arts & Humanities', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://bsu.edu',
    established: 1918,
    campusType: 'Suburban',
    about: 'Indiana university known for architecture and education programs.',
    rankings: { ugCS: 229, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-grand-valley',
    name: 'Grand Valley State University',
    country: 'USA',
    city: 'Allendale, MI',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Computer Science & IT', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://gvsu.edu',
    established: 1960,
    campusType: 'Suburban',
    about: 'West Michigan regional university with strong education programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-cent-mich',
    name: 'Central Michigan University',
    country: 'USA',
    city: 'Mount Pleasant, MI',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Medicine & Health', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://cmich.edu',
    established: 1892,
    campusType: 'Suburban',
    about: 'Michigan regional university with extensive online programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-western-mich',
    name: 'Western Michigan University',
    country: 'USA',
    city: 'Kalamazoo, MI',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Engineering', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 19000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://wmich.edu',
    established: 1903,
    campusType: 'Suburban',
    about: 'Michigan research university with diverse academic programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-ithaca',
    name: 'Ithaca College',
    country: 'USA',
    city: 'Ithaca, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Media & Communications', 'Business & Management', 'Arts & Humanities', 'Education', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 52000,
    tuitionMax: 57000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://ithaca.edu',
    established: 1892,
    campusType: 'Suburban',
    about: 'Private NY college known for communications and music.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemistry', 'Curriculum & Instruction', 'Digital Media & Content', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Public Relations & Advertising', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-hofstra',
    name: 'Hofstra University',
    country: 'USA',
    city: 'Hempstead, NY',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Law', 'Computer Science & IT', 'Education', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 52000,
    tuitionMax: 57000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 69,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://hofstra.edu',
    established: 1935,
    campusType: 'Suburban',
    about: 'Long Island university with top-tier law and business schools.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-quinnipiac',
    name: 'Quinnipiac University',
    country: 'USA',
    city: 'Hamden, CT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Media & Communications', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 52000,
    tuitionMax: 57000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://quinnipiac.edu',
    established: 1929,
    campusType: 'Suburban',
    about: 'Connecticut university with strong health and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Biomedical Sciences', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Dentistry', 'Digital Media & Content', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'International Business', 'International Law', 'Journalism & Mass Communication', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Public Relations & Advertising', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-elon',
    name: 'Elon University',
    country: 'USA',
    city: 'Elon, NC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Media & Communications', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 43000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://elon.edu',
    established: 1889,
    campusType: 'Suburban',
    about: 'NC liberal arts university known for experiential learning.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Digital Media & Content', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-butler',
    name: 'Butler University',
    country: 'USA',
    city: 'Indianapolis, IN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Education', 'Computer Science & IT', 'Pharmacy'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 42000,
    tuitionMax: 47000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://butler.edu',
    established: 1855,
    campusType: 'Suburban',
    about: 'Indianapolis university known for business and pharmacy.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Clinical Pharmacy', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy (PharmD/BPharm)', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-xavier',
    name: 'Xavier University',
    country: 'USA',
    city: 'Cincinnati, OH',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Education', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 42000,
    tuitionMax: 47000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://xavier.edu',
    established: 1831,
    campusType: 'Urban',
    about: 'Jesuit university in Cincinnati known for business and health.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-seton-hall',
    name: 'Seton Hall University',
    country: 'USA',
    city: 'South Orange, NJ',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 45000,
    tuitionMax: 51000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://shu.edu',
    established: 1856,
    campusType: 'Suburban',
    about: 'Catholic NJ university with top law and business schools.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-loyola-chicago',
    name: 'Loyola University Chicago',
    country: 'USA',
    city: 'Chicago, IL',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 46000,
    tuitionMax: 52000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://luc.edu',
    established: 1870,
    campusType: 'Urban',
    about: 'Jesuit university in Chicago with strong business and law.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-depaul',
    name: 'DePaul University',
    country: 'USA',
    city: 'Chicago, IL',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Computer Science & IT', 'Law', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 43000,
    tuitionMax: 49000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://depaul.edu',
    established: 1898,
    campusType: 'Urban',
    about: 'Chicago\'s Vincentian university; US\'s largest Catholic university.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-marquette',
    name: 'Marquette University',
    country: 'USA',
    city: 'Milwaukee, WI',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Business & Management', 'Law', 'Engineering', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 50000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://marquette.edu',
    established: 1881,
    campusType: 'Urban',
    about: 'Jesuit Milwaukee university with strong law and engineering.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-gonzaga',
    name: 'Gonzaga University',
    country: 'USA',
    city: 'Spokane, WA',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Law', 'Engineering', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 48000,
    tuitionMax: 54000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://gonzaga.edu',
    established: 1887,
    campusType: 'Urban',
    about: 'Jesuit Spokane university with strong business and law programs.',
    rankings: { ugCS: 177, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-santa-clara',
    name: 'Santa Clara University',
    country: 'USA',
    city: 'Santa Clara, CA',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Business & Management', 'Law', 'Engineering', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 56000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://scu.edu',
    established: 1851,
    campusType: 'Suburban',
    about: 'Jesuit Silicon Valley university with strong engineering and business.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: 64, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-fordham2',
    name: 'Fordham University',
    country: 'USA',
    city: 'New York, NY',
    qsRank: 801,
    usNewsRank: 62,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Social Sciences', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 61000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://fordham.edu',
    established: 1841,
    campusType: 'Urban',
    about: 'Jesuit New York university; Gabelli School of Business.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-pepperdine',
    name: 'Pepperdine University',
    country: 'USA',
    city: 'Malibu, CA',
    qsRank: null,
    usNewsRank: 42,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://pepperdine.edu',
    established: 1937,
    campusType: 'Suburban',
    about: 'Christian university in Malibu with beautiful Pacific campus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: 64, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-liberty',
    name: 'Liberty University',
    country: 'USA',
    city: 'Lynchburg, VA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Engineering', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 23000,
    tuitionMax: 26000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 99,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://liberty.edu',
    established: 1971,
    campusType: 'Suburban',
    about: 'Large Christian university with extensive online programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-regent',
    name: 'Regent University',
    country: 'USA',
    city: 'Virginia Beach, VA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Education', 'Media & Communications', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://regent.edu',
    established: 1977,
    campusType: 'Suburban',
    about: 'Christian university in Virginia Beach with strong law program.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Digital Media & Content', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-embry',
    name: 'Embry-Riddle Aeronautical University',
    country: 'USA',
    city: 'Daytona Beach, FL',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 43000,
    tuitionMax: 48000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://embryriddle.edu',
    established: 1925,
    campusType: 'Suburban',
    about: 'World\'s top aviation and aeronautical engineering university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-florida-intl',
    name: 'Florida International University',
    country: 'USA',
    city: 'Miami, FL',
    qsRank: 601,
    usNewsRank: 131,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 19000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 58,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://fiu.edu',
    established: 1965,
    campusType: 'Suburban',
    about: 'Miami\'s large public research university with global student body.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-nova-se',
    name: 'Nova Southeastern University',
    country: 'USA',
    city: 'Fort Lauderdale, FL',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 35000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://nova.edu',
    established: 1964,
    campusType: 'Suburban',
    about: 'South Florida private university with strong health sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-st-johns',
    name: 'St. John\'s University',
    country: 'USA',
    city: 'Queens, NY',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Law', 'Pharmacy', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 43000,
    tuitionMax: 48000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://stjohns.edu',
    established: 1870,
    campusType: 'Suburban',
    about: 'Catholic NYC university with strong law and pharmacy schools.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Clinical Pharmacy', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy (PharmD/BPharm)', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-la-verne',
    name: 'University of La Verne',
    country: 'USA',
    city: 'La Verne, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Education', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 40000,
    tuitionMax: 45000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://laverne.edu',
    established: 1891,
    campusType: 'Suburban',
    about: 'California private university known for law and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-hawaii-pacific',
    name: 'Hawaii Pacific University',
    country: 'USA',
    city: 'Honolulu, HI',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Social Sciences', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 28000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hpu.edu',
    established: 1965,
    campusType: 'Urban',
    about: 'Honolulu private university with diverse international programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-alaska',
    name: 'University of Alaska Fairbanks',
    country: 'USA',
    city: 'Fairbanks, AK',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Social Sciences', 'Business & Management', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 77,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uaf.edu',
    established: 1917,
    campusType: 'Suburban',
    about: 'Arctic research university with unique polar science programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-montana',
    name: 'University of Montana',
    country: 'USA',
    city: 'Missoula, MT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 95,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://umt.edu',
    established: 1893,
    campusType: 'Suburban',
    about: 'Montana flagship with strong natural resource and fine arts programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'it-bologna',
    name: 'University of Bologna',
    country: 'ITALY',
    city: 'Bologna',
    qsRank: 154,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Law', 'Engineering', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unibo.it',
    established: 1088,
    campusType: 'Urban',
    about: 'World\'s oldest university; comprehensive Italian research institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-sapienza',
    name: 'Sapienza University of Rome',
    country: 'ITALY',
    city: 'Rome',
    qsRank: 171,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Engineering', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uniroma1.it',
    established: 1303,
    campusType: 'Urban',
    about: 'Europe\'s largest university by enrolment; Rome\'s flagship institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Public Health (MPH)'],
  },
  {
    id: 'it-milan-poly',
    name: 'Politecnico di Milano',
    country: 'ITALY',
    city: 'Milan',
    qsRank: 123,
    usNewsRank: 152,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Design', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 8000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://polimi.it',
    established: 1863,
    campusType: 'Urban',
    about: 'Italy\'s top technical university; world-class for design and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Fashion Design & Management', 'Graphic Design & Visual Communication', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Industrial Design', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Software Engineering', 'UX/UI Design', 'Urban & Regional Planning'],
  },
  {
    id: 'it-milan',
    name: 'University of Milan',
    country: 'ITALY',
    city: 'Milan',
    qsRank: 301,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Law', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unimi.it',
    established: 1923,
    campusType: 'Urban',
    about: 'Milan\'s largest public research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'it-padova',
    name: 'University of Padua',
    country: 'ITALY',
    city: 'Padua',
    qsRank: 241,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Engineering', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unipd.it',
    established: 1222,
    campusType: 'Urban',
    about: 'Italy\'s second-oldest university; pioneered modern scientific method.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Industrial & Systems Engineering', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'it-bocconi',
    name: 'Bocconi University',
    country: 'ITALY',
    city: 'Milan',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Law', 'Social Sciences', 'Economics'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 22000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 30,
    ielts: 6.5,
    toefl: 100,
    greRequired: false,
    website: 'https://unibocconi.eu',
    established: 1902,
    campusType: 'Urban',
    about: 'Europe\'s top business university; consistently top 5 globally for MBA.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Applied Economics', 'Behavioral Economics', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Development Economics', 'Econometrics', 'Economics', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-sda-bocconi',
    name: 'SDA Bocconi School of Management',
    country: 'ITALY',
    city: 'Milan',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 65000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 20,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://sdabocconi.it',
    established: 1971,
    campusType: 'Urban',
    about: 'Italy\'s leading executive MBA; top European business school.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-luiss',
    name: 'LUISS Guido Carli University',
    country: 'ITALY',
    city: 'Rome',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Social Sciences', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://luiss.it',
    established: 1966,
    campusType: 'Urban',
    about: 'Rome\'s prestigious private university known for economics and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-florence',
    name: 'University of Florence',
    country: 'ITALY',
    city: 'Florence',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Agriculture', 'Medicine & Health', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unifi.it',
    established: 1321,
    campusType: 'Urban',
    about: 'Florentine university with strong arts, sciences and agriculture.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Public Health (MPH)'],
  },
  {
    id: 'it-turin',
    name: 'University of Turin',
    country: 'ITALY',
    city: 'Turin',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Law', 'Natural Sciences', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unito.it',
    established: 1404,
    campusType: 'Urban',
    about: 'Top Turin research university with strong medicine and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-cattolica',
    name: 'Università Cattolica del Sacro Cuore',
    country: 'ITALY',
    city: 'Milan',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 50,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://unicatt.it',
    established: 1921,
    campusType: 'Urban',
    about: 'Italy\'s largest private Catholic university across multiple campuses.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-polito',
    name: 'Politecnico di Torino',
    country: 'ITALY',
    city: 'Turin',
    qsRank: 301,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 8000,
    currency: 'EUR',
    intakes: ['October', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://polito.it',
    established: 1906,
    campusType: 'Urban',
    about: 'Turin\'s tech university; strong in automotive and aerospace engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'es-barcelona',
    name: 'University of Barcelona',
    country: 'SPAIN',
    city: 'Barcelona',
    qsRank: 171,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Social Sciences', 'Arts & Humanities', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ub.edu',
    established: 1450,
    campusType: 'Urban',
    about: 'Catalonia\'s flagship research university; top Spanish institution.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'es-madrid-comp',
    name: 'Complutense University of Madrid',
    country: 'SPAIN',
    city: 'Madrid',
    qsRank: 201,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Law', 'Social Sciences', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3500,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ucm.es',
    established: 1293,
    campusType: 'Urban',
    about: 'Madrid\'s oldest and largest university; strong across all faculties.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'es-autonoma-barcelona',
    name: 'Universitat Autònoma de Barcelona',
    country: 'SPAIN',
    city: 'Bellaterra',
    qsRank: 194,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Social Sciences', 'Medicine & Health', 'Business & Management', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uab.cat',
    established: 1968,
    campusType: 'Suburban',
    about: 'Research university near Barcelona; known for sciences and humanities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'es-iese',
    name: 'IESE Business School',
    country: 'SPAIN',
    city: 'Barcelona',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 85000,
    tuitionMax: 95000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 15,
    ielts: 7.5,
    toefl: 110,
    greRequired: false,
    website: 'https://iese.edu',
    established: 1958,
    campusType: 'Urban',
    about: 'World-top MBA school in Barcelona; Navarra University business arm.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'es-esade',
    name: 'ESADE Business & Law School',
    country: 'SPAIN',
    city: 'Barcelona',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 50000,
    tuitionMax: 60000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 25,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://esade.edu',
    established: 1958,
    campusType: 'Urban',
    about: 'Top Barcelona business and law school; consistently top 10 globally.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'es-ie-business',
    name: 'IE Business School',
    country: 'SPAIN',
    city: 'Madrid',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 75000,
    tuitionMax: 85000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 20,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://ie.edu',
    established: 1973,
    campusType: 'Urban',
    about: 'Spain\'s most globally connected business school in Madrid.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'es-madrid-auto',
    name: 'Universidad Autónoma de Madrid',
    country: 'SPAIN',
    city: 'Madrid',
    qsRank: 260,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Medicine & Health', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3500,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 42,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uam.es',
    established: 1968,
    campusType: 'Suburban',
    about: 'Madrid research university with strong sciences and humanities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'es-valencia',
    name: 'University of Valencia',
    country: 'SPAIN',
    city: 'Valencia',
    qsRank: 401,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Social Sciences', 'Arts & Humanities', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 46,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uv.es',
    established: 1499,
    campusType: 'Urban',
    about: 'Valencia\'s prestigious public research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'es-sevilla',
    name: 'University of Seville',
    country: 'SPAIN',
    city: 'Seville',
    qsRank: 501,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Arts & Humanities', 'Business & Management', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://us.es',
    established: 1505,
    campusType: 'Urban',
    about: 'Andalusia\'s largest university with strong engineering and arts.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'es-carlos-iii',
    name: 'Universidad Carlos III de Madrid',
    country: 'SPAIN',
    city: 'Madrid',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Engineering', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 6000,
    tuitionMax: 10000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 48,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://uc3m.es',
    established: 1989,
    campusType: 'Suburban',
    about: 'Highly ranked young Madrid university; top for law and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'dk-dtu',
    name: 'Technical University of Denmark',
    country: 'DENMARK',
    city: 'Lyngby',
    qsRank: 97,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 38,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://dtu.dk',
    established: 1829,
    campusType: 'Suburban',
    about: 'Scandinavia\'s leading technical university; strong in engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'dk-copenhagen',
    name: 'University of Copenhagen',
    country: 'DENMARK',
    city: 'Copenhagen',
    qsRank: 121,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://ku.dk',
    established: 1479,
    campusType: 'Urban',
    about: 'Denmark\'s oldest and most prestigious research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'dk-aarhus',
    name: 'Aarhus University',
    country: 'DENMARK',
    city: 'Aarhus',
    qsRank: 150,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Social Sciences', 'Business & Management', 'Medicine & Health', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 44,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://au.dk',
    established: 1928,
    campusType: 'Urban',
    about: 'Denmark\'s second-largest university; strong research output.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'dk-cbs',
    name: 'Copenhagen Business School',
    country: 'DENMARK',
    city: 'Copenhagen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences', 'Law', 'Economics'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://cbs.dk',
    established: 1917,
    campusType: 'Urban',
    about: 'Scandinavia\'s top business school; globally ranked.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Applied Economics', 'Behavioral Economics', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Development Economics', 'Econometrics', 'Economics', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'no-oslo',
    name: 'University of Oslo',
    country: 'NORWAY',
    city: 'Oslo',
    qsRank: 199,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Law', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 2000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://uio.no',
    established: 1811,
    campusType: 'Urban',
    about: 'Norway\'s leading research university; free tuition for all students.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'no-ntnu',
    name: 'Norwegian University of Science and Technology',
    country: 'NORWAY',
    city: 'Trondheim',
    qsRank: 295,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Architecture', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 2000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://ntnu.no',
    established: 1910,
    campusType: 'Urban',
    about: 'Norway\'s technical university; top for engineering and architecture.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Pharmacy', 'Physics', 'Public Health (MPH)', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'no-bergen',
    name: 'University of Bergen',
    country: 'NORWAY',
    city: 'Bergen',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Medicine & Health', 'Arts & Humanities', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 2000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 50,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://uib.no',
    established: 1946,
    campusType: 'Urban',
    about: 'Bergen research university with strong marine sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'fi-helsinki',
    name: 'University of Helsinki',
    country: 'FINLAND',
    city: 'Helsinki',
    qsRank: 107,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Social Sciences', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://helsinki.fi',
    established: 1640,
    campusType: 'Urban',
    about: 'Finland\'s flagship research university; free for EU students.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'fi-aalto',
    name: 'Aalto University',
    country: 'FINLAND',
    city: 'Espoo',
    qsRank: 109,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 38,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://aalto.fi',
    established: 2010,
    campusType: 'Suburban',
    about: 'Finland\'s innovation university; merger of top design, tech, and business schools.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'fi-tampere',
    name: 'Tampere University',
    country: 'FINLAND',
    city: 'Tampere',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Medicine & Health', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://tuni.fi',
    established: 2019,
    campusType: 'Urban',
    about: 'Finnish research university known for tech and healthcare.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'be-ku-leuven',
    name: 'KU Leuven',
    country: 'BELGIUM',
    city: 'Leuven',
    qsRank: 73,
    usNewsRank: 52,
    programs: ['Natural Sciences', 'Engineering', 'Medicine & Health', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://kuleuven.be',
    established: 1425,
    campusType: 'Urban',
    about: 'Belgium\'s top research university; one of Europe\'s oldest.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'be-ghent',
    name: 'Ghent University',
    country: 'BELGIUM',
    city: 'Ghent',
    qsRank: 67,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Engineering', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://ugent.be',
    established: 1817,
    campusType: 'Urban',
    about: 'Belgium\'s highly-ranked research university in Flanders.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'be-vlerick',
    name: 'Vlerick Business School',
    country: 'BELGIUM',
    city: 'Ghent',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 42000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://vlerick.com',
    established: 1953,
    campusType: 'Urban',
    about: 'Belgium\'s top private business school; globally ranked.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'at-vienna',
    name: 'University of Vienna',
    country: 'AUSTRIA',
    city: 'Vienna',
    qsRank: 151,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Law', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://univie.ac.at',
    established: 1365,
    campusType: 'Urban',
    about: 'Austria\'s oldest and largest university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'at-tu-vienna',
    name: 'Vienna University of Technology',
    country: 'AUSTRIA',
    city: 'Vienna',
    qsRank: 198,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Architecture', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 42,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://tuwien.at',
    established: 1815,
    campusType: 'Urban',
    about: 'Austria\'s premier technical university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'at-wu',
    name: 'Vienna University of Economics and Business',
    country: 'AUSTRIA',
    city: 'Vienna',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://wu.ac.at',
    established: 1898,
    campusType: 'Urban',
    about: 'Europe\'s largest business university; strong for economics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'at-graz',
    name: 'University of Graz',
    country: 'AUSTRIA',
    city: 'Graz',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Medicine & Health', 'Social Sciences', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-graz.at',
    established: 1585,
    campusType: 'Urban',
    about: 'Styria\'s leading research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'jp-tokyo',
    name: 'University of Tokyo',
    country: 'JAPAN',
    city: 'Tokyo',
    qsRank: 28,
    usNewsRank: 10,
    programs: ['Natural Sciences', 'Engineering', 'Medicine & Health', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5500,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 25,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://u-tokyo.ac.jp',
    established: 1877,
    campusType: 'Urban',
    about: 'Japan\'s most prestigious university; top for science and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Industrial & Systems Engineering', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'jp-kyoto',
    name: 'Kyoto University',
    country: 'JAPAN',
    city: 'Kyoto',
    qsRank: 46,
    usNewsRank: 25,
    programs: ['Natural Sciences', 'Medicine & Health', 'Engineering', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5500,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 28,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://kyoto-u.ac.jp',
    established: 1897,
    campusType: 'Suburban',
    about: 'Japan\'s second-top university; 19 Nobel laureates.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'jp-osaka',
    name: 'Osaka University',
    country: 'JAPAN',
    city: 'Osaka',
    qsRank: 80,
    usNewsRank: 52,
    programs: ['Natural Sciences', 'Medicine & Health', 'Engineering', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5500,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 35,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://osaka-u.ac.jp',
    established: 1931,
    campusType: 'Suburban',
    about: 'Japan\'s leading medical research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'jp-tokyo-tech',
    name: 'Tokyo Institute of Technology',
    country: 'JAPAN',
    city: 'Tokyo',
    qsRank: 55,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5500,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://titech.ac.jp',
    established: 1881,
    campusType: 'Suburban',
    about: 'Japan\'s top technical university; world-class for engineering and CS.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'jp-waseda',
    name: 'Waseda University',
    country: 'JAPAN',
    city: 'Tokyo',
    qsRank: 208,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Social Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://waseda.jp',
    established: 1882,
    campusType: 'Urban',
    about: 'Japan\'s leading private university with strong global programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'jp-keio',
    name: 'Keio University',
    country: 'JAPAN',
    city: 'Tokyo',
    qsRank: 189,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 44,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://keio.ac.jp',
    established: 1858,
    campusType: 'Urban',
    about: 'Japan\'s oldest private university; strong business and medicine.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'kr-snu',
    name: 'Seoul National University',
    country: 'SOUTH_KOREA',
    city: 'Seoul',
    qsRank: 31,
    usNewsRank: 52,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Medicine & Health', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 20,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://snu.ac.kr',
    established: 1946,
    campusType: 'Urban',
    about: 'South Korea\'s most prestigious university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'kr-kaist',
    name: 'KAIST',
    country: 'SOUTH_KOREA',
    city: 'Daejeon',
    qsRank: 56,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 25,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://kaist.ac.kr',
    established: 1971,
    campusType: 'Suburban',
    about: 'South Korea\'s MIT; world-class for engineering and tech.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'kr-yonsei',
    name: 'Yonsei University',
    country: 'SOUTH_KOREA',
    city: 'Seoul',
    qsRank: 72,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Engineering', 'Arts & Humanities', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 33,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://yonsei.ac.kr',
    established: 1885,
    campusType: 'Urban',
    about: 'One of South Korea\'s top private universities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'kr-korea',
    name: 'Korea University',
    country: 'SOUTH_KOREA',
    city: 'Seoul',
    qsRank: 74,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Engineering', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 36,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://korea.ac.kr',
    established: 1905,
    campusType: 'Urban',
    about: 'Prestigious Korean university; one of the SKY universities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-um',
    name: 'University of Malaya',
    country: 'MALAYSIA',
    city: 'Kuala Lumpur',
    qsRank: 65,
    usNewsRank: 152,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Medicine & Health', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 35,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://um.edu.my',
    established: 1905,
    campusType: 'Urban',
    about: 'Malaysia\'s top-ranked university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-utm',
    name: 'Universiti Teknologi Malaysia',
    country: 'MALAYSIA',
    city: 'Johor Bahru',
    qsRank: 195,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://utm.my',
    established: 1904,
    campusType: 'Suburban',
    about: 'Malaysia\'s leading technical university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'my-utp',
    name: 'Universiti Teknologi PETRONAS',
    country: 'MALAYSIA',
    city: 'Seri Iskandar',
    qsRank: 280,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://utp.edu.my',
    established: 1997,
    campusType: 'Suburban',
    about: 'Oil and gas engineering university funded by Petronas.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-taylor',
    name: 'Taylor\'s University',
    country: 'MALAYSIA',
    city: 'Subang Jaya',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Hospitality & Tourism', 'Engineering', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://taylors.edu.my',
    established: 1969,
    campusType: 'Suburban',
    about: 'Malaysia\'s top private university for hospitality and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food & Beverage Management', 'History', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'my-sunway',
    name: 'Sunway University',
    country: 'MALAYSIA',
    city: 'Subang Jaya',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 7000,
    tuitionMax: 10000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sunway.edu.my',
    established: 1987,
    campusType: 'Suburban',
    about: 'Malaysian private university with Lancaster University partnership.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'hk-hku',
    name: 'University of Hong Kong',
    country: 'HONG_KONG',
    city: 'Hong Kong',
    qsRank: 17,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Law', 'Engineering', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 23,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://hku.hk',
    established: 1911,
    campusType: 'Urban',
    about: 'Hong Kong\'s oldest university; globally top-ranked.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'hk-cuhk',
    name: 'Chinese University of Hong Kong',
    country: 'HONG_KONG',
    city: 'Hong Kong',
    qsRank: 36,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Medicine & Health', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://cuhk.edu.hk',
    established: 1963,
    campusType: 'Suburban',
    about: 'Bilingual research university in Hong Kong; strong for business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'hk-hkust',
    name: 'Hong Kong University of Science and Technology',
    country: 'HONG_KONG',
    city: 'Hong Kong',
    qsRank: 47,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 28,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://ust.hk',
    established: 1991,
    campusType: 'Suburban',
    about: 'Hong Kong\'s top tech university; consistently in global top 50.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-napier',
    name: 'Edinburgh Napier University',
    country: 'UK',
    city: 'Edinburgh',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://napier.ac.uk',
    established: 1964,
    campusType: 'Urban',
    about: 'Edinburgh modern university known for creative industries and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-staffordshire',
    name: 'Staffordshire University',
    country: 'UK',
    city: 'Stoke-on-Trent',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Arts & Humanities', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://staffs.ac.uk',
    established: 1992,
    campusType: 'Urban',
    about: 'Midlands university known for gaming, computing, and forensic science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-bedfordshire',
    name: 'University of Bedfordshire',
    country: 'UK',
    city: 'Luton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://beds.ac.uk',
    established: 1993,
    campusType: 'Urban',
    about: 'Bedfordshire university with diverse student population.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-hertfordshire',
    name: 'University of Hertfordshire',
    country: 'UK',
    city: 'Hatfield',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Pharmacy', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://herts.ac.uk',
    established: 1952,
    campusType: 'Suburban',
    about: 'London commuter university with strong aerospace engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Clinical Pharmacy', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy (PharmD/BPharm)', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-southampton-solent',
    name: 'Solent University',
    country: 'UK',
    city: 'Southampton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Engineering', 'Media & Communications', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://solent.ac.uk',
    established: 2005,
    campusType: 'Urban',
    about: 'Southampton modern university known for yacht design and maritime.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-lincoln',
    name: 'University of Lincoln',
    country: 'UK',
    city: 'Lincoln',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://lincoln.ac.uk',
    established: 1996,
    campusType: 'Urban',
    about: 'Lincoln university with strong engineering and arts programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-uwe',
    name: 'University of the West of England',
    country: 'UK',
    city: 'Bristol',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uwe.ac.uk',
    established: 1992,
    campusType: 'Suburban',
    about: 'Bristol\'s modern university with strong industry connections.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-manchester-met',
    name: 'Manchester Metropolitan University',
    country: 'UK',
    city: 'Manchester',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://mmu.ac.uk',
    established: 1970,
    campusType: 'Urban',
    about: 'Manchester\'s modern university with strong business and arts programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-brighton',
    name: 'University of Brighton',
    country: 'UK',
    city: 'Brighton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Engineering', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://brighton.ac.uk',
    established: 1858,
    campusType: 'Urban',
    about: 'Coastal university with strong design and sports science programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-kent',
    name: 'University of Kent',
    country: 'UK',
    city: 'Canterbury',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Social Sciences', 'Business & Management', 'Law', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 80,
    greRequired: false,
    website: 'https://kent.ac.uk',
    established: 1965,
    campusType: 'Suburban',
    about: 'England\'s European university; strong for social sciences and drama.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-charles-darwin',
    name: 'Charles Darwin University',
    country: 'AUSTRALIA',
    city: 'Darwin, NT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Education', 'Business & Management', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 31000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://cdu.edu.au',
    established: 1974,
    campusType: 'Urban',
    about: 'Northern Territory\'s university with unique outback research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-federation',
    name: 'Federation University Australia',
    country: 'AUSTRALIA',
    city: 'Ballarat, VIC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Education', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 30000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://federation.edu.au',
    established: 1870,
    campusType: 'Suburban',
    about: 'Victorian regional university with strong engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-canberra',
    name: 'University of Canberra',
    country: 'AUSTRALIA',
    city: 'Canberra, ACT',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Health Sciences', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://canberra.edu.au',
    established: 1967,
    campusType: 'Suburban',
    about: 'ACT university with strong health science and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-ecu',
    name: 'Edith Cowan University',
    country: 'AUSTRALIA',
    city: 'Perth, WA',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 26000,
    tuitionMax: 32000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ecu.edu.au',
    established: 1991,
    campusType: 'Suburban',
    about: 'Western Australian university with strong nursing and education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-sch-cath',
    name: 'Australian Catholic University',
    country: 'AUSTRALIA',
    city: 'Brisbane, QLD',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Education', 'Medicine & Health', 'Business & Management', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 26000,
    tuitionMax: 32000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 71,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://acu.edu.au',
    established: 1991,
    campusType: 'Urban',
    about: 'Multi-campus Catholic university across Australia\'s major cities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-murdoch',
    name: 'Murdoch University',
    country: 'AUSTRALIA',
    city: 'Perth, WA',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Natural Sciences', 'Veterinary Medicine', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 31000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://murdoch.edu.au',
    established: 1975,
    campusType: 'Suburban',
    about: 'WA university known for veterinary science and environmental research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Animal Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health'],
  },
  {
    id: 'au-sunshine-coast',
    name: 'University of the Sunshine Coast',
    country: 'AUSTRALIA',
    city: 'Sippy Downs, QLD',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Education', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 29000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://usc.edu.au',
    established: 1994,
    campusType: 'Suburban',
    about: 'Queensland regional university with strong sustainability programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-central-qld',
    name: 'Central Queensland University',
    country: 'AUSTRALIA',
    city: 'Rockhampton, QLD',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 27000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://cqu.edu.au',
    established: 1967,
    campusType: 'Suburban',
    about: 'CQU with multiple campuses across Queensland.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-charles-sturt',
    name: 'Charles Sturt University',
    country: 'AUSTRALIA',
    city: 'Bathurst, NSW',
    qsRank: null,
    usNewsRank: null,
    programs: ['Agriculture', 'Education', 'Business & Management', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 29000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 80,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csu.edu.au',
    established: 1989,
    campusType: 'Rural',
    about: 'NSW regional university known for agriculture and wine studies.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-wsu',
    name: 'Western Sydney University',
    country: 'AUSTRALIA',
    city: 'Penrith, NSW',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Medicine & Health', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 31000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://westernsydney.edu.au',
    established: 1989,
    campusType: 'Suburban',
    about: 'Multi-campus western Sydney university with strong medicine programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-dalhousie2',
    name: 'Saint Mary\'s University',
    country: 'CANADA',
    city: 'Halifax, NS',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 21000,
    tuitionMax: 26000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 72,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://smu.ca',
    established: 1802,
    campusType: 'Urban',
    about: 'Halifax university with strong astronomy and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-acadia',
    name: 'Acadia University',
    country: 'CANADA',
    city: 'Wolfville, NS',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 20000,
    tuitionMax: 25000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://acadiau.ca',
    established: 1838,
    campusType: 'Rural',
    about: 'Nova Scotia liberal arts university with strong science programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-memorial',
    name: 'Memorial University of Newfoundland',
    country: 'CANADA',
    city: 'St. John\'s, NL',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Medicine & Health', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mun.ca',
    established: 1949,
    campusType: 'Suburban',
    about: 'Newfoundland\'s only university; top for ocean engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-thompson',
    name: 'Thompson Rivers University',
    country: 'CANADA',
    city: 'Kamloops, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://tru.ca',
    established: 2005,
    campusType: 'Suburban',
    about: 'BC university with open learning and distance education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-kwantlen',
    name: 'Kwantlen Polytechnic University',
    country: 'CANADA',
    city: 'Surrey, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://kpu.ca',
    established: 1981,
    campusType: 'Suburban',
    about: 'Metro Vancouver polytechnic with strong design and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-mohawk',
    name: 'Mohawk College',
    country: 'CANADA',
    city: 'Hamilton, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Health Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mohawkcollege.ca',
    established: 1966,
    campusType: 'Suburban',
    about: 'Hamilton college with strong engineering technology programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-conestoga',
    name: 'Conestoga College',
    country: 'CANADA',
    city: 'Kitchener, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://conestogac.on.ca',
    established: 1967,
    campusType: 'Suburban',
    about: 'Ontario college with highest graduate employment rates.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ca-fanshawe',
    name: 'Fanshawe College',
    country: 'CANADA',
    city: 'London, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Health Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://fanshawec.ca',
    established: 1967,
    campusType: 'Urban',
    about: 'London Ontario college known for aviation and skilled trades.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-algonquin',
    name: 'Algonquin College',
    country: 'CANADA',
    city: 'Ottawa, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Health Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://algonquincollege.com',
    established: 1967,
    campusType: 'Suburban',
    about: 'Ottawa\'s largest college with strong tech and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-college-montreal',
    name: 'Collège de Maisonneuve',
    country: 'CANADA',
    city: 'Montreal, QC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://cmaisonneuve.qc.ca',
    established: 1961,
    campusType: 'Urban',
    about: 'Montreal CEGEP with diverse pre-university programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-nbcc',
    name: 'New Brunswick Community College',
    country: 'CANADA',
    city: 'Moncton, NB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Health Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://nbcc.ca',
    established: 1981,
    campusType: 'Urban',
    about: 'New Brunswick\'s community college with campuses province-wide.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-nscad',
    name: 'NSCAD University',
    country: 'CANADA',
    city: 'Halifax, NS',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Media & Communications', 'Design', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://nscad.ca',
    established: 1887,
    campusType: 'Urban',
    about: 'Nova Scotia art and design university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Architecture', 'Art History & Curatorship', 'Broadcasting & Media Production', 'Digital Media & Content', 'Fashion Design & Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Graphic Design & Visual Communication', 'History', 'Industrial Design', 'Interior Design', 'Journalism & Mass Communication', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'Music & Performing Arts', 'Philosophy', 'Public Relations & Advertising', 'UX/UI Design', 'Urban & Regional Planning'],
  },
  {
    id: 'ie-wit',
    name: 'Waterford Institute of Technology',
    country: 'IRELAND',
    city: 'Waterford',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://wit.ie',
    established: 1970,
    campusType: 'Urban',
    about: 'Waterford\'s institute now merged into South East Technological University.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-nci',
    name: 'National College of Ireland',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 10000,
    tuitionMax: 14000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ncirl.ie',
    established: 1951,
    campusType: 'Urban',
    about: 'Dublin city centre college focused on business and technology.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-cit',
    name: 'Munster Tech University Cork',
    country: 'IRELAND',
    city: 'Cork',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mtu.ie',
    established: 1912,
    campusType: 'Urban',
    about: 'Cork campus of Munster Technological University.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ie-gcd',
    name: 'Griffith College Dublin',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://griffith.ie',
    established: 1974,
    campusType: 'Urban',
    about: 'Dublin\'s largest independent college with strong law programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-ibat',
    name: 'IBAT College Dublin',
    country: 'IRELAND',
    city: 'Dublin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 9000,
    tuitionMax: 13000,
    currency: 'EUR',
    intakes: ['September'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ibat.ie',
    established: 2004,
    campusType: 'Urban',
    about: 'Dublin private college with strong tech and business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-duesseldorf',
    name: 'Heinrich Heine University Düsseldorf',
    country: 'GERMANY',
    city: 'Düsseldorf',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Business & Management', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://hhu.de',
    established: 1965,
    campusType: 'Suburban',
    about: 'Düsseldorf university strong in medicine and natural sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-giessen',
    name: 'Justus Liebig University Giessen',
    country: 'GERMANY',
    city: 'Giessen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Agriculture', 'Natural Sciences', 'Social Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 44,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-giessen.de',
    established: 1607,
    campusType: 'Suburban',
    about: 'Hessian university known for agriculture and veterinary medicine.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'de-muenster',
    name: 'University of Münster',
    country: 'GERMANY',
    city: 'Münster',
    qsRank: 298,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Medicine & Health', 'Law', 'Business & Management', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-muenster.de',
    established: 1780,
    campusType: 'Urban',
    about: 'Westphalian research university; one of Germany\'s largest.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-kiel',
    name: 'Kiel University',
    country: 'GERMANY',
    city: 'Kiel',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Medicine & Health', 'Engineering', 'Social Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 44,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-kiel.de',
    established: 1665,
    campusType: 'Urban',
    about: 'Northern German university by the Baltic Sea; known for marine science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Industrial & Systems Engineering', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'de-whu',
    name: 'WHU - Otto Beisheim School of Management',
    country: 'GERMANY',
    city: 'Vallendar',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 46000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 25,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://whu.edu',
    established: 1984,
    campusType: 'Suburban',
    about: 'Germany\'s top private business school; global MBA rankings.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-esmt',
    name: 'ESMT Berlin',
    country: 'GERMANY',
    city: 'Berlin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 50000,
    tuitionMax: 60000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 22,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://esmt.org',
    established: 2002,
    campusType: 'Urban',
    about: 'Germany\'s leading international business school in Berlin.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-hwr',
    name: 'HWR Berlin',
    country: 'GERMANY',
    city: 'Berlin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 6000,
    tuitionMax: 9000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 55,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://hwr-berlin.de',
    established: 1971,
    campusType: 'Urban',
    about: 'Berlin university of applied sciences for economics and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-fom',
    name: 'FOM University',
    country: 'GERMANY',
    city: 'Essen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Psychology', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 14000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://fom.de',
    established: 1991,
    campusType: 'Urban',
    about: 'Germany\'s largest private university of applied sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Clinical Psychology', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Counselling Psychology', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Organizational Psychology', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-hsrm',
    name: 'RheinMain University',
    country: 'GERMANY',
    city: 'Wiesbaden',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 58,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://hs-rm.de',
    established: 1971,
    campusType: 'Urban',
    about: 'Hessian applied sciences university near Frankfurt.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'International Relations & Diplomacy', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'de-haw',
    name: 'HAW Hamburg',
    country: 'GERMANY',
    city: 'Hamburg',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['October', 'April'],
    acceptanceRate: 58,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://haw-hamburg.de',
    established: 1970,
    campusType: 'Urban',
    about: 'Hamburg applied sciences university; strong in tech and social sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-dauphine',
    name: 'Université Paris Dauphine - PSL',
    country: 'FRANCE',
    city: 'Paris',
    qsRank: null,
    usNewsRank: null,
    programs: ['Finance & Accounting', 'Business & Management', 'Social Sciences', 'Law', 'Economics'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 8000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 25,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://dauphine.psl.eu',
    established: 1968,
    campusType: 'Urban',
    about: 'Elite Parisian management and economics university within PSL.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Applied Economics', 'Behavioral Economics', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Development Economics', 'Econometrics', 'Economics', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'Investment Management', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-insa-lyon',
    name: 'INSA Lyon',
    country: 'FRANCE',
    city: 'Lyon',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 6000,
    tuitionMax: 10000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://insa-lyon.fr',
    established: 1957,
    campusType: 'Suburban',
    about: 'France\'s premier engineering school in Lyon.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'fr-telecom-paris',
    name: 'Télécom Paris',
    country: 'FRANCE',
    city: 'Paris',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Data Science & AI', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 7000,
    tuitionMax: 11000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 25,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://telecom-paris.fr',
    established: 1878,
    campusType: 'Suburban',
    about: 'France\'s top telecom and digital engineering grande école.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-mines-nancy',
    name: 'Mines Nancy',
    country: 'FRANCE',
    city: 'Nancy',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Computer Science & IT', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 9000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 28,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://mines-nancy.univ-lorraine.fr',
    established: 1919,
    campusType: 'Urban',
    about: 'French school of mines with strong industrial engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-grenoble-inp',
    name: 'Grenoble INP',
    country: 'FRANCE',
    city: 'Grenoble',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Architecture', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 9000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 35,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://grenoble-inp.fr',
    established: 1900,
    campusType: 'Urban',
    about: 'Grenoble science and tech institute; strong in microelectronics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'fr-cergy',
    name: 'CY Cergy Paris Université',
    country: 'FRANCE',
    city: 'Cergy',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Social Sciences', 'Natural Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 42,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://cy-u.fr',
    established: 1991,
    campusType: 'Suburban',
    about: 'Paris-area research university with diverse academic programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-unistra',
    name: 'University of Strasbourg',
    country: 'FRANCE',
    city: 'Strasbourg',
    qsRank: 251,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Social Sciences', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://unistra.fr',
    established: 1537,
    campusType: 'Urban',
    about: 'Alsatian research university on the French-German border.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'fr-rennes1',
    name: 'University of Rennes 1',
    country: 'FRANCE',
    city: 'Rennes',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Medicine & Health', 'Engineering', 'Law', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 6000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://univ-rennes.fr',
    established: 1461,
    campusType: 'Urban',
    about: 'Brittany\'s research university with strong STEM programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-han',
    name: 'HAN University of Applied Sciences',
    country: 'NETHERLANDS',
    city: 'Arnhem',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://han.nl',
    established: 1996,
    campusType: 'Suburban',
    about: 'Arnhem & Nijmegen applied sciences university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-avans',
    name: 'Avans University of Applied Sciences',
    country: 'NETHERLANDS',
    city: 'Breda',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 7000,
    tuitionMax: 11000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://avans.nl',
    established: 2004,
    campusType: 'Urban',
    about: 'Brabant applied sciences university with international programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-fontys',
    name: 'Fontys University of Applied Sciences',
    country: 'NETHERLANDS',
    city: 'Eindhoven',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 7000,
    tuitionMax: 11000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://fontys.edu',
    established: 1995,
    campusType: 'Urban',
    about: 'Eindhoven applied sciences university with 7 campuses.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-nhl-stenden',
    name: 'NHL Stenden University',
    country: 'NETHERLANDS',
    city: 'Leeuwarden',
    qsRank: null,
    usNewsRank: null,
    programs: ['Hospitality & Tourism', 'Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://nhlstenden.com',
    established: 2018,
    campusType: 'Suburban',
    about: 'Frisian applied sciences university; top for hospitality.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food & Beverage Management', 'History', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'nl-windesheim',
    name: 'Windesheim University',
    country: 'NETHERLANDS',
    city: 'Zwolle',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 7000,
    tuitionMax: 11000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://windesheim.nl',
    established: 1986,
    campusType: 'Urban',
    about: 'Overijssel applied sciences university with strong social programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iit-bombay2',
    name: 'IIT Indore',
    country: 'INDIA',
    city: 'Indore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 32,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iiti.ac.in',
    established: 2009,
    campusType: 'Suburban',
    about: 'Central Indian IIT with growing research programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'in-iit-varanasi',
    name: 'IIT (BHU) Varanasi',
    country: 'INDIA',
    city: 'Varanasi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 35,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitbhu.ac.in',
    established: 1919,
    campusType: 'Urban',
    about: 'IIT within BHU campus; strong in mining and metallurgical engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-nit-trichy',
    name: 'NIT Tiruchirappalli',
    country: 'INDIA',
    city: 'Tiruchirappalli',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 45,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://nitt.edu',
    established: 1964,
    campusType: 'Suburban',
    about: 'South India\'s top National Institute of Technology.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-nit-warangal',
    name: 'NIT Warangal',
    country: 'INDIA',
    city: 'Warangal',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 52,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://nitw.ac.in',
    established: 1959,
    campusType: 'Suburban',
    about: 'Telangana\'s premier NIT with strong placement record.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-nit-surathkal',
    name: 'NIT Karnataka',
    country: 'INDIA',
    city: 'Surathkal',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 50,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://nitk.ac.in',
    established: 1960,
    campusType: 'Coastal',
    about: 'Coastal Karnataka NIT; strong in engineering and marine sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-kozhikode',
    name: 'IIM Kozhikode',
    country: 'INDIA',
    city: 'Kozhikode',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 28000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 15,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iimk.ac.in',
    established: 1996,
    campusType: 'Suburban',
    about: 'Kerala IIM known for its MBA and executive programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-lucknow',
    name: 'IIM Lucknow',
    country: 'INDIA',
    city: 'Lucknow',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 32000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 12,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iiml.ac.in',
    established: 1984,
    campusType: 'Suburban',
    about: 'UP\'s prestigious IIM; strong for agribusiness management.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-indore',
    name: 'IIM Indore',
    country: 'INDIA',
    city: 'Indore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 28000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 14,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iimidr.ac.in',
    established: 1996,
    campusType: 'Suburban',
    about: 'Central India IIM; known for integrated management program.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-fms',
    name: 'Faculty of Management Studies Delhi',
    country: 'INDIA',
    city: 'New Delhi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 15000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 10,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://fms.edu',
    established: 1954,
    campusType: 'Urban',
    about: 'Delhi University\'s business school; most affordable top MBA.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-spjimr',
    name: 'S P Jain Institute Mumbai',
    country: 'INDIA',
    city: 'Mumbai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 30000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 15,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://spjimr.org',
    established: 1981,
    campusType: 'Urban',
    about: 'Mumbai business school with strong placement record.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-sibm',
    name: 'Symbiosis Institute of Business Management',
    country: 'INDIA',
    city: 'Pune',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 20000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 30,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sibm.edu',
    established: 1978,
    campusType: 'Suburban',
    about: 'Pune\'s top private management institute.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-mit-pune',
    name: 'MIT World Peace University',
    country: 'INDIA',
    city: 'Pune',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 63,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://mitwpu.edu.in',
    established: 2017,
    campusType: 'Suburban',
    about: 'Pune private university with diverse engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-upes',
    name: 'UPES Dehradun',
    country: 'INDIA',
    city: 'Dehradun',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Law', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 67,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://upes.ac.in',
    established: 2003,
    campusType: 'Suburban',
    about: 'Energy sector university with strong petroleum engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-sharda',
    name: 'Sharda University',
    country: 'INDIA',
    city: 'Greater Noida',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Medicine & Health', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 6000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 72,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://sharda.ac.in',
    established: 2009,
    campusType: 'Suburban',
    about: 'NCR private university with diverse programs and international students.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-galgotias',
    name: 'Galgotias University',
    country: 'INDIA',
    city: 'Greater Noida',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 76,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://galgotiasuniversity.edu.in',
    established: 2011,
    campusType: 'Suburban',
    about: 'UP private university with strong tech and management programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-sam-houston',
    name: 'Sam Houston State University',
    country: 'USA',
    city: 'Huntsville, TX',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 19000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://shsu.edu',
    established: 1879,
    campusType: 'Suburban',
    about: 'Texas state university with strong criminal justice programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-utsa',
    name: 'University of Texas San Antonio',
    country: 'USA',
    city: 'San Antonio, TX',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://utsa.edu',
    established: 1969,
    campusType: 'Suburban',
    about: 'Largest UT System campus by enrollment; strong business school.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-utep',
    name: 'University of Texas El Paso',
    country: 'USA',
    city: 'El Paso, TX',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 100,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://utep.edu',
    established: 1914,
    campusType: 'Urban',
    about: 'Border region research university with strong engineering.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-utarlington',
    name: 'University of Texas Arlington',
    country: 'USA',
    city: 'Arlington, TX',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 27000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uta.edu',
    established: 1895,
    campusType: 'Suburban',
    about: 'DFW metro public university with top aerospace engineering.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-ttu',
    name: 'Texas Tech University',
    country: 'USA',
    city: 'Lubbock, TX',
    qsRank: 601,
    usNewsRank: 131,
    programs: ['Engineering', 'Business & Management', 'Agriculture', 'Computer Science & IT', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 26000,
    tuitionMax: 29000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 69,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ttu.edu',
    established: 1923,
    campusType: 'Suburban',
    about: 'West Texas university with strong business and engineering.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-iowa-state',
    name: 'Iowa State University',
    country: 'USA',
    city: 'Ames, IA',
    qsRank: 601,
    usNewsRank: 71,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 27000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 91,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://iastate.edu',
    established: 1858,
    campusType: 'Suburban',
    about: 'Iowa\'s STEM-focused land-grant university.',
    rankings: { ugCS: 98, ugEngineering: 50, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-kansas-state',
    name: 'Kansas State University',
    country: 'USA',
    city: 'Manhattan, KS',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Architecture', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 28000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 94,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://k-state.edu',
    established: 1863,
    campusType: 'Suburban',
    about: 'Kansas land-grant with top vet medicine and agriculture.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-washington-state',
    name: 'Washington State University',
    country: 'USA',
    city: 'Pullman, WA',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Veterinary Medicine'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 26000,
    tuitionMax: 29000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 76,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://wsu.edu',
    established: 1890,
    campusType: 'Rural',
    about: 'Pacific Northwest land-grant with strong agriculture and vet.',
    rankings: { ugCS: 98, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Animal Sciences', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health'],
  },
  {
    id: 'usa-oregon',
    name: 'University of Oregon',
    country: 'USA',
    city: 'Eugene, OR',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Business & Management', 'Social Sciences', 'Arts & Humanities', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 7,
    toefl: 80,
    greRequired: false,
    website: 'https://uoregon.edu',
    established: 1876,
    campusType: 'Suburban',
    about: 'Oregon\'s flagship university; strong for business and law.',
    rankings: { ugCS: 71, ugEngineering: null, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-oregon-state',
    name: 'Oregon State University',
    country: 'USA',
    city: 'Corvallis, OR',
    qsRank: 601,
    usNewsRank: 131,
    programs: ['Engineering', 'Agriculture', 'Computer Science & IT', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 31000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://oregonstate.edu',
    established: 1868,
    campusType: 'Suburban',
    about: 'Oregon\'s land-grant with top engineering and forestry.',
    rankings: { ugCS: 63, ugEngineering: 64, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-idaho',
    name: 'University of Idaho',
    country: 'USA',
    city: 'Moscow, ID',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Natural Sciences', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 27000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 76,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uidaho.edu',
    established: 1889,
    campusType: 'Rural',
    about: 'Idaho\'s land-grant flagship with strong engineering.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-wyoming',
    name: 'University of Wyoming',
    country: 'USA',
    city: 'Laramie, WY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Agriculture', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 95,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uwyo.edu',
    established: 1886,
    campusType: 'Suburban',
    about: 'Wyoming\'s only four-year university; affordable tuition.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-new-mexico',
    name: 'University of New Mexico',
    country: 'USA',
    city: 'Albuquerque, NM',
    qsRank: null,
    usNewsRank: 87,
    programs: ['Engineering', 'Business & Management', 'Law', 'Medicine & Health', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 26000,
    tuitionMax: 29000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 64,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://unm.edu',
    established: 1889,
    campusType: 'Urban',
    about: 'New Mexico flagship with strong research in aerospace.',
    rankings: { ugCS: 117, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-nevada-reno',
    name: 'University of Nevada Reno',
    country: 'USA',
    city: 'Reno, NV',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Medicine & Health', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://unr.edu',
    established: 1874,
    campusType: 'Suburban',
    about: 'Nevada\'s flagship land-grant research university.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-boise-state',
    name: 'Boise State University',
    country: 'USA',
    city: 'Boise, ID',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://boisestate.edu',
    established: 1932,
    campusType: 'Urban',
    about: 'Idaho\'s largest university; strong for cybersecurity and engineering.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-ndsu',
    name: 'North Dakota State University',
    country: 'USA',
    city: 'Fargo, ND',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 91,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ndsu.edu',
    established: 1890,
    campusType: 'Urban',
    about: 'North Dakota\'s flagship research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-sdsu-brookings',
    name: 'South Dakota State University',
    country: 'USA',
    city: 'Brookings, SD',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 92,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sdstate.edu',
    established: 1881,
    campusType: 'Rural',
    about: 'South Dakota\'s land-grant with strong agriculture and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-nebraska',
    name: 'University of Nebraska',
    country: 'USA',
    city: 'Lincoln, NE',
    qsRank: null,
    usNewsRank: 131,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 27000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://unl.edu',
    established: 1869,
    campusType: 'Suburban',
    about: 'Nebraska\'s flagship land-grant university in Lincoln.',
    rankings: { ugCS: 78, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-indiana-purdue',
    name: 'IUPUI - Indiana University Purdue University',
    country: 'USA',
    city: 'Indianapolis, IN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Medicine & Health', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://iupui.edu',
    established: 1969,
    campusType: 'Urban',
    about: 'Indianapolis joint campus of IU and Purdue.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-umkc',
    name: 'University of Missouri-Kansas City',
    country: 'USA',
    city: 'Kansas City, MO',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Law', 'Medicine & Health', 'Engineering', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://umkc.edu',
    established: 1929,
    campusType: 'Urban',
    about: 'Kansas City research university with strong health sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-wichita-state',
    name: 'Wichita State University',
    country: 'USA',
    city: 'Wichita, KS',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 19000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://wichita.edu',
    established: 1895,
    campusType: 'Urban',
    about: 'Kansas university in the heart of aviation manufacturing.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-se-louisiana',
    name: 'University of Louisiana Lafayette',
    country: 'USA',
    city: 'Lafayette, LA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://louisiana.edu',
    established: 1898,
    campusType: 'Urban',
    about: 'South Louisiana university with Cajun culture and oil industry ties.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-loyola-no',
    name: 'Loyola University New Orleans',
    country: 'USA',
    city: 'New Orleans, LA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 50000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://loyno.edu',
    established: 1904,
    campusType: 'Urban',
    about: 'Jesuit New Orleans university with strong law school.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-xavier-no',
    name: 'Xavier University of Louisiana',
    country: 'USA',
    city: 'New Orleans, LA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Business & Management', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 50,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://xula.edu',
    established: 1925,
    campusType: 'Urban',
    about: 'Historically Black university; top for placing students in med school.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Curriculum & Instruction', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-howard',
    name: 'Howard University',
    country: 'USA',
    city: 'Washington, DC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Engineering', 'Medicine & Health', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 32000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 49,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://howard.edu',
    established: 1867,
    campusType: 'Urban',
    about: 'Historically Black university in Washington DC; prestigious HBCU.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-morehouse',
    name: 'Morehouse College',
    country: 'USA',
    city: 'Atlanta, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 27000,
    tuitionMax: 31000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://morehouse.edu',
    established: 1867,
    campusType: 'Urban',
    about: 'All-male HBCU in Atlanta; Martin Luther King Jr\'s alma mater.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-spelman',
    name: 'Spelman College',
    country: 'USA',
    city: 'Atlanta, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Business & Management', 'Arts & Humanities', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 34000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 42,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://spelman.edu',
    established: 1881,
    campusType: 'Urban',
    about: 'Top HBCU for women; consistently leads for STEM women graduates.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-tuskegee',
    name: 'Tuskegee University',
    country: 'USA',
    city: 'Tuskegee, AL',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Agriculture', 'Architecture', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 28000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 56,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://tuskegee.edu',
    established: 1881,
    campusType: 'Rural',
    about: 'Historic HBCU with top architecture and aerospace engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-famu',
    name: 'Florida A&M University',
    country: 'USA',
    city: 'Tallahassee, FL',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Engineering', 'Pharmacy', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 45,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://famu.edu',
    established: 1887,
    campusType: 'Urban',
    about: 'Florida HBCU with #1 pharmacy school for Black graduates.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Clinical Pharmacy', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy (PharmD/BPharm)', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-norfolk-state',
    name: 'Norfolk State University',
    country: 'USA',
    city: 'Norfolk, VA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://nsu.edu',
    established: 1935,
    campusType: 'Urban',
    about: 'Virginia HBCU with strong engineering and cybersecurity.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-roehampton',
    name: 'University of Roehampton',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Social Sciences', 'Business & Management', 'Education', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://roehampton.ac.uk',
    established: 1841,
    campusType: 'Suburban',
    about: 'South London university with strong humanities and education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-southampton-su',
    name: 'University of Southampton (Solent)',
    country: 'UK',
    city: 'Southampton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Maritime Studies', 'Media & Communications', 'Business & Management', 'Engineering', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://solent.ac.uk',
    established: 2005,
    campusType: 'Urban',
    about: 'Southampton nautical and creative arts university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Maritime Studies', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Naval Architecture', 'Operations Management', 'Philosophy', 'Port & Shipping Management', 'Project Management', 'Public Relations & Advertising', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-abertay',
    name: 'Abertay University',
    country: 'UK',
    city: 'Dundee',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://abertay.ac.uk',
    established: 1888,
    campusType: 'Urban',
    about: 'Scottish university; world-leading for games development.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-dundee',
    name: 'University of Dundee',
    country: 'UK',
    city: 'Dundee',
    qsRank: 301,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Law', 'Engineering', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://dundee.ac.uk',
    established: 1881,
    campusType: 'Urban',
    about: 'Scottish research university known for medicine and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Public Health (MPH)'],
  },
  {
    id: 'uk-stirling',
    name: 'University of Stirling',
    country: 'UK',
    city: 'Stirling',
    qsRank: 351,
    usNewsRank: null,
    programs: ['Business & Management', 'Social Sciences', 'Natural Sciences', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://stir.ac.uk',
    established: 1967,
    campusType: 'Suburban',
    about: 'Scottish university known for aquaculture and sports studies.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-bangor',
    name: 'Bangor University',
    country: 'UK',
    city: 'Bangor',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Business & Management', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 83,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://bangor.ac.uk',
    established: 1884,
    campusType: 'Urban',
    about: 'Welsh coastal university known for marine biology and psychology.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-aber',
    name: 'Aberystwyth University',
    country: 'UK',
    city: 'Aberystwyth',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Business & Management', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 88,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://aber.ac.uk',
    established: 1872,
    campusType: 'Coastal',
    about: 'Wales\' oldest university; strong in geography and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-swansea',
    name: 'Swansea University',
    country: 'UK',
    city: 'Swansea',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Medicine & Health', 'Business & Management', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://swansea.ac.uk',
    established: 1920,
    campusType: 'Coastal',
    about: 'Welsh coastal research university strong in engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-cardiff-met',
    name: 'Cardiff Metropolitan University',
    country: 'UK',
    city: 'Cardiff',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Engineering', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://cardiffmet.ac.uk',
    established: 1865,
    campusType: 'Suburban',
    about: 'Cardiff modern university with strong sport and health programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-wrexham',
    name: 'Wrexham University',
    country: 'UK',
    city: 'Wrexham',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://wrexham.ac.uk',
    established: 2023,
    campusType: 'Urban',
    about: 'New Welsh university known for flexible vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-acg',
    name: 'Australian College of Graduate Medicine',
    country: 'AUSTRALIA',
    city: 'Adelaide',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 40000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 7,
    toefl: 79,
    greRequired: false,
    website: 'https://acgm.edu.au',
    established: 2008,
    campusType: 'Urban',
    about: 'Graduate medical education college in South Australia.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'International Relations & Diplomacy', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'au-swinburne',
    name: 'Swinburne University of Technology',
    country: 'AUSTRALIA',
    city: 'Melbourne',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 35000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://swinburne.edu.au',
    established: 1908,
    campusType: 'Urban',
    about: 'Melbourne tech university with strong engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-notre-dame',
    name: 'University of Notre Dame Australia',
    country: 'AUSTRALIA',
    city: 'Perth',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Business & Management', 'Law', 'Education', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 30000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://notredame.edu.au',
    established: 1989,
    campusType: 'Urban',
    about: 'Catholic university in Perth with campuses in Sydney and Broome.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-scua',
    name: 'Southern Cross University',
    country: 'AUSTRALIA',
    city: 'Lismore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Medicine & Health', 'Education', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 30000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://scu.edu.au',
    established: 1994,
    campusType: 'Suburban',
    about: 'Regional NSW university with strong environmental sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Curriculum & Instruction', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-aic',
    name: 'Australian Institute of Management',
    country: 'AUSTRALIA',
    city: 'Sydney',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 14000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://aim.com.au',
    established: 1941,
    campusType: 'Urban',
    about: 'Australia\'s leading management education provider.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iit-ropar',
    name: 'IIT Ropar',
    country: 'INDIA',
    city: 'Rupnagar',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitrpr.ac.in',
    established: 2008,
    campusType: 'Suburban',
    about: 'Punjab IIT with growing research profile.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'in-iit-jodhpur',
    name: 'IIT Jodhpur',
    country: 'INDIA',
    city: 'Jodhpur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 38,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitj.ac.in',
    established: 2008,
    campusType: 'Suburban',
    about: 'Rajasthan IIT with strong desert technology research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iit-gandhinagar',
    name: 'IIT Gandhinagar',
    country: 'INDIA',
    city: 'Gandhinagar',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 35,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iitgn.ac.in',
    established: 2008,
    campusType: 'Suburban',
    about: 'Gujarat IIT known for liberal arts integration in engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Relations & Diplomacy', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology', 'Software Engineering'],
  },
  {
    id: 'in-nit-calicut',
    name: 'NIT Calicut',
    country: 'INDIA',
    city: 'Kozhikode',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 55,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://nitc.ac.in',
    established: 1961,
    campusType: 'Suburban',
    about: 'Kerala NIT with strong CS and mechanical engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-nit-rourkela',
    name: 'NIT Rourkela',
    country: 'INDIA',
    city: 'Rourkela',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 57,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://nitrkl.ac.in',
    established: 1961,
    campusType: 'Suburban',
    about: 'Odisha NIT with excellent placement record.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iiit-hyderabad',
    name: 'IIIT Hyderabad',
    country: 'INDIA',
    city: 'Hyderabad',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Data Science & AI', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 22,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iiit.ac.in',
    established: 1998,
    campusType: 'Suburban',
    about: 'Hyderabad\'s specialized IT research university; top for ML/AI.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'in-iiit-bangalore',
    name: 'IIIT Bangalore',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Data Science & AI', 'Engineering', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 25,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://iiitb.ac.in',
    established: 1999,
    campusType: 'Urban',
    about: 'Bengaluru IT research university with industry-linked programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-doon',
    name: 'Doon University',
    country: 'INDIA',
    city: 'Dehradun',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Business & Management', 'Arts & Humanities', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 70,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://doonuniversity.ac.in',
    established: 2005,
    campusType: 'Suburban',
    about: 'Uttarakhand state university with environmental focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-bennett',
    name: 'Bennett University',
    country: 'INDIA',
    city: 'Greater Noida',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Media & Communications', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 6000,
    tuitionMax: 10000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 69,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://bennett.edu.in',
    established: 2016,
    campusType: 'Suburban',
    about: 'Times Group promoted private university with media specializations.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'Journalism & Mass Communication', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-presidency',
    name: 'Presidency University Bangalore',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 72,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: 'https://presidencyuniversity.in',
    established: 2013,
    campusType: 'Urban',
    about: 'Karnataka private university with strong engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'sg-shelton',
    name: 'Shelton College International',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://shelton.edu.sg',
    established: 1980,
    campusType: 'Urban',
    about: 'Singapore private college with international business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-global-academy',
    name: 'Global Academy of Technology',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 14000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://gat.edu.sg',
    established: 2002,
    campusType: 'Urban',
    about: 'Singapore tech academy with engineering and IT programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-ajman',
    name: 'Ajman University',
    country: 'UAE',
    city: 'Ajman',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Medicine & Health', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ajman.ac.ae',
    established: 1988,
    campusType: 'Urban',
    about: 'UAE\'s first private university in Ajman emirate.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'ae-sharjah',
    name: 'University of Sharjah',
    country: 'UAE',
    city: 'Sharjah',
    qsRank: 601,
    usNewsRank: null,
    programs: ['Engineering', 'Medicine & Health', 'Business & Management', 'Law', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 58,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sharjah.ac.ae',
    established: 1997,
    campusType: 'Suburban',
    about: 'UAE state university in Sharjah; comprehensive programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-zayed',
    name: 'Zayed University',
    country: 'UAE',
    city: 'Abu Dhabi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 0,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 50,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://zu.ac.ae',
    established: 1998,
    campusType: 'Suburban',
    about: 'UAE federal university focused on women\'s education (coeducational now).',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'nz-otago-poly',
    name: 'Otago Polytechnic',
    country: 'NZ',
    city: 'Dunedin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Engineering', 'Business & Management', 'Computer Science & IT', 'Agriculture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 80,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://op.ac.nz',
    established: 1906,
    campusType: 'Urban',
    about: 'Southern NZ polytechnic with strong arts and design programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-eastern-institute',
    name: 'Eastern Institute of Technology',
    country: 'NZ',
    city: 'Napier',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Natural Sciences', 'Arts & Humanities', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 81,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://eit.ac.nz',
    established: 1976,
    campusType: 'Urban',
    about: 'Hawke\'s Bay tertiary institute with diverse vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nz-manukau',
    name: 'Manukau Institute of Technology',
    country: 'NZ',
    city: 'Auckland',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://mit.ac.nz',
    established: 1970,
    campusType: 'Suburban',
    about: 'South Auckland polytechnic serving diverse communities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-unilu',
    name: 'University of Lucerne',
    country: 'SWITZERLAND',
    city: 'Lucerne',
    qsRank: null,
    usNewsRank: null,
    programs: ['Law', 'Social Sciences', 'Business & Management', 'Arts & Humanities', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2500,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 52,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://unilu.ch',
    established: 2000,
    campusType: 'Suburban',
    about: 'Small Swiss university known for law and social work.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-usi',
    name: 'Università della Svizzera italiana',
    country: 'SWITZERLAND',
    city: 'Lugano',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Architecture', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://usi.ch',
    established: 1996,
    campusType: 'Suburban',
    about: 'Italian-speaking Swiss university; unique trilingual environment.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'Interior Design', 'International Business', 'International Relations & Diplomacy', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'se-hkr2',
    name: 'University of Skövde',
    country: 'SWEDEN',
    city: 'Skövde',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://his.se',
    established: 1983,
    campusType: 'Suburban',
    about: 'Swedish university known for game development and informatics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-dalarna',
    name: 'Dalarna University',
    country: 'SWEDEN',
    city: 'Falun',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Natural Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://du.se',
    established: 1977,
    campusType: 'Suburban',
    about: 'Swedish university with strong industrial engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'se-gih',
    name: 'Swedish School of Sport and Health Sciences',
    country: 'SWEDEN',
    city: 'Stockholm',
    qsRank: null,
    usNewsRank: null,
    programs: ['Sports Science', 'Medicine & Health', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 14000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 60,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://gih.se',
    established: 1813,
    campusType: 'Urban',
    about: 'Sweden\'s specialist sports and health sciences university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Biomedical Sciences', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Exercise Physiology & Rehabilitation', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Pharmacy', 'Public Health (MPH)', 'Sports Management', 'Sports Science & Kinesiology', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'de-passau',
    name: 'University of Passau',
    country: 'GERMANY',
    city: 'Passau',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 47,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-passau.de',
    established: 1978,
    campusType: 'Suburban',
    about: 'Bavarian university known for European studies and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-bayreuth',
    name: 'University of Bayreuth',
    country: 'GERMANY',
    city: 'Bayreuth',
    qsRank: 401,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Business & Management', 'Law', 'Engineering', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 48,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-bayreuth.de',
    established: 1975,
    campusType: 'Suburban',
    about: 'Known for African studies and material sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-ulm',
    name: 'University of Ulm',
    country: 'GERMANY',
    city: 'Ulm',
    qsRank: 451,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Engineering', 'Computer Science & IT', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 47,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-ulm.de',
    established: 1967,
    campusType: 'Suburban',
    about: 'German university known for materials science and quantum physics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-tu-braunschweig',
    name: 'TU Braunschweig',
    country: 'GERMANY',
    city: 'Braunschweig',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 50,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://tu-braunschweig.de',
    established: 1745,
    campusType: 'Urban',
    about: 'Germany\'s oldest technical university with strong automotive research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Relations & Diplomacy', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'de-frankfurt-uas',
    name: 'Frankfurt University of Applied Sciences',
    country: 'GERMANY',
    city: 'Frankfurt',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 55,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://frankfurt-university.de',
    established: 1971,
    campusType: 'Urban',
    about: 'Frankfurt applied sciences university with strong finance sector links.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'International Relations & Diplomacy', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'fr-bordeaux',
    name: 'University of Bordeaux',
    country: 'FRANCE',
    city: 'Bordeaux',
    qsRank: 179,
    usNewsRank: 152,
    programs: ['Natural Sciences', 'Medicine & Health', 'Social Sciences', 'Arts & Humanities', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 6000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 41,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://u-bordeaux.fr',
    established: 1441,
    campusType: 'Urban',
    about: 'Bordeaux research university; strong in wine science and physics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'fr-aix-marseille',
    name: 'Aix-Marseille University',
    country: 'FRANCE',
    city: 'Marseille',
    qsRank: 224,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Medicine & Health', 'Law', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 6000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 42,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://univ-amu.fr',
    established: 1409,
    campusType: 'Urban',
    about: 'France\'s largest university; Mediterranean research hub.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'fr-montpellier',
    name: 'University of Montpellier',
    country: 'FRANCE',
    city: 'Montpellier',
    qsRank: 301,
    usNewsRank: 152,
    programs: ['Medicine & Health', 'Natural Sciences', 'Law', 'Business & Management', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 6000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://umontpellier.fr',
    established: 1289,
    campusType: 'Urban',
    about: 'One of Europe\'s oldest universities; strong in medicine.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-nice',
    name: 'Université Côte d\'Azur',
    country: 'FRANCE',
    city: 'Nice',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Business & Management', 'Arts & Humanities', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 6000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 44,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://univ-cotedazur.fr',
    established: 2015,
    campusType: 'Coastal',
    about: 'Riviera research cluster with focus on smart technologies.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fr-paris-est',
    name: 'Gustave Eiffel University',
    country: 'FRANCE',
    city: 'Marne-la-Vallée',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Architecture', 'Business & Management', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 6000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://univ-gustave-eiffel.fr',
    established: 2020,
    campusType: 'Suburban',
    about: 'New French university focused on sustainable cities and transport.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'International Relations & Diplomacy', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'nl-zuyd2',
    name: 'Breda University of Applied Sciences',
    country: 'NETHERLANDS',
    city: 'Breda',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Hospitality & Tourism', 'Media & Communications', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://buas.nl',
    established: 1994,
    campusType: 'Urban',
    about: 'Top Dutch hospitality and media university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Artificial Intelligence & Machine Learning', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'nl-artez',
    name: 'ArtEZ University of the Arts',
    country: 'NETHERLANDS',
    city: 'Arnhem',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Media & Communications', 'Architecture', 'Design'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://artez.nl',
    established: 1952,
    campusType: 'Urban',
    about: 'Dutch arts university with campuses in Arnhem, Enschede, and Zwolle.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Architecture', 'Art History & Curatorship', 'Broadcasting & Media Production', 'Digital Media & Content', 'Fashion Design & Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Graphic Design & Visual Communication', 'History', 'Industrial Design', 'Interior Design', 'Journalism & Mass Communication', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'Music & Performing Arts', 'Philosophy', 'Public Relations & Advertising', 'UX/UI Design', 'Urban & Regional Planning'],
  },
  {
    id: 'ie-limerick-it',
    name: 'Limerick Institute of Technology',
    country: 'IRELAND',
    city: 'Limerick',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Science'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 14000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://lit.ie',
    established: 1993,
    campusType: 'Urban',
    about: 'Limerick Institute now part of Technological University of the Shannon.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-ait',
    name: 'Atlantic Technological University Galway',
    country: 'IRELAND',
    city: 'Galway',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://atu.ie',
    established: 1972,
    campusType: 'Suburban',
    about: 'ATU Galway campus with engineering and science programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ie-dundalk',
    name: 'Dundalk Institute of Technology',
    country: 'IRELAND',
    city: 'Dundalk',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Health Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 14000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://dkit.ie',
    established: 1971,
    campusType: 'Suburban',
    about: 'Northeast Irish institute with strong engineering and health programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'jp-nagoya',
    name: 'Nagoya University',
    country: 'JAPAN',
    city: 'Nagoya',
    qsRank: 137,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Medicine & Health', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5500,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://nagoya-u.ac.jp',
    established: 1871,
    campusType: 'Urban',
    about: 'Japanese imperial university; 5 Nobel laureates since 2000.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Industrial & Systems Engineering', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'jp-tohoku',
    name: 'Tohoku University',
    country: 'JAPAN',
    city: 'Sendai',
    qsRank: 97,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Medicine & Health', 'Business & Management', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5500,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 32,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://tohoku.ac.jp',
    established: 1907,
    campusType: 'Urban',
    about: 'Japan\'s top research output university; strong for materials.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'jp-kyushu',
    name: 'Kyushu University',
    country: 'JAPAN',
    city: 'Fukuoka',
    qsRank: 155,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Medicine & Health', 'Business & Management', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5500,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://kyushu-u.ac.jp',
    established: 1911,
    campusType: 'Urban',
    about: 'Western Japan\'s leading research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'jp-hokkaido',
    name: 'Hokkaido University',
    country: 'JAPAN',
    city: 'Sapporo',
    qsRank: 132,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Agriculture', 'Engineering', 'Medicine & Health', 'Veterinary Medicine'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5500,
    tuitionMax: 8000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://hokudai.ac.jp',
    established: 1876,
    campusType: 'Suburban',
    about: 'Northern Japan research university known for agriculture and science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Animal Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Industrial & Systems Engineering', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Public Health (MPH)', 'Veterinary Medicine (BVSc/DVM)', 'Veterinary Public Health'],
  },
  {
    id: 'kr-sungkyunkwan',
    name: 'Sungkyunkwan University',
    country: 'SOUTH_KOREA',
    city: 'Seoul',
    qsRank: 121,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Business & Management', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://skku.edu',
    established: 1398,
    campusType: 'Urban',
    about: 'Samsung-affiliated Korean university; top for engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'kr-postech',
    name: 'POSTECH',
    country: 'SOUTH_KOREA',
    city: 'Pohang',
    qsRank: 75,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 15,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://postech.ac.kr',
    established: 1986,
    campusType: 'Suburban',
    about: 'POSCO-funded Korean technical university; top for engineering research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'kr-hanyang',
    name: 'Hanyang University',
    country: 'SOUTH_KOREA',
    city: 'Seoul',
    qsRank: 195,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 42,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://hanyang.ac.kr',
    established: 1939,
    campusType: 'Urban',
    about: 'Korean university known for engineering and Samsung partnerships.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-monash-my',
    name: 'Monash University Malaysia',
    country: 'MALAYSIA',
    city: 'Subang Jaya',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Medicine & Health', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://monash.edu.my',
    established: 1998,
    campusType: 'Suburban',
    about: 'Australian Monash University\'s Malaysian campus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-nottingham-my',
    name: 'University of Nottingham Malaysia',
    country: 'MALAYSIA',
    city: 'Semenyih',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 11000,
    tuitionMax: 15000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 50,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://nottingham.edu.my',
    established: 2000,
    campusType: 'Suburban',
    about: 'UK Nottingham University\'s Malaysian campus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-sunway2',
    name: 'Sunway College',
    country: 'MALAYSIA',
    city: 'Subang Jaya',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 9000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 75,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://sunwaycollege.edu.my',
    established: 1987,
    campusType: 'Suburban',
    about: 'Pre-university and diploma college in the Sunway education group.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-help',
    name: 'HELP University',
    country: 'MALAYSIA',
    city: 'Kuala Lumpur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Computer Science & IT', 'Psychology', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 14000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://help.edu.my',
    established: 1986,
    campusType: 'Urban',
    about: 'Malaysian private university with UK degree partnerships.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Clinical Psychology', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Counselling Psychology', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Organizational Psychology', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'hk-city',
    name: 'City University of Hong Kong',
    country: 'HONG_KONG',
    city: 'Hong Kong',
    qsRank: 62,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 35,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://cityu.edu.hk',
    established: 1984,
    campusType: 'Urban',
    about: 'Dynamic Hong Kong research university; top for business and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'hk-polyu',
    name: 'Hong Kong Polytechnic University',
    country: 'HONG_KONG',
    city: 'Hong Kong',
    qsRank: 57,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 38,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://polyu.edu.hk',
    established: 1937,
    campusType: 'Urban',
    about: 'Hong Kong applied sciences university; top for engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'hk-hkbu',
    name: 'Hong Kong Baptist University',
    country: 'HONG_KONG',
    city: 'Hong Kong',
    qsRank: 398,
    usNewsRank: null,
    programs: ['Business & Management', 'Social Sciences', 'Arts & Humanities', 'Medicine & Health', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://hkbu.edu.hk',
    established: 1956,
    campusType: 'Urban',
    about: 'Hong Kong teaching and research university known for communications.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-belmont',
    name: 'Belmont University',
    country: 'USA',
    city: 'Nashville, TN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Music', 'Arts & Humanities', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 36000,
    tuitionMax: 42000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://belmont.edu',
    established: 1890,
    campusType: 'Urban',
    about: 'Nashville Christian university known for music business programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Composition & Theory', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Music Business', 'Music Performance', 'Music Technology & Production', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-duquesne',
    name: 'Duquesne University',
    country: 'USA',
    city: 'Pittsburgh, PA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Pharmacy', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 42000,
    tuitionMax: 48000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://duq.edu',
    established: 1878,
    campusType: 'Urban',
    about: 'Catholic Pittsburgh university with strong pharmacy and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Clinical Pharmacy', 'Computer Engineering', 'Corporate & Commercial Law', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy (PharmD/BPharm)', 'Philosophy', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-villanova',
    name: 'Villanova University',
    country: 'USA',
    city: 'Villanova, PA',
    qsRank: null,
    usNewsRank: 46,
    programs: ['Business & Management', 'Engineering', 'Law', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 37,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://villanova.edu',
    established: 1842,
    campusType: 'Suburban',
    about: 'Augustinian university near Philadelphia; strong for business.',
    rankings: { ugCS: 125, ugEngineering: null, ugBusiness: 51, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-st-thomas',
    name: 'University of St. Thomas',
    country: 'USA',
    city: 'Houston, TX',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Law', 'Natural Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://stthom.edu',
    established: 1947,
    campusType: 'Urban',
    about: 'Catholic liberal arts university in Houston, Texas.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-coastal',
    name: 'Coastal Carolina University',
    country: 'USA',
    city: 'Conway, SC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Arts & Humanities', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 71,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://coastal.edu',
    established: 1954,
    campusType: 'Suburban',
    about: 'South Carolina coastal university with strong hospitality programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-kennesaw',
    name: 'Kennesaw State University',
    country: 'USA',
    city: 'Kennesaw, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://kennesaw.edu',
    established: 1963,
    campusType: 'Suburban',
    about: 'Atlanta-area university; second largest in Georgia.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-troy',
    name: 'Troy University',
    country: 'USA',
    city: 'Troy, AL',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://troy.edu',
    established: 1887,
    campusType: 'Suburban',
    about: 'Alabama university with extensive online programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-valdosta',
    name: 'Valdosta State University',
    country: 'USA',
    city: 'Valdosta, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://valdosta.edu',
    established: 1906,
    campusType: 'Suburban',
    about: 'South Georgia university with strong education programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-univ-memphis',
    name: 'University of Memphis',
    country: 'USA',
    city: 'Memphis, TN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Education', 'Arts & Humanities', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 21000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://memphis.edu',
    established: 1912,
    campusType: 'Urban',
    about: 'Tennessee urban university with strong music and law programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-ut-chattanooga',
    name: 'University of Tennessee Chattanooga',
    country: 'USA',
    city: 'Chattanooga, TN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Education', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 19000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://utc.edu',
    established: 1886,
    campusType: 'Urban',
    about: 'UT system campus in Chattanooga with strong engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-appalachian',
    name: 'Appalachian State University',
    country: 'USA',
    city: 'Boone, NC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Natural Sciences', 'Arts & Humanities', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://appstate.edu',
    established: 1899,
    campusType: 'Rural',
    about: 'NC mountain university with strong sustainability programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-eastern-michigan',
    name: 'Eastern Michigan University',
    country: 'USA',
    city: 'Ypsilanti, MI',
    qsRank: null,
    usNewsRank: null,
    programs: ['Education', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://emich.edu',
    established: 1849,
    campusType: 'Suburban',
    about: 'Michigan teacher preparation university near Ann Arbor.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-central-washington',
    name: 'Central Washington University',
    country: 'USA',
    city: 'Ellensburg, WA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Computer Science & IT', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://cwu.edu',
    established: 1890,
    campusType: 'Rural',
    about: 'Washington state university known for education and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-uccs',
    name: 'University of Colorado Colorado Springs',
    country: 'USA',
    city: 'Colorado Springs, CO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uccs.edu',
    established: 1965,
    campusType: 'Urban',
    about: 'Colorado Springs public university with strong engineering.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-colorado-state',
    name: 'Colorado State University',
    country: 'USA',
    city: 'Fort Collins, CO',
    qsRank: null,
    usNewsRank: 79,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Natural Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 27000,
    tuitionMax: 30000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://colostate.edu',
    established: 1870,
    campusType: 'Urban',
    about: 'Colorado\'s land-grant university with strong agriculture and vet med.',
    rankings: { ugCS: 71, ugEngineering: 77, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-utah',
    name: 'University of Utah',
    country: 'USA',
    city: 'Salt Lake City, UT',
    qsRank: null,
    usNewsRank: 79,
    programs: ['Engineering', 'Business & Management', 'Medicine & Health', 'Computer Science & IT', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://utah.edu',
    established: 1850,
    campusType: 'Urban',
    about: 'Utah\'s flagship; home of famous David Eccles School of Business.',
    rankings: { ugCS: 63, ugEngineering: 64, ugBusiness: 41, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-utah-state',
    name: 'Utah State University',
    country: 'USA',
    city: 'Logan, UT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Education', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 95,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://usu.edu',
    established: 1888,
    campusType: 'Suburban',
    about: 'Utah land-grant with strong aerospace and agriculture.',
    rankings: { ugCS: 177, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-byu-idaho',
    name: 'BYU-Idaho',
    country: 'USA',
    city: 'Rexburg, ID',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Engineering', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4500,
    tuitionMax: 5000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 100,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://byui.edu',
    established: 1888,
    campusType: 'Rural',
    about: 'LDS university with very affordable tuition in eastern Idaho.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-sac-state',
    name: 'California State University Sacramento',
    country: 'USA',
    city: 'Sacramento, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 71,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://csus.edu',
    established: 1947,
    campusType: 'Suburban',
    about: 'Sacramento state university near California\'s capital.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-sfsu',
    name: 'San Francisco State University',
    country: 'USA',
    city: 'San Francisco, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sfsu.edu',
    established: 1899,
    campusType: 'Urban',
    about: 'San Francisco\'s public university with diverse programs.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-csulb',
    name: 'California State Long Beach',
    country: 'USA',
    city: 'Long Beach, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 44,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://csulb.edu',
    established: 1949,
    campusType: 'Suburban',
    about: 'One of California\'s largest CSU campuses near Los Angeles.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-csula',
    name: 'Cal State LA',
    country: 'USA',
    city: 'Los Angeles, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 49,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://calstatela.edu',
    established: 1947,
    campusType: 'Urban',
    about: 'Urban LA university with highly diverse student population.',
    rankings: { ugCS: 107, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-csuf',
    name: 'Cal State Fullerton',
    country: 'USA',
    city: 'Fullerton, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 55,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://fullerton.edu',
    established: 1957,
    campusType: 'Suburban',
    about: 'Orange County\'s CSU campus with strong business programs.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-csun',
    name: 'Cal State Northridge',
    country: 'USA',
    city: 'Northridge, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 50,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://csun.edu',
    established: 1958,
    campusType: 'Suburban',
    about: 'San Fernando Valley CSU campus with strong film and media.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-cpoly-slo',
    name: 'Cal Poly San Luis Obispo',
    country: 'USA',
    city: 'San Luis Obispo, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Architecture', 'Agriculture', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://calpoly.edu',
    established: 1901,
    campusType: 'Suburban',
    about: 'Top engineering school in the California State system.',
    rankings: { ugCS: 78, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-cpoly-pomona',
    name: 'Cal Poly Pomona',
    country: 'USA',
    city: 'Pomona, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Architecture', 'Agriculture', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 55,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://cpp.edu',
    established: 1938,
    campusType: 'Suburban',
    about: 'Inland Empire CSU campus with strong engineering and architecture.',
    rankings: { ugCS: 117, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-sdsu2',
    name: 'San Diego State University',
    country: 'USA',
    city: 'San Diego, CA',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 21000,
    tuitionMax: 24000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 67,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sdsu.edu',
    established: 1897,
    campusType: 'Suburban',
    about: 'San Diego\'s large public university with top business programs.',
    rankings: { ugCS: 98, ugEngineering: null, ugBusiness: 64, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-sonoma',
    name: 'Sonoma State University',
    country: 'USA',
    city: 'Rohnert Park, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://sonoma.edu',
    established: 1960,
    campusType: 'Suburban',
    about: 'Wine country CSU campus in Sonoma County.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-humboldt',
    name: 'Cal Poly Humboldt',
    country: 'USA',
    city: 'Arcata, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Environmental Studies', 'Arts & Humanities', 'Business & Management', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://humboldt.edu',
    established: 1913,
    campusType: 'Coastal',
    about: 'Northern California university known for environmental sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Conservation Biology', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Renewable Energy & Clean Technology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Sustainability & Climate Studies'],
  },
  {
    id: 'usa-maritime-cal',
    name: 'California State University Maritime',
    country: 'USA',
    city: 'Vallejo, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Natural Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csum.edu',
    established: 1929,
    campusType: 'Coastal',
    about: 'California\'s maritime academy; trains engineers for ships.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-dominguez',
    name: 'Cal State Dominguez Hills',
    country: 'USA',
    city: 'Carson, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csudh.edu',
    established: 1960,
    campusType: 'Suburban',
    about: 'South Bay CSU campus with diverse working adult student body.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-east-bay',
    name: 'Cal State East Bay',
    country: 'USA',
    city: 'Hayward, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://csueastbay.edu',
    established: 1957,
    campusType: 'Suburban',
    about: 'East Bay Area CSU campus near Silicon Valley.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-stanislaus',
    name: 'Cal State Stanislaus',
    country: 'USA',
    city: 'Turlock, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csustan.edu',
    established: 1957,
    campusType: 'Suburban',
    about: 'Central Valley CSU campus with strong agriculture region ties.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-chico',
    name: 'Cal State Chico',
    country: 'USA',
    city: 'Chico, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://csuchico.edu',
    established: 1887,
    campusType: 'Suburban',
    about: 'Northern California CSU campus with strong tech programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-fresno-state',
    name: 'Fresno State',
    country: 'USA',
    city: 'Fresno, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Agriculture', 'Business & Management', 'Engineering', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 20000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 69,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://fresnostate.edu',
    established: 1911,
    campusType: 'Suburban',
    about: 'Central California university with strong agriculture programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-bakersfield',
    name: 'Cal State Bakersfield',
    country: 'USA',
    city: 'Bakersfield, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Natural Sciences', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csub.edu',
    established: 1970,
    campusType: 'Suburban',
    about: 'Central Valley CSU campus serving the Kern County region.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-channel-islands',
    name: 'CSU Channel Islands',
    country: 'USA',
    city: 'Camarillo, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csuci.edu',
    established: 2002,
    campusType: 'Suburban',
    about: 'Ventura County\'s CSU campus on historic Camarillo state hospital grounds.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-monterey-bay',
    name: 'CSU Monterey Bay',
    country: 'USA',
    city: 'Seaside, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Computer Science & IT', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csumb.edu',
    established: 1994,
    campusType: 'Coastal',
    about: 'Monterey Bay CSU campus with strong marine biology programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-san-marcos',
    name: 'Cal State San Marcos',
    country: 'USA',
    city: 'San Marcos, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 60,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csusm.edu',
    established: 1989,
    campusType: 'Suburban',
    about: 'North San Diego County CSU campus with growing research programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-univ-hartford',
    name: 'University of Hartford',
    country: 'USA',
    city: 'West Hartford, CT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Computer Science & IT', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 42000,
    tuitionMax: 47000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://hartford.edu',
    established: 1877,
    campusType: 'Suburban',
    about: 'Connecticut private university with strong music conservatory.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-sacred-heart',
    name: 'Sacred Heart University',
    country: 'USA',
    city: 'Fairfield, CT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Medicine & Health', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 44000,
    tuitionMax: 49000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sacredheart.edu',
    established: 1963,
    campusType: 'Suburban',
    about: 'CT Catholic university with strong sports management programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-vt2',
    name: 'Vermont Technical College',
    country: 'USA',
    city: 'Randolph Center, VT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Agriculture', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://vtc.edu',
    established: 1866,
    campusType: 'Rural',
    about: 'Vermont\'s technical institution with strong engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-new-hampshire',
    name: 'University of New Hampshire',
    country: 'USA',
    city: 'Durham, NH',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Natural Sciences', 'Agriculture', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 34000,
    tuitionMax: 37000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unh.edu',
    established: 1866,
    campusType: 'Suburban',
    about: 'New Hampshire\'s flagship land-grant research university.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-maine',
    name: 'University of Maine',
    country: 'USA',
    city: 'Orono, ME',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Business & Management', 'Agriculture', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 90,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://umaine.edu',
    established: 1865,
    campusType: 'Suburban',
    about: 'Maine\'s flagship land-grant with strong forestry and engineering.',
    rankings: { ugCS: 177, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-rhode-island',
    name: 'University of Rhode Island',
    country: 'USA',
    city: 'Kingston, RI',
    qsRank: null,
    usNewsRank: 201,
    programs: ['Engineering', 'Business & Management', 'Medicine & Health', 'Natural Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uri.edu',
    established: 1892,
    campusType: 'Suburban',
    about: 'Rhode Island\'s public flagship known for pharmacy and engineering.',
    rankings: { ugCS: 177, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-uconn2',
    name: 'University of Connecticut Stamford',
    country: 'USA',
    city: 'Stamford, CT',
    qsRank: null,
    usNewsRank: 62,
    programs: ['Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 35000,
    tuitionMax: 38000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://stamford.uconn.edu',
    established: 1939,
    campusType: 'Urban',
    about: 'UConn\'s Stamford campus in Connecticut\'s financial corridor.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-fordham3',
    name: 'Fordham Gabelli School',
    country: 'USA',
    city: 'New York, NY',
    qsRank: null,
    usNewsRank: 62,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Economics'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 61000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://fordham.edu/gabelli',
    established: 1841,
    campusType: 'Urban',
    about: 'Fordham\'s business school with strong Wall Street connections.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Applied Economics', 'Behavioral Economics', 'Business Administration (BBA/BCom)', 'Development Economics', 'Econometrics', 'Economics', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-baruch',
    name: 'Baruch College CUNY',
    country: 'USA',
    city: 'New York, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 7000,
    tuitionMax: 10000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 31,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://baruch.cuny.edu',
    established: 1919,
    campusType: 'Urban',
    about: 'CUNY\'s business-focused college; top public school for finance.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-hunter',
    name: 'Hunter College CUNY',
    country: 'USA',
    city: 'New York, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Arts & Humanities', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 7000,
    tuitionMax: 10000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 35,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://hunter.cuny.edu',
    established: 1870,
    campusType: 'Urban',
    about: 'Large CUNY campus in midtown Manhattan with diverse programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-brooklyn-college',
    name: 'Brooklyn College CUNY',
    country: 'USA',
    city: 'Brooklyn, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Business & Management', 'Natural Sciences', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 7000,
    tuitionMax: 10000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 38,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://brooklyn.cuny.edu',
    established: 1930,
    campusType: 'Urban',
    about: 'Brooklyn-based CUNY college known for arts and sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-queensborough',
    name: 'Queens College CUNY',
    country: 'USA',
    city: 'Queens, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Business & Management', 'Natural Sciences', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 7000,
    tuitionMax: 10000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 45,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://qc.cuny.edu',
    established: 1937,
    campusType: 'Suburban',
    about: 'CUNY campus in Flushing Queens with diverse programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-hertford',
    name: 'University of Hertfordshire',
    country: 'UK',
    city: 'Hatfield',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Pharmacy', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://herts.ac.uk',
    established: 1952,
    campusType: 'Suburban',
    about: 'Hertfordshire university near London with strong aerospace.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Clinical Pharmacy', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Pharmaceutical Sciences', 'Pharmacy (PharmD/BPharm)', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-glasg-cal',
    name: 'Glasgow Caledonian University',
    country: 'UK',
    city: 'Glasgow',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://gcu.ac.uk',
    established: 1993,
    campusType: 'Urban',
    about: 'Glasgow modern university with strong nursing and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-edinburgh-napier2',
    name: 'Edinburgh Napier',
    country: 'UK',
    city: 'Edinburgh',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://napier.ac.uk',
    established: 1964,
    campusType: 'Urban',
    about: 'Edinburgh modern university for creative and digital industries.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-bolton',
    name: 'University of Bolton',
    country: 'UK',
    city: 'Bolton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 89,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://bolton.ac.uk',
    established: 1982,
    campusType: 'Urban',
    about: 'Lancashire university with focus on technical skills.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-london-met',
    name: 'London Metropolitan University',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://londonmet.ac.uk',
    established: 2002,
    campusType: 'Urban',
    about: 'London\'s diverse urban university for working professionals.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-brunel2',
    name: 'Brunel University London',
    country: 'UK',
    city: 'Uxbridge',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 85,
    greRequired: false,
    website: 'https://brunel.ac.uk',
    established: 1966,
    campusType: 'Suburban',
    about: 'London university known for engineering and technology programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-central-lancashire',
    name: 'University of Central Lancashire',
    country: 'UK',
    city: 'Preston',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uclan.ac.uk',
    established: 1828,
    campusType: 'Urban',
    about: 'Lancashire\'s major university with broad academic programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-chester',
    name: 'University of Chester',
    country: 'UK',
    city: 'Chester',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Social Sciences', 'Medicine & Health', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://chester.ac.uk',
    established: 1839,
    campusType: 'Urban',
    about: 'Northwest England university known for business and health.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-huddersfield2',
    name: 'University of Huddersfield',
    country: 'UK',
    city: 'Huddersfield',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://hud.ac.uk',
    established: 1841,
    campusType: 'Urban',
    about: 'Yorkshire university known for music technology and engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-wolverhampton2',
    name: 'University of Wolverhampton',
    country: 'UK',
    city: 'Wolverhampton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://wlv.ac.uk',
    established: 1992,
    campusType: 'Urban',
    about: 'West Midlands university with wide vocational programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-northampton',
    name: 'University of Northampton',
    country: 'UK',
    city: 'Northampton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://northampton.ac.uk',
    established: 1999,
    campusType: 'Suburban',
    about: 'Northamptonshire\'s social enterprise university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-bedfordshire2',
    name: 'University of Bedfordshire',
    country: 'UK',
    city: 'Luton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://beds.ac.uk',
    established: 1993,
    campusType: 'Urban',
    about: 'Bedfordshire university with diverse student body.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-winchester',
    name: 'University of Winchester',
    country: 'UK',
    city: 'Winchester',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Education', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://winchester.ac.uk',
    established: 1840,
    campusType: 'Suburban',
    about: 'Hampshire liberal arts university with strong education programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-worcester',
    name: 'University of Worcester',
    country: 'UK',
    city: 'Worcester',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Social Sciences', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://worcester.ac.uk',
    established: 1946,
    campusType: 'Urban',
    about: 'Worcestershire modern university known for sport and education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-york-st-john',
    name: 'York St John University',
    country: 'UK',
    city: 'York',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://yorksj.ac.uk',
    established: 1841,
    campusType: 'Urban',
    about: 'York\'s church-founded university; strong education and arts.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-bishops',
    name: 'Bishop Grosseteste University',
    country: 'UK',
    city: 'Lincoln',
    qsRank: null,
    usNewsRank: null,
    programs: ['Education', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://bgu.ac.uk',
    established: 1862,
    campusType: 'Suburban',
    about: 'Small Lincoln university with specialist education programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-bath-spa',
    name: 'Bath Spa University',
    country: 'UK',
    city: 'Bath',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Business & Management', 'Education', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://bathspa.ac.uk',
    established: 1898,
    campusType: 'Suburban',
    about: 'Bath creative arts university with strong fashion and music.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-arts-london',
    name: 'University of the Arts London',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Media & Communications', 'Architecture', 'Design'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://arts.ac.uk',
    established: 2003,
    campusType: 'Urban',
    about: 'UK\'s largest arts university; includes Central Saint Martins.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Architecture', 'Art History & Curatorship', 'Broadcasting & Media Production', 'Digital Media & Content', 'Fashion Design & Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Graphic Design & Visual Communication', 'History', 'Industrial Design', 'Interior Design', 'Journalism & Mass Communication', 'Landscape Architecture', 'Languages & Linguistics', 'Literature & Creative Writing', 'Music & Performing Arts', 'Philosophy', 'Public Relations & Advertising', 'UX/UI Design', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-goldsmiths',
    name: 'Goldsmiths University of London',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Media & Communications', 'Social Sciences', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 21000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://gold.ac.uk',
    established: 1891,
    campusType: 'Urban',
    about: 'London arts and social sciences university; strong for design.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Broadcasting & Media Production', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Education & Teaching', 'Educational Leadership', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human-Computer Interaction', 'Information Technology', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'Music & Performing Arts', 'Network Engineering', 'Philosophy', 'Political Science & Government', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Software Engineering', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-royal-holloway',
    name: 'Royal Holloway University of London',
    country: 'UK',
    city: 'Egham',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Social Sciences', 'Natural Sciences', 'Computer Science & IT', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://royalholloway.ac.uk',
    established: 1879,
    campusType: 'Suburban',
    about: 'London university in a Victorian castle with strong humanities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-keele',
    name: 'Keele University',
    country: 'UK',
    city: 'Keele',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Business & Management', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://keele.ac.uk',
    established: 1949,
    campusType: 'Rural',
    about: 'Staffordshire campus university known for joint honours programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-brighton2',
    name: 'University of Brighton',
    country: 'UK',
    city: 'Brighton',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Engineering', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 81,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://brighton.ac.uk',
    established: 1858,
    campusType: 'Coastal',
    about: 'Coastal Sussex university with strong design programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-chichester',
    name: 'University of Chichester',
    country: 'UK',
    city: 'Chichester',
    qsRank: null,
    usNewsRank: null,
    programs: ['Education', 'Arts & Humanities', 'Business & Management', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://chi.ac.uk',
    established: 1839,
    campusType: 'Suburban',
    about: 'West Sussex university with strong teacher training.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-edge-hill',
    name: 'Edge Hill University',
    country: 'UK',
    city: 'Ormskirk',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Medicine & Health', 'Arts & Humanities', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://edgehill.ac.uk',
    established: 1885,
    campusType: 'Suburban',
    about: 'Lancashire university with strong nursing and education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-falmouth',
    name: 'Falmouth University',
    country: 'UK',
    city: 'Falmouth',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Media & Communications', 'Computer Science & IT', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 82,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://falmouth.ac.uk',
    established: 1902,
    campusType: 'Coastal',
    about: 'Cornwall creative arts university known for film and media.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-buckingham',
    name: 'University of Buckingham',
    country: 'UK',
    city: 'Buckingham',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 86,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://buckingham.ac.uk',
    established: 1974,
    campusType: 'Suburban',
    about: 'UK\'s only independent university; two-year accelerated degrees.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-robert-gordon',
    name: 'Robert Gordon University',
    country: 'UK',
    city: 'Aberdeen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Architecture', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://rgu.ac.uk',
    established: 1992,
    campusType: 'Urban',
    about: 'Aberdeen applied sciences university; strong for energy sector.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-sunderland2',
    name: 'University of Sunderland',
    country: 'UK',
    city: 'Sunderland',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Media & Communications', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 90,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://sunderland.ac.uk',
    established: 1901,
    campusType: 'Urban',
    about: 'Northeast England university with affordable tuition.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-teesside2',
    name: 'Teesside University',
    country: 'UK',
    city: 'Middlesbrough',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Medicine & Health', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://tees.ac.uk',
    established: 1930,
    campusType: 'Urban',
    about: 'Teesside university known for digital and creative industries.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-liverpool-john-moores',
    name: 'Liverpool John Moores University',
    country: 'UK',
    city: 'Liverpool',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ljmu.ac.uk',
    established: 1992,
    campusType: 'Urban',
    about: 'Liverpool modern university with strong engineering and architecture.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-redeemer',
    name: 'Redeemer University',
    country: 'CANADA',
    city: 'Ancaster, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 84,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://redeemer.ca',
    established: 1982,
    campusType: 'Suburban',
    about: 'Small Christian liberal arts university in Hamilton area.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-univ-victoria2',
    name: 'University of Victoria',
    country: 'CANADA',
    city: 'Victoria, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Business & Management', 'Engineering', 'Natural Sciences', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 21000,
    tuitionMax: 27000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 71,
    ielts: 7,
    toefl: 79,
    greRequired: false,
    website: 'https://uvic.ca',
    established: 1963,
    campusType: 'Suburban',
    about: 'BC research university strong in tech and environmental programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-kingswood',
    name: 'Kingswood University',
    country: 'CANADA',
    city: 'Sussex, NB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://kingswood.edu',
    established: 1945,
    campusType: 'Rural',
    about: 'Small maritime Bible college with business and education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-cape-breton',
    name: 'Cape Breton University',
    country: 'CANADA',
    city: 'Sydney, NS',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://cbu.ca',
    established: 1974,
    campusType: 'Suburban',
    about: 'Nova Scotia regional university with coal mining heritage.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-univ-winnipeg',
    name: 'University of Winnipeg',
    country: 'CANADA',
    city: 'Winnipeg, MB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Natural Sciences', 'Business & Management', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uwinnipeg.ca',
    established: 1871,
    campusType: 'Urban',
    about: 'Downtown Winnipeg university with strong arts and sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-brandon',
    name: 'Brandon University',
    country: 'CANADA',
    city: 'Brandon, MB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Natural Sciences', 'Business & Management', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://brandonu.ca',
    established: 1899,
    campusType: 'Urban',
    about: 'Small Manitoba university known for music and rural health.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-uleth',
    name: 'University of Lethbridge',
    country: 'CANADA',
    city: 'Lethbridge, AB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Arts & Humanities', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://uleth.ca',
    established: 1967,
    campusType: 'Suburban',
    about: 'Alberta\'s smallest comprehensive research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-univ-fraser',
    name: 'University of the Fraser Valley',
    country: 'CANADA',
    city: 'Abbotsford, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ufv.ca',
    established: 1974,
    campusType: 'Suburban',
    about: 'BC teaching university in the Fraser Valley corridor.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-kwantlen2',
    name: 'Kwantlen Polytechnic University',
    country: 'CANADA',
    city: 'Surrey, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Design', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://kpu.ca',
    established: 1981,
    campusType: 'Suburban',
    about: 'Metro Vancouver polytechnic with strong design programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Fashion Design & Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Graphic Design & Visual Communication', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial Design', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'UX/UI Design'],
  },
  {
    id: 'ca-okanagan',
    name: 'University of British Columbia Okanagan',
    country: 'CANADA',
    city: 'Kelowna, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Natural Sciences', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 30000,
    tuitionMax: 36000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 63,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://ok.ubc.ca',
    established: 2005,
    campusType: 'Suburban',
    about: 'UBC\'s smaller Kelowna campus in BC\'s wine country.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-lakehead',
    name: 'Lakehead University',
    country: 'CANADA',
    city: 'Thunder Bay, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Natural Sciences', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 82,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://lakeheadu.ca',
    established: 1965,
    campusType: 'Suburban',
    about: 'Northern Ontario university at the Lakehead.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-ontario-tech',
    name: 'Ontario Tech University',
    country: 'CANADA',
    city: 'Oshawa, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 24000,
    tuitionMax: 28000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 76,
    ielts: 7,
    toefl: 79,
    greRequired: false,
    website: 'https://ontariotechu.ca',
    established: 2002,
    campusType: 'Suburban',
    about: 'Durham Region university focused on applied technology.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-camosun',
    name: 'Camosun College',
    country: 'CANADA',
    city: 'Victoria, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Natural Sciences', 'Health Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 81,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://camosun.ca',
    established: 1971,
    campusType: 'Suburban',
    about: 'Victoria BC college with strong health care programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-northern-lights',
    name: 'Northern Lights College',
    country: 'CANADA',
    city: 'Dawson Creek, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://nlc.bc.ca',
    established: 1975,
    campusType: 'Rural',
    about: 'Remote northeastern BC college with trades and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-nait',
    name: 'NAIT (Northern Alberta Institute)',
    country: 'CANADA',
    city: 'Edmonton, AB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 72,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://nait.ca',
    established: 1962,
    campusType: 'Urban',
    about: 'Edmonton applied technology institute with strong trades.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-sait',
    name: 'SAIT (Southern Alberta Institute)',
    country: 'CANADA',
    city: 'Calgary, AB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 70,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sait.ca',
    established: 1916,
    campusType: 'Urban',
    about: 'Calgary polytechnic; top for trades and technology.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-nova-scotia-college',
    name: 'NSCC (Nova Scotia Community College)',
    country: 'CANADA',
    city: 'Halifax, NS',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Health Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 83,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://nscc.ca',
    established: 1988,
    campusType: 'Urban',
    about: 'Nova Scotia\'s community college network province-wide.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-college-north',
    name: 'College of the North Atlantic',
    country: 'CANADA',
    city: 'Stephenville, NL',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Health Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://cna.nl.ca',
    established: 1963,
    campusType: 'Suburban',
    about: 'Newfoundland\'s province-wide college system.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Health Informatics', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-durham-college',
    name: 'Durham College',
    country: 'CANADA',
    city: 'Oshawa, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Health Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 15000,
    tuitionMax: 19000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://durhamcollege.ca',
    established: 1967,
    campusType: 'Suburban',
    about: 'Durham region Ontario college near Toronto.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Health Informatics', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Kinesiology & Exercise Science', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Nutrition & Dietetics', 'Operations Management', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ca-georgian',
    name: 'Georgian College',
    country: 'CANADA',
    city: 'Barrie, ON',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'Diploma / Certificate'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'CAD',
    intakes: ['September', 'January', 'May'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://georgiancollege.ca',
    established: 1967,
    campusType: 'Suburban',
    about: 'Simcoe County Ontario college with strong applied programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-victoria-uni',
    name: 'Victoria University',
    country: 'AUSTRALIA',
    city: 'Melbourne',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 75,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://vu.edu.au',
    established: 1916,
    campusType: 'Urban',
    about: 'Melbourne polytechnic-style university; strong for sport sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-avondale',
    name: 'Avondale University',
    country: 'AUSTRALIA',
    city: 'Lake Macquarie, NSW',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Business & Management', 'Education', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 29000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 60,
    greRequired: false,
    website: 'https://avondale.edu.au',
    established: 1897,
    campusType: 'Suburban',
    about: 'Australian Adventist university near Newcastle.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Curriculum & Instruction', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-nt-open',
    name: 'Charles Darwin Online',
    country: 'AUSTRALIA',
    city: 'Darwin, NT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Education', 'Computer Science & IT', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 25000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://cdu.edu.au',
    established: 1974,
    campusType: 'Urban',
    about: 'Northern Territory online and blended university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-sturt',
    name: 'Charles Sturt University Wagga Wagga',
    country: 'AUSTRALIA',
    city: 'Wagga Wagga, NSW',
    qsRank: null,
    usNewsRank: null,
    programs: ['Agriculture', 'Education', 'Business & Management', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 28000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 80,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csu.edu.au',
    established: 1989,
    campusType: 'Rural',
    about: 'Regional NSW university with strong agriculture programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-tabor',
    name: 'Tabor College',
    country: 'AUSTRALIA',
    city: 'Adelaide',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Education', 'Business & Management', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://tabor.edu.au',
    established: 1982,
    campusType: 'Suburban',
    about: 'Small Australian Christian university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-excelsia',
    name: 'Excelsia College',
    country: 'AUSTRALIA',
    city: 'Sydney',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 27000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://excelsia.edu.au',
    established: 1983,
    campusType: 'Suburban',
    about: 'Sydney Christian liberal arts college.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-aic2',
    name: 'Australian Institute of Management',
    country: 'AUSTRALIA',
    city: 'Melbourne',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 14000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://aim.com.au',
    established: 1941,
    campusType: 'Urban',
    about: 'Melbourne campus of AIM; leadership education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Sociology', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-blue-mountains',
    name: 'Blue Mountains International Hotel Management',
    country: 'AUSTRALIA',
    city: 'Leura, NSW',
    qsRank: null,
    usNewsRank: null,
    programs: ['Hospitality & Tourism', 'Business & Management', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 30000,
    tuitionMax: 38000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 50,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://bmiht.edu.au',
    established: 1991,
    campusType: 'Rural',
    about: 'Australia\'s top hospitality management school in Blue Mountains.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food & Beverage Management', 'History', 'Hospitality & Hotel Management', 'Human Resource Management', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'au-torrens2',
    name: 'Torrens University Sydney',
    country: 'AUSTRALIA',
    city: 'Sydney',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Arts & Humanities', 'Hospitality & Tourism'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 31000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 90,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://torrens.edu.au',
    established: 2013,
    campusType: 'Urban',
    about: 'Sydney campus of Torrens private university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food & Beverage Management', 'History', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'au-notre-dame2',
    name: 'Notre Dame University Fremantle',
    country: 'AUSTRALIA',
    city: 'Fremantle, WA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Business & Management', 'Law', 'Education', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 30000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://notredame.edu.au',
    established: 1989,
    campusType: 'Coastal',
    about: 'Fremantle campus of Australian Catholic university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-murdoch2',
    name: 'Murdoch University Dubai',
    country: 'AUSTRALIA',
    city: 'Perth, WA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 28000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://murdoch.edu.au',
    established: 1975,
    campusType: 'Suburban',
    about: 'Western Australian research university strong in veterinary science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-acu2',
    name: 'ACU Sydney',
    country: 'AUSTRALIA',
    city: 'Sydney',
    qsRank: null,
    usNewsRank: null,
    programs: ['Education', 'Medicine & Health', 'Business & Management', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 29000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 68,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://acu.edu.au',
    established: 1991,
    campusType: 'Urban',
    about: 'Sydney campus of Australian Catholic University.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-griffith2',
    name: 'Griffith Nathan',
    country: 'AUSTRALIA',
    city: 'Brisbane',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Engineering', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 34000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 71,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://griffith.edu.au',
    established: 1971,
    campusType: 'Suburban',
    about: 'Griffith Nathan campus in Brisbane.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Dentistry', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-jcu2',
    name: 'JCU Singapore',
    country: 'AUSTRALIA',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Medicine & Health', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 27000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 52,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://jcu.edu.sg',
    established: 2003,
    campusType: 'Urban',
    about: 'JCU\'s Singapore campus for the Asia-Pacific market.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'au-sunway-aus',
    name: 'Sunway Australia',
    country: 'AUSTRALIA',
    city: 'Melbourne',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Arts & Humanities', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 23000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://sunway.edu.au',
    established: 2015,
    campusType: 'Urban',
    about: 'Melbourne campus with Asia-Pacific connections.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iit-mandi',
    name: 'IIT Mandi',
    country: 'INDIA',
    city: 'Mandi, HP',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 42,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2009,
    campusType: 'Suburban',
    about: 'https://iitmandi.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'in-iit-tirupati',
    name: 'IIT Tirupati',
    country: 'INDIA',
    city: 'Tirupati, AP',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 42,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2015,
    campusType: 'Suburban',
    about: 'https://iittp.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iit-dharwad',
    name: 'IIT Dharwad',
    country: 'INDIA',
    city: 'Dharwad, KA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 43,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2016,
    campusType: 'Suburban',
    about: 'https://iitdh.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Software Engineering'],
  },
  {
    id: 'in-iit-bhilai',
    name: 'IIT Bhilai',
    country: 'INDIA',
    city: 'Bhilai, CG',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 44,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2016,
    campusType: 'Suburban',
    about: 'https://iitbhilai.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iit-jammu',
    name: 'IIT Jammu',
    country: 'INDIA',
    city: 'Jammu',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 44,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2016,
    campusType: 'Suburban',
    about: 'https://iitjammu.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Software Engineering'],
  },
  {
    id: 'in-nit-allahabad',
    name: 'Motilal Nehru NIT Allahabad',
    country: 'INDIA',
    city: 'Prayagraj',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 60,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1961,
    campusType: 'Suburban',
    about: 'https://mnnit.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-nit-surat',
    name: 'SVNIT Surat',
    country: 'INDIA',
    city: 'Surat',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 62,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1961,
    campusType: 'Suburban',
    about: 'https://svnit.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-nit-jaipur',
    name: 'Malaviya NIT Jaipur',
    country: 'INDIA',
    city: 'Jaipur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 58,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1963,
    campusType: 'Suburban',
    about: 'https://mnit.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Software Engineering', 'Urban & Regional Planning'],
  },
  {
    id: 'in-nit-kurukshetra',
    name: 'NIT Kurukshetra',
    country: 'INDIA',
    city: 'Kurukshetra',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 62,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1963,
    campusType: 'Suburban',
    about: 'https://nitkkr.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-nit-silchar',
    name: 'NIT Silchar',
    country: 'INDIA',
    city: 'Silchar, Assam',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 3000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 65,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1967,
    campusType: 'Suburban',
    about: 'https://nits.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iiit-allahabad',
    name: 'IIIT Allahabad',
    country: 'INDIA',
    city: 'Prayagraj',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Data Science & AI', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 28,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1999,
    campusType: 'Suburban',
    about: 'https://iiita.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'in-iiit-delhi',
    name: 'IIIT Delhi',
    country: 'INDIA',
    city: 'New Delhi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Data Science & AI', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 7000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 22,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2008,
    campusType: 'Urban',
    about: 'https://iiitd.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Environmental Engineering', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Relations & Diplomacy', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Political Science & Government', 'Psychology', 'Quantitative Analytics', 'Sociology', 'Software Engineering'],
  },
  {
    id: 'in-iim-rohtak',
    name: 'IIM Rohtak',
    country: 'INDIA',
    city: 'Rohtak, HR',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 18,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2010,
    campusType: 'Suburban',
    about: 'https://iimrohtak.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-ranchi',
    name: 'IIM Ranchi',
    country: 'INDIA',
    city: 'Ranchi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Human Resources'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 20,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2010,
    campusType: 'Suburban',
    about: 'https://iimranchi.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Organizational Behavior', 'Project Management', 'Risk Management & Insurance', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Talent Management'],
  },
  {
    id: 'in-iim-udaipur',
    name: 'IIM Udaipur',
    country: 'INDIA',
    city: 'Udaipur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 22,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2011,
    campusType: 'Urban',
    about: 'https://iimu.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-trichy',
    name: 'IIM Trichy',
    country: 'INDIA',
    city: 'Tiruchirappalli',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 24000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 20,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2011,
    campusType: 'Suburban',
    about: 'https://iimtrichy.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-kashipur',
    name: 'IIM Kashipur',
    country: 'INDIA',
    city: 'Kashipur, UK',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Operations'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 22,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2011,
    campusType: 'Suburban',
    about: 'https://iimkashipur.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Quality Management & Six Sigma', 'Risk Management & Insurance', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-nagpur',
    name: 'IIM Nagpur',
    country: 'INDIA',
    city: 'Nagpur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 22,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2015,
    campusType: 'Urban',
    about: 'https://iimnagpur.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-visakhapatnam',
    name: 'IIM Visakhapatnam',
    country: 'INDIA',
    city: 'Visakhapatnam',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 23,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2015,
    campusType: 'Coastal',
    about: 'https://iimv.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-bodh-gaya',
    name: 'IIM Bodh Gaya',
    country: 'INDIA',
    city: 'Bodh Gaya',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 25,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2015,
    campusType: 'Suburban',
    about: 'https://iimbg.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-sirmaur',
    name: 'IIM Sirmaur',
    country: 'INDIA',
    city: 'Paonta Sahib',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 26,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2015,
    campusType: 'Rural',
    about: 'https://iimsirmaur.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-sambalpur',
    name: 'IIM Sambalpur',
    country: 'INDIA',
    city: 'Sambalpur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 27,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2015,
    campusType: 'Urban',
    about: 'https://iimsambalpur.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-iim-amritsar',
    name: 'IIM Amritsar',
    country: 'INDIA',
    city: 'Amritsar',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 26,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2015,
    campusType: 'Urban',
    about: 'https://iimamritsar.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-da-iict',
    name: 'DA-IICT Gandhinagar',
    country: 'INDIA',
    city: 'Gandhinagar',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Data Science & AI', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 6000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 27,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2003,
    campusType: 'Suburban',
    about: 'https://daiict.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'in-pdeu',
    name: 'Pandit Deendayal Energy University',
    country: 'INDIA',
    city: 'Gandhinagar',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 55,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2007,
    campusType: 'Suburban',
    about: 'https://pdeu.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-nirma',
    name: 'Nirma University',
    country: 'INDIA',
    city: 'Ahmedabad',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Law', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 52,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1994,
    campusType: 'Suburban',
    about: 'https://nirmauni.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Landscape Architecture', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-marwadi',
    name: 'Marwadi University',
    country: 'INDIA',
    city: 'Rajkot',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Architecture', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 72,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2016,
    campusType: 'Suburban',
    about: 'https://marwadiuniversity.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-adani',
    name: 'Adani University',
    country: 'INDIA',
    city: 'Ahmedabad',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Data Science & AI', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 60,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2021,
    campusType: 'Suburban',
    about: 'https://adaniuniversity.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-silver-oak',
    name: 'Silver Oak University',
    country: 'INDIA',
    city: 'Ahmedabad',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 75,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2018,
    campusType: 'Suburban',
    about: 'https://silveroakuni.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-kl-university',
    name: 'KL University',
    country: 'INDIA',
    city: 'Vijayawada',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 67,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1980,
    campusType: 'Urban',
    about: 'https://kluniversity.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'in-sastra',
    name: 'SASTRA University',
    country: 'INDIA',
    city: 'Thanjavur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 62,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1984,
    campusType: 'Suburban',
    about: 'https://sastra.edu',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-psg',
    name: 'PSG College of Technology',
    country: 'INDIA',
    city: 'Coimbatore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 52,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1951,
    campusType: 'Urban',
    about: 'https://psgtech.edu',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-coimbatore-inst',
    name: 'Sri Krishna College',
    country: 'INDIA',
    city: 'Coimbatore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 68,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2001,
    campusType: 'Suburban',
    about: 'https://skcet.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-ramaiah',
    name: 'M.S. Ramaiah Institute',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 62,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1962,
    campusType: 'Urban',
    about: 'https://msrit.edu',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-rv',
    name: 'R.V. College of Engineering',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Architecture'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 58,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1952,
    campusType: 'Urban',
    about: 'https://rvce.edu.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'in-bms',
    name: 'BMS College of Engineering',
    country: 'INDIA',
    city: 'Bengaluru',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 60,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 1946,
    campusType: 'Urban',
    about: 'https://bmsce.ac.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-niit',
    name: 'NIIT University',
    country: 'INDIA',
    city: 'Neemrana',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 62,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2009,
    campusType: 'Rural',
    about: 'https://niituniversity.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-woxsen',
    name: 'Woxsen University',
    country: 'INDIA',
    city: 'Hyderabad',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Engineering', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 62,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: null,
    established: 2008,
    campusType: 'Suburban',
    about: 'https://woxsen.edu.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Investment Management', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Project Management', 'Risk Management & Insurance', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-opjs',
    name: 'OPJS University',
    country: 'INDIA',
    city: 'Churu, RJ',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Education', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 82,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2013,
    campusType: 'Rural',
    about: 'https://opjsuniversity.edu.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'in-jecrc',
    name: 'JECRC University',
    country: 'INDIA',
    city: 'Jaipur',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Architecture', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 5000,
    currency: 'INR',
    intakes: ['July', 'January'],
    acceptanceRate: 70,
    ielts: null,
    toefl: null,
    greRequired: false,
    website: null,
    established: 2012,
    campusType: 'Suburban',
    about: 'https://jecrcuniversity.edu.in',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-wentworth',
    name: 'Wentworth Institute of Technology',
    country: 'USA',
    city: 'Boston, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 43000,
    tuitionMax: 48000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 76,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://wit.edu',
    established: 1904,
    campusType: 'Urban',
    about: 'Boston tech university known for co-op and engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'usa-worcester-poly',
    name: 'Worcester Polytechnic Institute',
    country: 'USA',
    city: 'Worcester, MA',
    qsRank: null,
    usNewsRank: 92,
    programs: ['Engineering', 'Computer Science & IT', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 57000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 43,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://wpi.edu',
    established: 1865,
    campusType: 'Suburban',
    about: 'Top engineering university known for project-based learning.',
    rankings: { ugCS: 78, ugEngineering: 64, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Actuarial Mathematics', 'Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Fire Protection Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Robotics Engineering', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-rose-hulman',
    name: 'Rose-Hulman Institute',
    country: 'USA',
    city: 'Terre Haute, IN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 60000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 61,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://rose-hulman.edu',
    established: 1874,
    campusType: 'Suburban',
    about: 'Consistently #1 engineering school in the USA.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mathematics', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Optical Engineering', 'Physics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-harvey-mudd',
    name: 'Harvey Mudd College',
    country: 'USA',
    city: 'Claremont, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 14,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://hmc.edu',
    established: 1955,
    campusType: 'Suburban',
    about: 'Elite STEM liberal arts college in the Claremont Consortium.',
    rankings: { ugCS: 25, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Joint Science', 'Materials Science & Engineering', 'Mathematical & Computational Biology', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Software Engineering'],
  },
  {
    id: 'usa-swarthmore',
    name: 'Swarthmore College',
    country: 'USA',
    city: 'Swarthmore, PA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 9,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://swarthmore.edu',
    established: 1864,
    campusType: 'Suburban',
    about: 'Top 3 liberal arts college in the USA.',
    rankings: { ugCS: 98, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-williams',
    name: 'Williams College',
    country: 'USA',
    city: 'Williamstown, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 9,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://williams.edu',
    established: 1793,
    campusType: 'Rural',
    about: '#1 or #2 liberal arts college in the US annually.',
    rankings: { ugCS: 107, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-amherst',
    name: 'Amherst College',
    country: 'USA',
    city: 'Amherst, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 11,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://amherst.edu',
    established: 1821,
    campusType: 'Rural',
    about: 'Top liberal arts college; need-blind admissions.',
    rankings: { ugCS: 98, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-middlebury',
    name: 'Middlebury College',
    country: 'USA',
    city: 'Middlebury, VT',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Social Sciences', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 16,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://middlebury.edu',
    established: 1800,
    campusType: 'Rural',
    about: 'Top liberal arts college known for language immersion programs.',
    rankings: { ugCS: 177, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-bowdoin',
    name: 'Bowdoin College',
    country: 'USA',
    city: 'Brunswick, ME',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 9,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://bowdoin.edu',
    established: 1794,
    campusType: 'Coastal',
    about: 'Top Maine liberal arts college; strong marine studies.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-colby',
    name: 'Colby College',
    country: 'USA',
    city: 'Waterville, ME',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 10,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://colby.edu',
    established: 1813,
    campusType: 'Rural',
    about: 'Maine liberal arts college with strong environmental studies.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-colgate',
    name: 'Colgate University',
    country: 'USA',
    city: 'Hamilton, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 24,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://colgate.edu',
    established: 1819,
    campusType: 'Rural',
    about: 'New York liberal arts university with strong business programs.',
    rankings: { ugCS: 212, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-hamilton',
    name: 'Hamilton College',
    country: 'USA',
    city: 'Clinton, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 16,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://hamilton.edu',
    established: 1812,
    campusType: 'Rural',
    about: 'Upstate NY liberal arts college with open curriculum.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-carleton',
    name: 'Carleton College',
    country: 'USA',
    city: 'Northfield, MN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 17,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://carleton.edu',
    established: 1866,
    campusType: 'Suburban',
    about: 'Top Midwest liberal arts college known for sciences.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-grinnell',
    name: 'Grinnell College',
    country: 'USA',
    city: 'Grinnell, IA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 57000,
    tuitionMax: 62000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 17,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://grinnell.edu',
    established: 1846,
    campusType: 'Rural',
    about: 'Iowa liberal arts college with self-governance and social justice.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-macalester',
    name: 'Macalester College',
    country: 'USA',
    city: 'Saint Paul, MN',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 59000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 40,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://macalester.edu',
    established: 1874,
    campusType: 'Urban',
    about: 'Minnesota liberal arts college known for international focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-oberlin',
    name: 'Oberlin College',
    country: 'USA',
    city: 'Oberlin, OH',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Natural Sciences', 'Social Sciences', 'Music', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 28,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://oberlin.edu',
    established: 1833,
    campusType: 'Rural',
    about: 'Ohio liberal arts college with a famous conservatory of music.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Composition & Theory', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Music Business', 'Music Performance', 'Music Technology & Production', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-vassar',
    name: 'Vassar College',
    country: 'USA',
    city: 'Poughkeepsie, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Natural Sciences', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 24,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://vassar.edu',
    established: 1861,
    campusType: 'Suburban',
    about: 'Hudson Valley liberal arts college; coeducational since 1969.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-bates',
    name: 'Bates College',
    country: 'USA',
    city: 'Lewiston, ME',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Natural Sciences', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 13,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://bates.edu',
    established: 1855,
    campusType: 'Urban',
    about: 'Maine liberal arts college; first to have fully need-blind admissions.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-haverford',
    name: 'Haverford College',
    country: 'USA',
    city: 'Haverford, PA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 59000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 17,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://haverford.edu',
    established: 1833,
    campusType: 'Suburban',
    about: 'Philadelphia-area Quaker liberal arts college.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-reed',
    name: 'Reed College',
    country: 'USA',
    city: 'Portland, OR',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 35,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://reed.edu',
    established: 1908,
    campusType: 'Suburban',
    about: 'Portland liberal arts college with unique thesis requirement.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-smith',
    name: 'Smith College',
    country: 'USA',
    city: 'Northampton, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Engineering', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://smith.edu',
    established: 1871,
    campusType: 'Suburban',
    about: 'Top women\'s liberal arts college; Seven Sisters.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-wellesley',
    name: 'Wellesley College',
    country: 'USA',
    city: 'Wellesley, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 16,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://wellesley.edu',
    established: 1870,
    campusType: 'Suburban',
    about: 'Top women\'s college near Boston; Hillary Clinton\'s alma mater.',
    rankings: { ugCS: 98, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-barnard',
    name: 'Barnard College',
    country: 'USA',
    city: 'New York, NY',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Natural Sciences', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 62000,
    tuitionMax: 67000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 12,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://barnard.edu',
    established: 1889,
    campusType: 'Urban',
    about: 'Women\'s college affiliated with Columbia University in NYC.',
    rankings: { ugCS: 177, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-mount-holyoke',
    name: 'Mount Holyoke College',
    country: 'USA',
    city: 'South Hadley, MA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 37,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://mtholyoke.edu',
    established: 1837,
    campusType: 'Rural',
    about: 'Oldest women\'s college in the US; part of Five Colleges.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-bryn-mawr',
    name: 'Bryn Mawr College',
    country: 'USA',
    city: 'Bryn Mawr, PA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 58000,
    tuitionMax: 63000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 37,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://brynmawr.edu',
    established: 1885,
    campusType: 'Suburban',
    about: 'Philadelphia-area women\'s college; rigorous academics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-pomona',
    name: 'Pomona College',
    country: 'USA',
    city: 'Claremont, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 59000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 7,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://pomona.edu',
    established: 1887,
    campusType: 'Suburban',
    about: 'Top liberal arts college; co-founder of Claremont Consortium.',
    rankings: { ugCS: 78, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-claremont-mckenna',
    name: 'Claremont McKenna College',
    country: 'USA',
    city: 'Claremont, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 9,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://claremontmckenna.edu',
    established: 1946,
    campusType: 'Suburban',
    about: 'Top liberal arts college for business and economics.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Finance', 'Financial Engineering', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-scripps',
    name: 'Scripps College',
    country: 'USA',
    city: 'Claremont, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Natural Sciences', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 59000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 25,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://scrippscollege.edu',
    established: 1926,
    campusType: 'Suburban',
    about: 'Claremont women\'s liberal arts college with strong humanities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-pitzer',
    name: 'Pitzer College',
    country: 'USA',
    city: 'Claremont, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Social Sciences', 'Arts & Humanities', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 59000,
    tuitionMax: 64000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 17,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://pitzer.edu',
    established: 1963,
    campusType: 'Suburban',
    about: 'Claremont college known for social responsibility and environment.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-kalamazoo',
    name: 'Kalamazoo College',
    country: 'USA',
    city: 'Kalamazoo, MI',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 60000,
    currency: 'USD',
    intakes: ['September'],
    acceptanceRate: 73,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://kzoo.edu',
    established: 1833,
    campusType: 'Urban',
    about: 'Michigan liberal arts college known for study abroad emphasis.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-soas',
    name: 'SOAS University of London',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Social Sciences', 'Arts & Humanities', 'Law', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 24000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 56,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://soas.ac.uk',
    established: 1916,
    campusType: 'Urban',
    about: 'Specialist London university for Asia, Africa, and Middle East.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-lshtm',
    name: 'London School of Hygiene & Tropical Medicine',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 25000,
    tuitionMax: 35000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 20,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://lshtm.ac.uk',
    established: 1899,
    campusType: 'Urban',
    about: 'World\'s leading public health university; COVID-19 modelling.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'International Relations & Diplomacy', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'uk-imperial-business',
    name: 'Imperial College Business School',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 45000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 20,
    ielts: 7.5,
    toefl: 107,
    greRequired: false,
    website: 'https://imperial.ac.uk/business-school',
    established: 2004,
    campusType: 'Urban',
    about: 'Imperial\'s business school; top for MBA and finance.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing & Big Data', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-ucl-ioe',
    name: 'UCL Institute of Education',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Education', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 25000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 30,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://ioe.ac.uk',
    established: 1902,
    campusType: 'Urban',
    about: 'World\'s top education school; part of UCL.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Music & Performing Arts', 'Philosophy', 'Political Science & Government', 'Psychology', 'Sociology', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-cranfield',
    name: 'Cranfield University',
    country: 'UK',
    city: 'Cranfield',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Agriculture', 'Natural Sciences', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 28000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 60,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://cranfield.ac.uk',
    established: 1946,
    campusType: 'Rural',
    about: 'UK\'s specialist postgraduate and research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing & Big Data', 'Computer Engineering', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Project Management', 'Quantitative Analytics', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-open-uni',
    name: 'The Open University',
    country: 'UK',
    city: 'Milton Keynes',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Social Sciences', 'Arts & Humanities', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 5000,
    tuitionMax: 8000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 100,
    ielts: 5,
    toefl: 60,
    greRequired: false,
    website: 'https://open.ac.uk',
    established: 1969,
    campusType: 'Suburban',
    about: 'UK\'s largest distance learning university; millions of graduates.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-brunel-london',
    name: 'Brunel University',
    country: 'UK',
    city: 'Uxbridge',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 6,
    toefl: 85,
    greRequired: false,
    website: 'https://brunel.ac.uk',
    established: 1966,
    campusType: 'Suburban',
    about: 'West London university with strong engineering programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-loughborough2',
    name: 'Loughborough University London',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Architecture', 'Design', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 25000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://london.lboro.ac.uk',
    established: 2015,
    campusType: 'Urban',
    about: 'Loughborough\'s London campus on the Olympic Park.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Architecture', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Fashion Design & Management', 'Graphic Design & Visual Communication', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial Design', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'UX/UI Design', 'Urban & Regional Planning'],
  },
  {
    id: 'uk-kingston2',
    name: 'Kingston Business School',
    country: 'UK',
    city: 'Kingston upon Thames',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://kbs.ac.uk',
    established: 1992,
    campusType: 'Suburban',
    about: 'South London business school with global programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-ibm-business',
    name: 'London Business School',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 90000,
    tuitionMax: 100000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 10,
    ielts: 7.5,
    toefl: 110,
    greRequired: false,
    website: 'https://london.edu',
    established: 1964,
    campusType: 'Urban',
    about: 'World\'s top MBA school; consistently ranked #1-3 globally.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-trent',
    name: 'University of Trento',
    country: 'ITALY',
    city: 'Trento',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Social Sciences', 'Law', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unitn.it',
    established: 1962,
    campusType: 'Urban',
    about: 'Small northern Italian university with strong tech and social sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-pisa',
    name: 'University of Pisa',
    country: 'ITALY',
    city: 'Pisa',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Medicine & Health', 'Law', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 44,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unipi.it',
    established: 1343,
    campusType: 'Urban',
    about: 'Historic Tuscany university where Galileo once taught.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Public Health (MPH)'],
  },
  {
    id: 'it-scuola-normale',
    name: 'Scuola Normale Superiore',
    country: 'ITALY',
    city: 'Pisa',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 0,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 10,
    ielts: 7.5,
    toefl: 110,
    greRequired: false,
    website: 'https://sns.it',
    established: 1810,
    campusType: 'Urban',
    about: 'Italy\'s elite research university; no tuition; highly selective.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Industrial & Systems Engineering', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Sociology'],
  },
  {
    id: 'it-sissa',
    name: 'SISSA Trieste',
    country: 'ITALY',
    city: 'Trieste',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Engineering', 'Computer Science & IT', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 0,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 10,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://sissa.it',
    established: 1978,
    campusType: 'Coastal',
    about: 'Italy\'s international school of advanced studies in Trieste.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Analytics', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Quantitative Analytics', 'Software Engineering'],
  },
  {
    id: 'it-politecnico-torino',
    name: 'Politecnico di Torino',
    country: 'ITALY',
    city: 'Turin',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Design'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 4000,
    tuitionMax: 8000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://polito.it',
    established: 1906,
    campusType: 'Urban',
    about: 'Turin\'s technical university; strong automotive engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Fashion Design & Management', 'Graphic Design & Visual Communication', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Industrial Design', 'Information Technology', 'Interior Design', 'Landscape Architecture', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Physics', 'Software Engineering', 'UX/UI Design', 'Urban & Regional Planning'],
  },
  {
    id: 'es-upm',
    name: 'Universidad Politécnica de Madrid',
    country: 'SPAIN',
    city: 'Madrid',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 5000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 48,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://upm.es',
    established: 1971,
    campusType: 'Urban',
    about: 'Spain\'s largest technical university; top for engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'es-upv',
    name: 'Universitat Politècnica de València',
    country: 'SPAIN',
    city: 'Valencia',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Architecture', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 5000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 46,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://upv.es',
    established: 1968,
    campusType: 'Suburban',
    about: 'Valencia\'s technical university with strong industrial engineering.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Architecture', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Interior Design', 'International Business', 'Landscape Architecture', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Urban & Regional Planning'],
  },
  {
    id: 'es-deusto',
    name: 'University of Deusto',
    country: 'SPAIN',
    city: 'Bilbao',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Engineering', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 52,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://deusto.es',
    established: 1886,
    campusType: 'Urban',
    about: 'Basque Jesuit university; top in Spain for business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'dk-itu',
    name: 'IT University of Copenhagen',
    country: 'DENMARK',
    city: 'Copenhagen',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Business & Management', 'Data Science & AI', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 42,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://itu.dk',
    established: 1999,
    campusType: 'Urban',
    about: 'Denmark\'s IT-specialist university in Copenhagen.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'no-bi',
    name: 'BI Norwegian Business School',
    country: 'NORWAY',
    city: 'Oslo',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Social Sciences', 'Economics'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://bi.no',
    established: 1943,
    campusType: 'Urban',
    about: 'Norway\'s top private business school; Scandinavia\'s largest.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Anthropology', 'Applied Economics', 'Behavioral Economics', 'Business Administration (BBA/BCom)', 'Criminology & Criminal Justice', 'Development Economics', 'Econometrics', 'Economics', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Risk Management & Insurance', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fi-turku',
    name: 'University of Turku',
    country: 'FINLAND',
    city: 'Turku',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 92,
    greRequired: false,
    website: 'https://utu.fi',
    established: 1920,
    campusType: 'Coastal',
    about: 'Finland\'s third-oldest university in the coastal city of Turku.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'fi-jyu',
    name: 'University of Jyväskylä',
    country: 'FINLAND',
    city: 'Jyväskylä',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Business & Management', 'Education', 'Sports Science'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 0,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://jyu.fi',
    established: 1934,
    campusType: 'Suburban',
    about: 'Central Finland university known for education and sports science.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Exercise Physiology & Rehabilitation', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Sports Management', 'Sports Science & Kinesiology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'be-univ-liege',
    name: 'University of Liège',
    country: 'BELGIUM',
    city: 'Liège',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Medicine & Health', 'Business & Management', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uliege.be',
    established: 1817,
    campusType: 'Urban',
    about: 'Wallonia\'s main research university in Liège.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'at-salzburg',
    name: 'University of Salzburg',
    country: 'AUSTRIA',
    city: 'Salzburg',
    qsRank: null,
    usNewsRank: null,
    programs: ['Law', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 45,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-salzburg.at',
    established: 1622,
    campusType: 'Urban',
    about: 'Mozart\'s birthplace university; strong in humanities and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'at-innsbruck',
    name: 'University of Innsbruck',
    country: 'AUSTRIA',
    city: 'Innsbruck',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Law', 'Business & Management', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'February'],
    acceptanceRate: 44,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uibk.ac.at',
    established: 1669,
    campusType: 'Suburban',
    about: 'Alpine Austrian university known for skiing and sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-pepperdine2',
    name: 'Seaver College Pepperdine',
    country: 'USA',
    city: 'Malibu, CA',
    qsRank: null,
    usNewsRank: 42,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://pepperdine.edu',
    established: 1937,
    campusType: 'Coastal',
    about: 'Pepperdine\'s liberal arts college on the Malibu coast.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-biola',
    name: 'Biola University',
    country: 'USA',
    city: 'La Mirada, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 39000,
    tuitionMax: 44000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://biola.edu',
    established: 1908,
    campusType: 'Suburban',
    about: 'Christian university near Los Angeles with strong programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-azusa',
    name: 'Azusa Pacific University',
    country: 'USA',
    city: 'Azusa, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Medicine & Health', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 43000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 75,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://apu.edu',
    established: 1899,
    campusType: 'Suburban',
    about: 'LA-area Christian university with strong nursing and education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-westmont',
    name: 'Westmont College',
    country: 'USA',
    city: 'Santa Barbara, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Business & Management', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 52000,
    tuitionMax: 57000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://westmont.edu',
    established: 1937,
    campusType: 'Coastal',
    about: 'California Christian liberal arts college near Santa Barbara.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-point-loma',
    name: 'Point Loma Nazarene University',
    country: 'USA',
    city: 'San Diego, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 37000,
    tuitionMax: 42000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 77,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://pointloma.edu',
    established: 1902,
    campusType: 'Coastal',
    about: 'Christian university on the San Diego coastline.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-pacific-union',
    name: 'Pacific Union College',
    country: 'USA',
    city: 'Angwin, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 32000,
    tuitionMax: 37000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://puc.edu',
    established: 1882,
    campusType: 'Rural',
    about: 'California Adventist liberal arts college in Napa Valley.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-loma-linda',
    name: 'Loma Linda University',
    country: 'USA',
    city: 'Loma Linda, CA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Business & Management', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 36000,
    tuitionMax: 42000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://llu.edu',
    established: 1905,
    campusType: 'Suburban',
    about: 'Seventh-day Adventist health sciences university in SoCal.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-regis',
    name: 'Regis University',
    country: 'USA',
    city: 'Denver, CO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Medicine & Health', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 37000,
    tuitionMax: 42000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://regis.edu',
    established: 1877,
    campusType: 'Suburban',
    about: 'Jesuit university in Denver with strong graduate programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-du',
    name: 'University of Denver',
    country: 'USA',
    city: 'Denver, CO',
    qsRank: null,
    usNewsRank: 87,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 55000,
    tuitionMax: 61000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 64,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://du.edu',
    established: 1864,
    campusType: 'Suburban',
    about: 'Private Denver university with top hotel management school.',
    rankings: { ugCS: 193, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-colorado-college',
    name: 'Colorado College',
    country: 'USA',
    city: 'Colorado Springs, CO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 65000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 13,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://coloradocollege.edu',
    established: 1874,
    campusType: 'Urban',
    about: 'Liberal arts college with unique Block Plan curriculum.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-western-colorado',
    name: 'Western Colorado University',
    country: 'USA',
    city: 'Gunnison, CO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Arts & Humanities', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 90,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://western.edu',
    established: 1901,
    campusType: 'Rural',
    about: 'Small mountain university known for outdoor recreation programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-fort-lewis',
    name: 'Fort Lewis College',
    country: 'USA',
    city: 'Durango, CO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Arts & Humanities', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://fortlewis.edu',
    established: 1911,
    campusType: 'Suburban',
    about: 'Colorado mountain college with tuition waivers for Native students.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-adams-state',
    name: 'Adams State University',
    country: 'USA',
    city: 'Alamosa, CO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Natural Sciences', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 87,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://adams.edu',
    established: 1921,
    campusType: 'Suburban',
    about: 'Southern Colorado high-altitude university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-mesa-state',
    name: 'Colorado Mesa University',
    country: 'USA',
    city: 'Grand Junction, CO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Natural Sciences', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://coloradomesa.edu',
    established: 1925,
    campusType: 'Suburban',
    about: 'Western Colorado university near Grand Junction.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-csupueblo',
    name: 'Colorado State Pueblo',
    country: 'USA',
    city: 'Pueblo, CO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Natural Sciences', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://csupueblo.edu',
    established: 1933,
    campusType: 'Suburban',
    about: 'Southern Colorado state university with applied focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-unlv2',
    name: 'UNLV Las Vegas Campus',
    country: 'USA',
    city: 'Las Vegas, NV',
    qsRank: null,
    usNewsRank: null,
    programs: ['Hospitality & Tourism', 'Business & Management', 'Engineering', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 84,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://unlv.edu',
    established: 1957,
    campusType: 'Urban',
    about: 'Nevada\'s urban research university in the Entertainment Capital.',
    rankings: { ugCS: 154, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Event & Convention Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Food & Beverage Management', 'History', 'Hospitality & Hotel Management', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'usa-nevada-state',
    name: 'Nevada State University',
    country: 'USA',
    city: 'Henderson, NV',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Social Sciences', 'Computer Science & IT', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 15000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 100,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://nevadastate.edu',
    established: 2002,
    campusType: 'Suburban',
    about: 'New Henderson Nevada university focused on access and equity.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-great-basin',
    name: 'Great Basin College',
    country: 'USA',
    city: 'Elko, NV',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Computer Science & IT', 'Education', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 11000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 100,
    ielts: 5,
    toefl: 60,
    greRequired: false,
    website: 'https://gbcnv.edu',
    established: 1967,
    campusType: 'Rural',
    about: 'Rural Nevada college serving a large geographic area.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-western-nevada',
    name: 'Western Nevada College',
    country: 'USA',
    city: 'Carson City, NV',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Arts & Humanities', 'Computer Science & IT', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 11000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 100,
    ielts: 5,
    toefl: 60,
    greRequired: false,
    website: 'https://wnc.edu',
    established: 1971,
    campusType: 'Suburban',
    about: 'Carson City community college with transfer programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-truckee',
    name: 'Truckee Meadows Community College',
    country: 'USA',
    city: 'Reno, NV',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 7000,
    tuitionMax: 10000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 100,
    ielts: 5,
    toefl: 60,
    greRequired: false,
    website: 'https://tmcc.edu',
    established: 1971,
    campusType: 'Urban',
    about: 'Reno area community college near UNR campus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-csu',
    name: 'Charleston Southern University',
    country: 'USA',
    city: 'Charleston, SC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Natural Sciences', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 28000,
    tuitionMax: 33000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://csuniv.edu',
    established: 1964,
    campusType: 'Suburban',
    about: 'Charleston Christian university with strong nursing programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-benedict',
    name: 'Benedict College',
    country: 'USA',
    city: 'Columbia, SC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 21000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://benedict.edu',
    established: 1870,
    campusType: 'Urban',
    about: 'South Carolina HBCU in Columbia; strong community roots.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-claflin',
    name: 'Claflin University',
    country: 'USA',
    city: 'Orangeburg, SC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Education', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 46,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://claflin.edu',
    established: 1869,
    campusType: 'Suburban',
    about: 'South Carolina HBCU; oldest in the state.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-south-carol-state',
    name: 'South Carolina State University',
    country: 'USA',
    city: 'Orangeburg, SC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Education', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://scsu.edu',
    established: 1896,
    campusType: 'Suburban',
    about: 'South Carolina\'s historically Black land-grant university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-winthrop',
    name: 'Winthrop University',
    country: 'USA',
    city: 'Rock Hill, SC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Education', 'Social Sciences', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 25000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://winthrop.edu',
    established: 1886,
    campusType: 'Suburban',
    about: 'South Carolina university known for fine arts and education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-citadel',
    name: 'The Citadel',
    country: 'USA',
    city: 'Charleston, SC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Education', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 76,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://citadel.edu',
    established: 1842,
    campusType: 'Urban',
    about: 'South Carolina military college with strong leadership programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-coastal-georgia',
    name: 'College of Coastal Georgia',
    country: 'USA',
    city: 'Brunswick, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Arts & Humanities', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 13000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://ccga.edu',
    established: 1961,
    campusType: 'Coastal',
    about: 'Georgia coastal college with marine science programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-armstrong',
    name: 'Armstrong State (GS)',
    country: 'USA',
    city: 'Savannah, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Medicine & Health', 'Arts & Humanities', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://georgiasouthern.edu/armstrong',
    established: 1935,
    campusType: 'Coastal',
    about: 'Georgia Southern\'s Armstrong campus in Savannah.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Health (MPH)', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-savannah-state',
    name: 'Savannah State University',
    country: 'USA',
    city: 'Savannah, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 65,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://savannahstate.edu',
    established: 1890,
    campusType: 'Urban',
    about: 'Georgia HBCU in historic coastal Savannah.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-fort-valley',
    name: 'Fort Valley State University',
    country: 'USA',
    city: 'Fort Valley, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Agriculture', 'Business & Management', 'Education', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 68,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://fvsu.edu',
    established: 1895,
    campusType: 'Rural',
    about: 'Georgia\'s 1890 land-grant HBCU; strong in agriculture.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Operations Management', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-albany-state',
    name: 'Albany State University',
    country: 'USA',
    city: 'Albany, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Medicine & Health', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 63,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://asurams.edu',
    established: 1903,
    campusType: 'Suburban',
    about: 'Southwest Georgia HBCU with strong nursing and business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Curriculum & Instruction', 'Dentistry', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-clark-atlanta',
    name: 'Clark Atlanta University',
    country: 'USA',
    city: 'Atlanta, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Social Sciences', 'Natural Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 28000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 50,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://cau.edu',
    established: 1865,
    campusType: 'Urban',
    about: 'Atlanta\'s large HBCU; part of the Atlanta University Center.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-morehouse-med',
    name: 'Morehouse School of Medicine',
    country: 'USA',
    city: 'Atlanta, GA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Public Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 40000,
    tuitionMax: 50000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 5,
    ielts: 7,
    toefl: 90,
    greRequired: false,
    website: 'https://msm.edu',
    established: 1975,
    campusType: 'Urban',
    about: 'HBCUs premier medical school in Atlanta.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Epidemiology', 'Global Health', 'Health Policy & Management', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Public Health (MPH)'],
  },
  {
    id: 'usa-bethune-cookman',
    name: 'Bethune-Cookman University',
    country: 'USA',
    city: 'Daytona Beach, FL',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Education', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 22000,
    tuitionMax: 26000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://cookman.edu',
    established: 1904,
    campusType: 'Urban',
    about: 'Florida HBCU on the coast; founded by Mary McLeod Bethune.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-florida-memorial',
    name: 'Florida Memorial University',
    country: 'USA',
    city: 'Miami Gardens, FL',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Natural Sciences', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 63,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://fmuniv.edu',
    established: 1879,
    campusType: 'Suburban',
    about: 'South Florida\'s only HBCU in Miami area.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-edward-waters',
    name: 'Edward Waters University',
    country: 'USA',
    city: 'Jacksonville, FL',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Education', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 66,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://ewc.edu',
    established: 1866,
    campusType: 'Urban',
    about: 'Florida\'s oldest HBCU in Jacksonville.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-lincoln-mo',
    name: 'Lincoln University Missouri',
    country: 'USA',
    city: 'Jefferson City, MO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Agriculture', 'Education', 'Arts & Humanities', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 75,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://lincolnu.edu',
    established: 1866,
    campusType: 'Suburban',
    about: 'Missouri\'s 1890 land-grant HBCU in the state capital.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-harris-stowe',
    name: 'Harris-Stowe State University',
    country: 'USA',
    city: 'St. Louis, MO',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Arts & Humanities', 'Social Sciences', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 10000,
    tuitionMax: 13000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://hssu.edu',
    established: 1857,
    campusType: 'Urban',
    about: 'St. Louis urban HBCU with focus on urban education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-southern-univ',
    name: 'Southern University',
    country: 'USA',
    city: 'Baton Rouge, LA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Agriculture', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 15000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 45,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://subr.edu',
    established: 1880,
    campusType: 'Suburban',
    about: 'Louisiana\'s HBCU land-grant system flagship.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Agribusiness Management', 'Agricultural Engineering', 'Agriculture & Food Sciences', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'usa-grambling',
    name: 'Grambling State University',
    country: 'USA',
    city: 'Grambling, LA',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Education', 'Natural Sciences', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 56,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://gram.edu',
    established: 1901,
    campusType: 'Rural',
    about: 'Louisiana HBCU known for its football program and arts.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Curriculum & Instruction', 'Earth & Planetary Sciences', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-newman2',
    name: 'Newman University Birmingham',
    country: 'UK',
    city: 'Birmingham',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Social Sciences', 'Arts & Humanities', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 16000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 88,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://newman.ac.uk',
    established: 1968,
    campusType: 'Suburban',
    about: 'Birmingham Catholic university with strong teacher education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'uk-uca',
    name: 'University for the Creative Arts',
    country: 'UK',
    city: 'Canterbury',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Media & Communications', 'Design', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 78,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uca.ac.uk',
    established: 1882,
    campusType: 'Suburban',
    about: 'Kent creative arts university across multiple campuses.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Broadcasting & Media Production', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Fashion Design & Management', 'Film & Media Studies', 'Fine Arts & Studio Art', 'Graphic Design & Visual Communication', 'History', 'Human-Computer Interaction', 'Industrial Design', 'Information Technology', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'Music & Performing Arts', 'Network Engineering', 'Philosophy', 'Public Relations & Advertising', 'Software Engineering', 'UX/UI Design'],
  },
  {
    id: 'uk-south-wales',
    name: 'University of South Wales',
    country: 'UK',
    city: 'Pontypridd',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 17000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 85,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://southwales.ac.uk',
    established: 1992,
    campusType: 'Suburban',
    about: 'Wales\' largest taught-based university with vocational focus.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-ulster',
    name: 'Ulster University',
    country: 'UK',
    city: 'Belfast',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 20000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 80,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://ulster.ac.uk',
    established: 1984,
    campusType: 'Urban',
    about: 'Northern Ireland\'s multi-campus modern university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-bournemouth',
    name: 'Bournemouth University',
    country: 'UK',
    city: 'Bournemouth',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Computer Science & IT', 'Media & Communications', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 16000,
    tuitionMax: 19000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://bournemouth.ac.uk',
    established: 1992,
    campusType: 'Coastal',
    about: 'Dorset university known for media, film, and tourism.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Journalism & Mass Communication', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Public Relations & Advertising', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'uk-london-bs',
    name: 'London Business School',
    country: 'UK',
    city: 'London',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Finance & Accounting', 'Entrepreneurship'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 90000,
    tuitionMax: 100000,
    currency: 'GBP',
    intakes: ['September', 'January'],
    acceptanceRate: 10,
    ielts: 7.5,
    toefl: 110,
    greRequired: false,
    website: 'https://london.edu',
    established: 1964,
    campusType: 'Urban',
    about: 'World\'s top MBA school; consistently ranked #1-3 globally.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Business Administration (BBA/BCom)', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Social Entrepreneurship', 'Startup & Venture Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-osnabrueck',
    name: 'University of Osnabrück',
    country: 'GERMANY',
    city: 'Osnabrück',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Business & Management', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 46,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-osnabrueck.de',
    established: 1974,
    campusType: 'Suburban',
    about: 'Lower Saxony university with strong languages and sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-bielefeld',
    name: 'Bielefeld University',
    country: 'GERMANY',
    city: 'Bielefeld',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Business & Management', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 44,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-bielefeld.de',
    established: 1969,
    campusType: 'Suburban',
    about: 'NRW interdisciplinary research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-jena',
    name: 'Friedrich Schiller University Jena',
    country: 'GERMANY',
    city: 'Jena',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 44,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-jena.de',
    established: 1558,
    campusType: 'Urban',
    about: 'Thuringia university; known for optics and photonics research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'fr-nantes',
    name: 'University of Nantes',
    country: 'FRANCE',
    city: 'Nantes',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Natural Sciences', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 6000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://univ-nantes.fr',
    established: 1962,
    campusType: 'Urban',
    about: 'Loire Valley university with strong medicine programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Pharmacy', 'Physics', 'Political Science & Government', 'Psychology', 'Public Health (MPH)', 'Sociology'],
  },
  {
    id: 'fr-lorraine',
    name: 'University of Lorraine',
    country: 'FRANCE',
    city: 'Nancy',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Medicine & Health', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 3000,
    tuitionMax: 6000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://univ-lorraine.fr',
    established: 2012,
    campusType: 'Urban',
    about: 'Cross-border French university near Belgium and Germany.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'nl-breda',
    name: 'Breda University of Applied Sciences',
    country: 'NETHERLANDS',
    city: 'Breda',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Hospitality & Tourism', 'Media & Communications', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 74,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://buas.nl',
    established: 1994,
    campusType: 'Urban',
    about: 'Top Dutch hospitality and media university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Artificial Intelligence & Machine Learning', 'Broadcasting & Media Production', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Digital Media & Content', 'Entrepreneurship & Innovation', 'Event & Convention Management', 'Food & Beverage Management', 'Hospitality & Hotel Management', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Journalism & Mass Communication', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Project Management', 'Public Relations & Advertising', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Tourism Management'],
  },
  {
    id: 'se-lnu',
    name: 'Linnaeus University',
    country: 'SWEDEN',
    city: 'Växjö',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Natural Sciences', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://lnu.se',
    established: 2010,
    campusType: 'Urban',
    about: 'South Swedish university; formed from two merged universities.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-bth',
    name: 'Blekinge Institute of Technology',
    country: 'SWEDEN',
    city: 'Karlskrona',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Data Science & AI', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 58,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://bth.se',
    established: 1989,
    campusType: 'Coastal',
    about: 'Sweden\'s tech specialist; top for software engineering research.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'se-oru',
    name: 'Örebro University',
    country: 'SWEDEN',
    city: 'Örebro',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Natural Sciences', 'Medicine & Health', 'Computer Science & IT'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://oru.se',
    established: 1977,
    campusType: 'Urban',
    about: 'Central Swedish research university with strong nursing.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Network Engineering', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ch-unine',
    name: 'University of Neuchâtel',
    country: 'SWITZERLAND',
    city: 'Neuchâtel',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Law', 'Social Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 2500,
    currency: 'CHF',
    intakes: ['September', 'January'],
    acceptanceRate: 53,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://unine.ch',
    established: 1909,
    campusType: 'Urban',
    about: 'Lakeside Swiss university strong in microbiology and law.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Microbiology', 'Operations Management', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-verona',
    name: 'University of Verona',
    country: 'ITALY',
    city: 'Verona',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Law', 'Business & Management', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 44,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://univr.it',
    established: 1982,
    campusType: 'Urban',
    about: 'Northern Italian university in the city of Romeo and Juliet.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'it-bari',
    name: 'University of Bari Aldo Moro',
    country: 'ITALY',
    city: 'Bari',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Law', 'Natural Sciences', 'Business & Management', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 46,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uniba.it',
    established: 1925,
    campusType: 'Urban',
    about: 'Apulia\'s largest university on the Adriatic coast.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'es-granada',
    name: 'University of Granada',
    country: 'SPAIN',
    city: 'Granada',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Arts & Humanities', 'Medicine & Health', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://ugr.es',
    established: 1531,
    campusType: 'Urban',
    about: 'Andalusia\'s historic university in the Alhambra city.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Sciences', 'Biotechnology', 'Chemistry', 'Corporate & Commercial Law', 'Dentistry', 'Earth & Planetary Sciences', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Music & Performing Arts', 'Nursing', 'Pharmacy', 'Philosophy', 'Physics', 'Public Health (MPH)'],
  },
  {
    id: 'es-zaragoza',
    name: 'University of Zaragoza',
    country: 'SPAIN',
    city: 'Zaragoza',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Natural Sciences', 'Business & Management', 'Medicine & Health'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 2000,
    tuitionMax: 4000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://unizar.es',
    established: 1542,
    campusType: 'Urban',
    about: 'Aragon\'s flagship research university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biomedical Sciences', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Computer Engineering', 'Dentistry', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Microbiology', 'Nursing', 'Operations Management', 'Pharmacy', 'Physics', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'jp-meiji',
    name: 'Meiji University',
    country: 'JAPAN',
    city: 'Tokyo',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Law', 'Arts & Humanities', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 47,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://meiji.ac.jp',
    established: 1881,
    campusType: 'Urban',
    about: 'Tokyo\'s large and diverse private university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Corporate & Commercial Law', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Project Management', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'jp-sophia',
    name: 'Sophia University',
    country: 'JAPAN',
    city: 'Tokyo',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Arts & Humanities', 'Social Sciences', 'Engineering'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 88,
    greRequired: false,
    website: 'https://sophia.ac.jp',
    established: 1913,
    campusType: 'Urban',
    about: 'Tokyo Jesuit university; top for international education.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Computer Engineering', 'Criminology & Criminal Justice', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Industrial & Systems Engineering', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'kr-ewha',
    name: 'Ewha Womans University',
    country: 'SOUTH_KOREA',
    city: 'Seoul',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Medicine & Health', 'Arts & Humanities', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 35,
    ielts: 6,
    toefl: 88,
    greRequired: false,
    website: 'https://ewha.ac.kr',
    established: 1886,
    campusType: 'Urban',
    about: 'World\'s largest female-only university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Art History & Curatorship', 'Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Dentistry', 'Entrepreneurship & Innovation', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Languages & Linguistics', 'Law (LLB/JD)', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Music & Performing Arts', 'Nursing', 'Operations Management', 'Pharmacy', 'Philosophy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-mmu',
    name: 'Multimedia University',
    country: 'MALAYSIA',
    city: 'Cyberjaya',
    qsRank: null,
    usNewsRank: null,
    programs: ['Computer Science & IT', 'Engineering', 'Business & Management', 'Data Science & AI'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 57,
    ielts: 5.5,
    toefl: 79,
    greRequired: false,
    website: 'https://mmu.edu.my',
    established: 1999,
    campusType: 'Suburban',
    about: 'Telekom Malaysia-funded university in Cyberjaya tech hub.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Business Analytics', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Cloud Computing & Big Data', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Quantitative Analytics', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'my-inti',
    name: 'INTI International University',
    country: 'MALAYSIA',
    city: 'Nilai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Engineering', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 72,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://intiuniversity.edu.my',
    established: 2007,
    campusType: 'Suburban',
    about: 'Laurentian Canada-affiliated Malaysian university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'hk-cityu',
    name: 'City University of Hong Kong',
    country: 'HONG_KONG',
    city: 'Hong Kong',
    qsRank: 62,
    usNewsRank: null,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 17000,
    tuitionMax: 23000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 35,
    ielts: 7,
    toefl: 100,
    greRequired: false,
    website: 'https://cityu.edu.hk',
    established: 1984,
    campusType: 'Urban',
    about: 'Dynamic Hong Kong research university; top for business.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-mdis',
    name: 'MDIS Singapore',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Finance & Accounting'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 12000,
    tuitionMax: 16000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mdis.edu.sg',
    established: 1956,
    campusType: 'Urban',
    about: 'Singapore\'s oldest private college with UK partnerships.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Accounting & Auditing', 'Actuarial Science', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Entrepreneurship & Innovation', 'Finance', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'Investment Management', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Project Management', 'Risk Management & Insurance', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'sg-rp',
    name: 'Republic Polytechnic',
    country: 'SINGAPORE',
    city: 'Singapore',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Natural Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 8000,
    tuitionMax: 12000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 62,
    ielts: 5.5,
    toefl: 60,
    greRequired: false,
    website: 'https://rp.edu.sg',
    established: 2002,
    campusType: 'Suburban',
    about: 'Singapore polytechnic focused on problem-based learning.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'ae-abu-dhabi-uni',
    name: 'Abu Dhabi University',
    country: 'UAE',
    city: 'Abu Dhabi',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Business & Management', 'Computer Science & IT', 'Law'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 14000,
    tuitionMax: 18000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 66,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://adu.ac.ae',
    established: 2003,
    campusType: 'Suburban',
    about: 'Multi-campus UAE private university with strong tech programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'au-notre-dame-aus',
    name: 'University of Notre Dame Australia',
    country: 'AUSTRALIA',
    city: 'Perth',
    qsRank: null,
    usNewsRank: null,
    programs: ['Medicine & Health', 'Business & Management', 'Law', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 24000,
    tuitionMax: 30000,
    currency: 'AUD',
    intakes: ['February', 'July'],
    acceptanceRate: 73,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://notredame.edu.au',
    established: 1989,
    campusType: 'Urban',
    about: 'Catholic university in Perth with campuses in Sydney.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Biomedical Sciences', 'Business Administration (BBA/BCom)', 'Corporate & Commercial Law', 'Curriculum & Instruction', 'Dentistry', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'International Business', 'International Law', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Medical Sciences', 'Medicine (MBBS/MD)', 'Nursing', 'Operations Management', 'Pharmacy', 'Project Management', 'Public Health (MPH)', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-royal-roads',
    name: 'Royal Roads University',
    country: 'CANADA',
    city: 'Colwood, BC',
    qsRank: null,
    usNewsRank: null,
    programs: ['Business & Management', 'Computer Science & IT', 'Social Sciences', 'Education'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 20000,
    tuitionMax: 25000,
    currency: 'CAD',
    intakes: ['September', 'January'],
    acceptanceRate: 83,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://royalroads.ca',
    established: 1995,
    campusType: 'Coastal',
    about: 'BC university with strong online graduate programs.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Artificial Intelligence & Machine Learning', 'Business Administration (BBA/BCom)', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Curriculum & Instruction', 'Cybersecurity & Information Security', 'Data Science', 'Education & Teaching', 'Educational Leadership', 'Entrepreneurship & Innovation', 'Human Resource Management', 'Human-Computer Interaction', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'MBA', 'Marketing', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'TESOL & Applied Linguistics'],
  },
  {
    id: 'ca-mount-allison',
    name: 'Mount Allison University',
    country: 'CANADA',
    city: 'Sackville, NB',
    qsRank: null,
    usNewsRank: null,
    programs: ['Arts & Humanities', 'Natural Sciences', 'Business & Management', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 18000,
    tuitionMax: 22000,
    currency: 'CAD',
    intakes: ['September', 'January'],
    acceptanceRate: 79,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://mta.ca',
    established: 1839,
    campusType: 'Rural',
    about: 'Canada\'s best undergraduate university; small liberal arts.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'in-bits-dubai',
    name: 'BITS Pilani Dubai',
    country: 'INDIA',
    city: 'Dubai',
    qsRank: null,
    usNewsRank: null,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 13000,
    tuitionMax: 17000,
    currency: 'USD',
    intakes: ['September', 'January'],
    acceptanceRate: 55,
    ielts: 6,
    toefl: 79,
    greRequired: false,
    website: 'https://bpdc.bitspilani.ac.in',
    established: 2000,
    campusType: 'Urban',
    about: 'Dubai campus of India\'s top private tech university.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'de-potsdam',
    name: 'University of Potsdam',
    country: 'GERMANY',
    city: 'Potsdam',
    qsRank: null,
    usNewsRank: null,
    programs: ['Natural Sciences', 'Social Sciences', 'Arts & Humanities', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 1500,
    tuitionMax: 3000,
    currency: 'EUR',
    intakes: ['September', 'January'],
    acceptanceRate: 45,
    ielts: 7,
    toefl: 88,
    greRequired: false,
    website: 'https://uni-potsdam.de',
    established: 1991,
    campusType: 'Suburban',
    about: 'Brandenburg university near Berlin with strong sciences.',
    rankings: { ugCS: null, ugEngineering: null, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null },
    availablePrograms: ['Anthropology', 'Art History & Curatorship', 'Biochemistry & Molecular Biology', 'Biology', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemistry', 'Criminology & Criminal Justice', 'Earth & Planetary Sciences', 'Entrepreneurship & Innovation', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Microbiology', 'Music & Performing Arts', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-tamu',
    name: 'Texas A&M University',
    country: 'USA',
    city: 'College Station, TX',
    qsRank: 521,
    usNewsRank: 67,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 40000,
    tuitionMax: 46000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 63,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://tamu.edu',
    established: 1876,
    campusType: 'Suburban',
    about: 'Flagship Texas land-grant; one of the largest US universities with world-class engineering and agriculture programs.',
    rankings: { ugCS: 45, ugEngineering: 17, ugBusiness: 24, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: 12, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Agricultural Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Nuclear Engineering', 'Ocean Engineering', 'Operations Management', 'Petroleum Engineering', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics', 'Veterinary Medicine (BVSc/DVM)'],
  },
  {
    id: 'usa-baylor',
    name: 'Baylor University',
    country: 'USA',
    city: 'Waco, TX',
    qsRank: null,
    usNewsRank: 62,
    programs: ['Business & Management', 'Engineering', 'Computer Science & IT', 'Law', 'Social Sciences'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 54000,
    tuitionMax: 60000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 36,
    ielts: 6.5,
    toefl: 80,
    greRequired: false,
    website: 'https://baylor.edu',
    established: 1845,
    campusType: 'Suburban',
    about: 'Baptist research university in top 65 nationally; strong law, business, and pre-health.',
    rankings: { ugCS: 136, ugEngineering: null, ugBusiness: 64, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Artificial Intelligence & Machine Learning', 'Biomedical Engineering', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Corporate & Commercial Law', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Law', 'International Relations & Diplomacy', 'LLM (Master of Laws)', 'Law (LLB/JD)', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Network Engineering', 'Operations Management', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-uga',
    name: 'University of Georgia',
    country: 'USA',
    city: 'Athens, GA',
    qsRank: null,
    usNewsRank: 71,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 31000,
    tuitionMax: 36000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 45,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://uga.edu',
    established: 1785,
    campusType: 'Suburban',
    about: 'Georgia flagship; oldest US public university; top-ranked journalism, law, and pharmacy.',
    rankings: { ugCS: 78, ugEngineering: null, ugBusiness: 19, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-rpi',
    name: 'Rensselaer Polytechnic Institute',
    country: 'USA',
    city: 'Troy, NY',
    qsRank: null,
    usNewsRank: 97,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 61000,
    tuitionMax: 68000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 43,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://rpi.edu',
    established: 1824,
    campusType: 'Suburban',
    about: 'America\'s oldest private engineering university; elite programs in engineering, computing, and architecture.',
    rankings: { ugCS: 48, ugEngineering: 35, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-arizona',
    name: 'University of Arizona',
    country: 'USA',
    city: 'Tucson, AZ',
    qsRank: null,
    usNewsRank: 110,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management', 'Social Sciences', 'Arts & Humanities'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 38000,
    tuitionMax: 43000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 83,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://arizona.edu',
    established: 1885,
    campusType: 'Urban',
    about: 'Arizona flagship; world-renowned for astronomy, optical sciences, and environmental sciences.',
    rankings: { ugCS: 54, ugEngineering: 50, ugBusiness: 32, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Anthropology', 'Art History & Curatorship', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Criminology & Criminal Justice', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Film & Media Studies', 'Fine Arts & Studio Art', 'History', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'International Relations & Diplomacy', 'Languages & Linguistics', 'Literature & Creative Writing', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Music & Performing Arts', 'Network Engineering', 'Operations Management', 'Philosophy', 'Physics', 'Political Science & Government', 'Project Management', 'Psychology', 'Sociology', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  },
  {
    id: 'usa-colorado-mines',
    name: 'Colorado School of Mines',
    country: 'USA',
    city: 'Golden, CO',
    qsRank: null,
    usNewsRank: 92,
    programs: ['Engineering', 'Natural Sciences', 'Computer Science & IT', 'Environmental Studies'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 43000,
    tuitionMax: 48000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 42,
    ielts: 6.5,
    toefl: 79,
    greRequired: false,
    website: 'https://mines.edu',
    established: 1874,
    campusType: 'Suburban',
    about: 'Elite STEM institution specializing in engineering and earth sciences; top-5 nationally for graduate ROI.',
    rankings: { ugCS: 78, ugEngineering: 42, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Conservation Biology', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Environmental Engineering', 'Environmental Science', 'Geophysics', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Mining Engineering', 'Network Engineering', 'Nuclear Science & Engineering', 'Petroleum Engineering', 'Physics', 'Renewable Energy & Clean Technology', 'Software Engineering', 'Sustainability & Climate Studies'],
  },
  {
    id: 'usa-stevens',
    name: 'Stevens Institute of Technology',
    country: 'USA',
    city: 'Hoboken, NJ',
    qsRank: null,
    usNewsRank: 87,
    programs: ['Engineering', 'Computer Science & IT', 'Natural Sciences', 'Business & Management'],
    degreeTypes: ['Undergraduate (UG)', 'Postgraduate (PG)', 'PhD / Research'],
    tuitionMin: 60000,
    tuitionMax: 66000,
    currency: 'USD',
    intakes: ['August', 'January'],
    acceptanceRate: 40,
    ielts: 6.5,
    toefl: 90,
    greRequired: false,
    website: 'https://stevens.edu',
    established: 1870,
    campusType: 'Urban',
    about: 'Hoboken engineering powerhouse with Manhattan views; top-ranked for salary outcomes and tech innovation.',
    rankings: { ugCS: 78, ugEngineering: 77, ugBusiness: null, ugLaw: null, ugMedicine: null, ugEducation: null,  gradCS: null, gradEngineering: null, gradBusiness: null, gradLaw: null, gradMedicine: null, gradEducation: null, qsCS: null, qsEngineering: null, qsBusiness: null, qsNaturalSci: null, qsSocialSci: null, qsArtsHum: null },
    availablePrograms: ['Aerospace Engineering', 'Artificial Intelligence & Machine Learning', 'Biochemistry & Molecular Biology', 'Biology', 'Biomedical Engineering', 'Biotechnology', 'Business Administration (BBA/BCom)', 'Chemical Engineering', 'Chemistry', 'Civil Engineering', 'Cloud Computing', 'Computer Engineering', 'Computer Science', 'Cybersecurity & Information Security', 'Data Science', 'Earth & Planetary Sciences', 'Electrical Engineering', 'Entrepreneurship & Innovation', 'Environmental Engineering', 'Environmental Science', 'Financial Engineering', 'Human Resource Management', 'Human-Computer Interaction', 'Industrial & Systems Engineering', 'Information Technology', 'International Business', 'MBA', 'Marketing', 'Materials Science & Engineering', 'Mechanical Engineering', 'Microbiology', 'Naval Architecture & Marine Engineering', 'Network Engineering', 'Operations Management', 'Physics', 'Project Management', 'Science Communication', 'Software Engineering', 'Strategy & Consulting', 'Supply Chain & Logistics'],
  }
];

export const AVAILABLE_PROGRAMS = [
  'Accounting & Auditing',
  'Accounting & Finance',
  'Actuarial Mathematics',
  'Actuarial Science',
  'Advertising & Public Relations',
  'Aeronautics & Astronautics',
  'Aerospace Engineering',
  'Aerospace Management',
  'Agribusiness Management',
  'Agricultural & Food Engineering',
  'Agricultural Engineering',
  'Agricultural Sciences',
  'Agriculture & Food Sciences',
  'Agriculture & Life Sciences',
  'Airport & Airline Operations',
  'Anglo-Saxon Norse & Celtic',
  'Animal Sciences',
  'Anthropology',
  'Applied Economics',
  'Applied Mathematics',
  'Arabic & Islamic Studies',
  'Archaeology',
  'Architectural Engineering',
  'Architecture',
  'Art & Design',
  'Art History & Curatorship',
  'Art, Design & Media',
  'Artificial Intelligence & Machine Learning',
  'Asia-Pacific Studies',
  'Astrophysics',
  'Astrophysics & Cosmology',
  'Atmospheric Sciences',
  'Aviation Management',
  'Aviation Technology',
  'Bartlett School',
  'Behavioral Economics',
  'Biochemistry',
  'Biochemistry & Molecular Biology',
  'Biology',
  'Biomedical Engineering',
  'Biomedical Sciences',
  'Biotechnology',
  'Brain Sciences',
  'Brewing & Food Technology',
  'Broadcast Journalism',
  'Broadcasting & Media Production',
  'Business Administration (BBA/BCom)',
  'Business Analytics',
  'Business Commerce',
  'Celtic & Scottish Studies',
  'Chemical Engineering',
  'Chemistry',
  'Cinema & Media Studies',
  'City & Regional Planning',
  'Civil Engineering',
  'Classics',
  'Clinical Pharmacy',
  'Clinical Psychology',
  'Cloud Computing',
  'Cloud Computing & Big Data',
  'Coastal & Ocean Management',
  'Cognitive Science',
  'Commerce',
  'Communication Studies',
  'Communication Systems',
  'Community Health Nursing',
  'Comparative Human Development',
  'Composition & Theory',
  'Computational & Applied Mathematics',
  'Computational & Data Sciences',
  'Computational & Neural Systems',
  'Computational Science',
  'Computer Engineering',
  'Computer Science',
  'Conservation Biology',
  'Corporate & Commercial Law',
  'Counselling Psychology',
  'Criminology & Criminal Justice',
  'Culinary Arts & Gastronomy',
  'Curriculum & Instruction',
  'Cybersecurity & Information Security',
  'Data Science',
  'Dental Medicine',
  'Dentistry',
  'Design',
  'Design Engineering',
  'Development Economics',
  'Development Studies',
  'Digital Journalism',
  'Digital Media & Content',
  'Digital Transformation',
  'Diplomatic Studies',
  'Divinity',
  'Divinity & Theology',
  'Drama & Theatre Arts',
  'Dyson School of Design Engineering',
  'Earth & Environmental Engineering',
  'Earth & Planetary Sciences',
  'Earth Sciences',
  'Earth Systems',
  'Econometrics',
  'Economics',
  'Education & Teaching',
  'Educational Leadership',
  'Electrical Engineering',
  'Energy & Resources',
  'Energy Engineering',
  'Engineering Design',
  'Entertainment Technology',
  'Entrepreneurship & Innovation',
  'Environmental Engineering',
  'Environmental Horticulture',
  'Environmental Management',
  'Environmental Science',
  'Epidemiology',
  'European Studies',
  'Event & Convention Management',
  'Exercise Physiology & Rehabilitation',
  'Export & Import Management',
  'Fashion Design & Management',
  'Film & Media Studies',
  'Film & TV Production',
  'Film, Television & Digital Media',
  'Finance',
  'Financial Engineering',
  'Fine Arts',
  'Fine Arts & Studio Art',
  'Fire Protection Engineering',
  'Fisheries & Aquatic Sciences',
  'Food & Beverage Management',
  'Food & Nutritional Sciences',
  'Food Science & Technology',
  'Foreign Policy & Security Studies',
  'Foreign Service & Diplomacy',
  'Forestry',
  'Forestry & Environmental Studies',
  'Forestry & Forest Management',
  'Genetic Counselling',
  'Geobiology',
  'Geodesy & Geoinformation',
  'Geography',
  'Geology & Geophysics',
  'Geomatics',
  'Geophysics',
  'Geosciences',
  'Global Affairs',
  'Global Health',
  'Government & Public Policy',
  'Graphic Design & Visual Communication',
  'Health Informatics',
  'Health Policy & Management',
  'History',
  'Hospitality & Hotel Management',
  'Hotel & Restaurant Management',
  'Hotel Administration & Hospitality Management',
  'Human Resource Management',
  'Human-Computer Interaction',
  'IT Management & Strategy',
  'Industrial & Systems Engineering',
  'Industrial Design',
  'Informatics',
  'Information Science',
  'Information Systems Management',
  'Information Technology',
  'Innovation Management',
  'Interdisciplinary Studies',
  'Interior Design',
  'International Business',
  'International Law',
  'International Relations & Diplomacy',
  'International Studies',
  'International Trade & Commerce',
  'Investment Management',
  'Joint Science',
  'Journalism',
  'Journalism & Mass Communication',
  'Kinesiology & Exercise Science',
  'LLM (Master of Laws)',
  'Land Economy',
  'Landscape Architecture',
  'Language Technologies',
  'Languages & Linguistics',
  'Law (LLB/JD)',
  'Liberal Arts',
  'Library & Information Science',
  'Life Sciences Engineering',
  'Linguistics',
  'Literature & Creative Writing',
  'MBA',
  'Management Science & Engineering',
  'Marine Biology',
  'Marine Engineering',
  'Marine Sciences',
  'Maritime Studies',
  'Marketing',
  'Materials Engineering',
  'Materials Science',
  'Materials Science & Engineering',
  'Mathematical & Computational Biology',
  'Mathematical Sciences',
  'Mathematics',
  'Mechanical Engineering',
  'Media Studies',
  'Medical Sciences',
  'Medicine (MBBS/MD)',
  'Microbiology',
  'Microengineering',
  'Mining Engineering',
  'Music',
  'Music & Performing Arts',
  'Music Business',
  'Music Performance',
  'Music Technology & Production',
  'Musical Arts',
  'Natural Resources Management',
  'Natural Sciences',
  'Naval Architecture',
  'Naval Architecture & Marine Engineering',
  'Naval Architecture & Ocean Engineering',
  'Network Engineering',
  'Neuroscience',
  'Nuclear Engineering',
  'Nuclear Engineering & Radiological Sciences',
  'Nuclear Plasma & Radiological Engineering',
  'Nuclear Science & Engineering',
  'Nurse Practitioner',
  'Nursing',
  'Nursing (BSN/MSN)',
  'Nutrition & Dietetics',
  'Occupational Therapy',
  'Ocean Engineering',
  'Oceanography',
  'Operations Management',
  'Operations Research',
  'Optical Engineering',
  'Optometry',
  'Organizational Behavior',
  'Organizational Psychology',
  'Oriental Studies',
  'PPE (Philosophy, Politics & Economics)',
  'Peabody Education',
  'Petroleum Engineering',
  'Pharmaceutical Sciences',
  'Pharmacy',
  'Pharmacy (PharmD/BPharm)',
  'Philosophy',
  'Physics',
  'Policy & Management',
  'Policy Studies',
  'Political Science & Government',
  'Polymer Engineering',
  'Polymer Science',
  'Port & Shipping Management',
  'Project Management',
  'Psychology',
  'Public & International Affairs',
  'Public Health (MPH)',
  'Public Policy',
  'Public Relations & Advertising',
  'Public Systems Management',
  'Quality Management & Six Sigma',
  'Quantitative Analytics',
  'Real Estate',
  'Regional Studies',
  'Religious Studies',
  'Renewable Energy & Clean Technology',
  'Restaurant & Food Management',
  'Risk Management & Insurance',
  'Robotics & Autonomous Systems',
  'Robotics Engineering',
  'Rollins Public Health',
  'Sacred Music',
  'Science Communication',
  'Security Studies',
  'Social Entrepreneurship',
  'Social Policy',
  'Social Welfare',
  'Social Work',
  'Sociology',
  'Software Engineering',
  'Space Science & Engineering',
  'Sports Management',
  'Sports Science & Health',
  'Sports Science & Kinesiology',
  'Startup & Venture Management',
  'Statistics & Data Analysis',
  'Strategy & Consulting',
  'Supply Chain & Logistics',
  'Sustainability & Climate Studies',
  'Symbolic Systems',
  'TESOL & Applied Linguistics',
  'Talent Management',
  'Technology Management',
  'Theatre & Performance Studies',
  'Theology',
  'Theology & Religious Studies',
  'Tourism Management',
  'Trade Policy & Economics',
  'Transportation & Logistics',
  'UX/UI Design',
  'Urban & Regional Planning',
  'Urban Planning',
  'Urban Studies & Planning',
  'Veterinary Medicine (BVSc/DVM)',
  'Veterinary Public Health',
  'Veterinary Science',
  'Viticulture & Enology',
];